var Gr = Object.defineProperty;
var vr = (a, e, t) => e in a ? Gr(a, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : a[e] = t;
var $ = (a, e, t) => (vr(a, typeof e != "symbol" ? e + "" : e, t), t);
import { reactive as Ur } from "vue";
function Ht(a, e) {
  return function() {
    return a.apply(e, arguments);
  };
}
const { toString: gr } = Object.prototype, { getPrototypeOf: Vt } = Object, Ne = /* @__PURE__ */ ((a) => (e) => {
  const t = gr.call(e);
  return a[t] || (a[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), W = (a) => (a = a.toLowerCase(), (e) => Ne(e) === a), _e = (a) => (e) => typeof e === a, { isArray: se } = Array, Te = _e("undefined");
function xr(a) {
  return a !== null && !Te(a) && a.constructor !== null && !Te(a.constructor) && k(a.constructor.isBuffer) && a.constructor.isBuffer(a);
}
const Qt = W("ArrayBuffer");
function Er(a) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(a) : e = a && a.buffer && Qt(a.buffer), e;
}
const Ir = _e("string"), k = _e("function"), Wt = _e("number"), Me = (a) => a !== null && typeof a == "object", Fr = (a) => a === !0 || a === !1, Fe = (a) => {
  if (Ne(a) !== "object")
    return !1;
  const e = Vt(a);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in a) && !(Symbol.iterator in a);
}, Lr = W("Date"), Dr = W("File"), Br = W("Blob"), jr = W("FileList"), kr = (a) => Me(a) && k(a.pipe), Hr = (a) => {
  let e;
  return a && (typeof FormData == "function" && a instanceof FormData || k(a.append) && ((e = Ne(a)) === "formdata" || // detect form-data instance
  e === "object" && k(a.toString) && a.toString() === "[object FormData]"));
}, Qr = W("URLSearchParams"), Wr = (a) => a.trim ? a.trim() : a.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ge(a, e, { allOwnKeys: t = !1 } = {}) {
  if (a === null || typeof a > "u")
    return;
  let o, r;
  if (typeof a != "object" && (a = [a]), se(a))
    for (o = 0, r = a.length; o < r; o++)
      e.call(null, a[o], o, a);
  else {
    const n = t ? Object.getOwnPropertyNames(a) : Object.keys(a), l = n.length;
    let s;
    for (o = 0; o < l; o++)
      s = n[o], e.call(null, a[s], s, a);
  }
}
function $t(a, e) {
  e = e.toLowerCase();
  const t = Object.keys(a);
  let o = t.length, r;
  for (; o-- > 0; )
    if (r = t[o], e === r.toLowerCase())
      return r;
  return null;
}
const Nt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, _t = (a) => !Te(a) && a !== Nt;
function tt() {
  const { caseless: a } = _t(this) && this || {}, e = {}, t = (o, r) => {
    const n = a && $t(e, r) || r;
    Fe(e[n]) && Fe(o) ? e[n] = tt(e[n], o) : Fe(o) ? e[n] = tt({}, o) : se(o) ? e[n] = o.slice() : e[n] = o;
  };
  for (let o = 0, r = arguments.length; o < r; o++)
    arguments[o] && ge(arguments[o], t);
  return e;
}
const $r = (a, e, t, { allOwnKeys: o } = {}) => (ge(e, (r, n) => {
  t && k(r) ? a[n] = Ht(r, t) : a[n] = r;
}, { allOwnKeys: o }), a), Nr = (a) => (a.charCodeAt(0) === 65279 && (a = a.slice(1)), a), _r = (a, e, t, o) => {
  a.prototype = Object.create(e.prototype, o), a.prototype.constructor = a, Object.defineProperty(a, "super", {
    value: e.prototype
  }), t && Object.assign(a.prototype, t);
}, Mr = (a, e, t, o) => {
  let r, n, l;
  const s = {};
  if (e = e || {}, a == null)
    return e;
  do {
    for (r = Object.getOwnPropertyNames(a), n = r.length; n-- > 0; )
      l = r[n], (!o || o(l, a, e)) && !s[l] && (e[l] = a[l], s[l] = !0);
    a = t !== !1 && Vt(a);
  } while (a && (!t || t(a, e)) && a !== Object.prototype);
  return e;
}, zr = (a, e, t) => {
  a = String(a), (t === void 0 || t > a.length) && (t = a.length), t -= e.length;
  const o = a.indexOf(e, t);
  return o !== -1 && o === t;
}, Kr = (a) => {
  if (!a)
    return null;
  if (se(a))
    return a;
  let e = a.length;
  if (!Wt(e))
    return null;
  const t = new Array(e);
  for (; e-- > 0; )
    t[e] = a[e];
  return t;
}, Jr = /* @__PURE__ */ ((a) => (e) => a && e instanceof a)(typeof Uint8Array < "u" && Vt(Uint8Array)), Xr = (a, e) => {
  const o = (a && a[Symbol.iterator]).call(a);
  let r;
  for (; (r = o.next()) && !r.done; ) {
    const n = r.value;
    e.call(a, n[0], n[1]);
  }
}, Zr = (a, e) => {
  let t;
  const o = [];
  for (; (t = a.exec(e)) !== null; )
    o.push(t);
  return o;
}, Yr = W("HTMLFormElement"), qr = (a) => a.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, o, r) {
    return o.toUpperCase() + r;
  }
), Gt = (({ hasOwnProperty: a }) => (e, t) => a.call(e, t))(Object.prototype), eo = W("RegExp"), Mt = (a, e) => {
  const t = Object.getOwnPropertyDescriptors(a), o = {};
  ge(t, (r, n) => {
    let l;
    (l = e(r, n, a)) !== !1 && (o[n] = l || r);
  }), Object.defineProperties(a, o);
}, to = (a) => {
  Mt(a, (e, t) => {
    if (k(a) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const o = a[t];
    if (k(o)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, ro = (a, e) => {
  const t = {}, o = (r) => {
    r.forEach((n) => {
      t[n] = !0;
    });
  };
  return se(a) ? o(a) : o(String(a).split(e)), t;
}, oo = () => {
}, ao = (a, e) => (a = +a, Number.isFinite(a) ? a : e), Xe = "abcdefghijklmnopqrstuvwxyz", vt = "0123456789", zt = {
  DIGIT: vt,
  ALPHA: Xe,
  ALPHA_DIGIT: Xe + Xe.toUpperCase() + vt
}, no = (a = 16, e = zt.ALPHA_DIGIT) => {
  let t = "";
  const { length: o } = e;
  for (; a--; )
    t += e[Math.random() * o | 0];
  return t;
};
function lo(a) {
  return !!(a && k(a.append) && a[Symbol.toStringTag] === "FormData" && a[Symbol.iterator]);
}
const so = (a) => {
  const e = new Array(10), t = (o, r) => {
    if (Me(o)) {
      if (e.indexOf(o) >= 0)
        return;
      if (!("toJSON" in o)) {
        e[r] = o;
        const n = se(o) ? [] : {};
        return ge(o, (l, s) => {
          const i = t(l, r + 1);
          !Te(i) && (n[s] = i);
        }), e[r] = void 0, n;
      }
    }
    return o;
  };
  return t(a, 0);
}, io = W("AsyncFunction"), co = (a) => a && (Me(a) || k(a)) && k(a.then) && k(a.catch), b = {
  isArray: se,
  isArrayBuffer: Qt,
  isBuffer: xr,
  isFormData: Hr,
  isArrayBufferView: Er,
  isString: Ir,
  isNumber: Wt,
  isBoolean: Fr,
  isObject: Me,
  isPlainObject: Fe,
  isUndefined: Te,
  isDate: Lr,
  isFile: Dr,
  isBlob: Br,
  isRegExp: eo,
  isFunction: k,
  isStream: kr,
  isURLSearchParams: Qr,
  isTypedArray: Jr,
  isFileList: jr,
  forEach: ge,
  merge: tt,
  extend: $r,
  trim: Wr,
  stripBOM: Nr,
  inherits: _r,
  toFlatObject: Mr,
  kindOf: Ne,
  kindOfTest: W,
  endsWith: zr,
  toArray: Kr,
  forEachEntry: Xr,
  matchAll: Zr,
  isHTMLForm: Yr,
  hasOwnProperty: Gt,
  hasOwnProp: Gt,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Mt,
  freezeMethods: to,
  toObjectSet: ro,
  toCamelCase: qr,
  noop: oo,
  toFiniteNumber: ao,
  findKey: $t,
  global: Nt,
  isContextDefined: _t,
  ALPHABET: zt,
  generateString: no,
  isSpecCompliantForm: lo,
  toJSONObject: so,
  isAsyncFn: io,
  isThenable: co
};
function x(a, e, t, o, r) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = a, this.name = "AxiosError", e && (this.code = e), t && (this.config = t), o && (this.request = o), r && (this.response = r);
}
b.inherits(x, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: b.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Kt = x.prototype, Jt = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((a) => {
  Jt[a] = { value: a };
});
Object.defineProperties(x, Jt);
Object.defineProperty(Kt, "isAxiosError", { value: !0 });
x.from = (a, e, t, o, r, n) => {
  const l = Object.create(Kt);
  return b.toFlatObject(a, l, function(i) {
    return i !== Error.prototype;
  }, (s) => s !== "isAxiosError"), x.call(l, a.message, e, t, o, r), l.cause = a, l.name = a.name, n && Object.assign(l, n), l;
};
const po = null;
function rt(a) {
  return b.isPlainObject(a) || b.isArray(a);
}
function Xt(a) {
  return b.endsWith(a, "[]") ? a.slice(0, -2) : a;
}
function Ut(a, e, t) {
  return a ? a.concat(e).map(function(r, n) {
    return r = Xt(r), !t && n ? "[" + r + "]" : r;
  }).join(t ? "." : "") : e;
}
function ho(a) {
  return b.isArray(a) && !a.some(rt);
}
const uo = b.toFlatObject(b, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function ze(a, e, t) {
  if (!b.isObject(a))
    throw new TypeError("target must be an object");
  e = e || new FormData(), t = b.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(w, T) {
    return !b.isUndefined(T[w]);
  });
  const o = t.metaTokens, r = t.visitor || d, n = t.dots, l = t.indexes, i = (t.Blob || typeof Blob < "u" && Blob) && b.isSpecCompliantForm(e);
  if (!b.isFunction(r))
    throw new TypeError("visitor must be a function");
  function c(A) {
    if (A === null)
      return "";
    if (b.isDate(A))
      return A.toISOString();
    if (!i && b.isBlob(A))
      throw new x("Blob is not supported. Use a Buffer instead.");
    return b.isArrayBuffer(A) || b.isTypedArray(A) ? i && typeof Blob == "function" ? new Blob([A]) : Buffer.from(A) : A;
  }
  function d(A, w, T) {
    let g = A;
    if (A && !T && typeof A == "object") {
      if (b.endsWith(w, "{}"))
        w = o ? w : w.slice(0, -2), A = JSON.stringify(A);
      else if (b.isArray(A) && ho(A) || (b.isFileList(A) || b.endsWith(w, "[]")) && (g = b.toArray(A)))
        return w = Xt(w), g.forEach(function(E, q) {
          !(b.isUndefined(E) || E === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            l === !0 ? Ut([w], q, n) : l === null ? w : w + "[]",
            c(E)
          );
        }), !1;
    }
    return rt(A) ? !0 : (e.append(Ut(T, w, n), c(A)), !1);
  }
  const h = [], f = Object.assign(uo, {
    defaultVisitor: d,
    convertValue: c,
    isVisitable: rt
  });
  function R(A, w) {
    if (!b.isUndefined(A)) {
      if (h.indexOf(A) !== -1)
        throw Error("Circular reference detected in " + w.join("."));
      h.push(A), b.forEach(A, function(g, G) {
        (!(b.isUndefined(g) || g === null) && r.call(
          e,
          g,
          b.isString(G) ? G.trim() : G,
          w,
          f
        )) === !0 && R(g, w ? w.concat(G) : [G]);
      }), h.pop();
    }
  }
  if (!b.isObject(a))
    throw new TypeError("data must be an object");
  return R(a), e;
}
function gt(a) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(a).replace(/[!'()~]|%20|%00/g, function(o) {
    return e[o];
  });
}
function Pt(a, e) {
  this._pairs = [], a && ze(a, this, e);
}
const Zt = Pt.prototype;
Zt.append = function(e, t) {
  this._pairs.push([e, t]);
};
Zt.toString = function(e) {
  const t = e ? function(o) {
    return e.call(this, o, gt);
  } : gt;
  return this._pairs.map(function(r) {
    return t(r[0]) + "=" + t(r[1]);
  }, "").join("&");
};
function Co(a) {
  return encodeURIComponent(a).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Yt(a, e, t) {
  if (!e)
    return a;
  const o = t && t.encode || Co, r = t && t.serialize;
  let n;
  if (r ? n = r(e, t) : n = b.isURLSearchParams(e) ? e.toString() : new Pt(e, t).toString(o), n) {
    const l = a.indexOf("#");
    l !== -1 && (a = a.slice(0, l)), a += (a.indexOf("?") === -1 ? "?" : "&") + n;
  }
  return a;
}
class xt {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, t, o) {
    return this.handlers.push({
      fulfilled: e,
      rejected: t,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    b.forEach(this.handlers, function(o) {
      o !== null && e(o);
    });
  }
}
const qt = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, yo = typeof URLSearchParams < "u" ? URLSearchParams : Pt, mo = typeof FormData < "u" ? FormData : null, Oo = typeof Blob < "u" ? Blob : null, Vo = {
  isBrowser: !0,
  classes: {
    URLSearchParams: yo,
    FormData: mo,
    Blob: Oo
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, er = typeof window < "u" && typeof document < "u", Po = ((a) => er && ["ReactNative", "NativeScript", "NS"].indexOf(a) < 0)(typeof navigator < "u" && navigator.product), fo = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", wo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: er,
  hasStandardBrowserEnv: Po,
  hasStandardBrowserWebWorkerEnv: fo
}, Symbol.toStringTag, { value: "Module" })), Q = {
  ...wo,
  ...Vo
};
function Ao(a, e) {
  return ze(a, new Q.classes.URLSearchParams(), Object.assign({
    visitor: function(t, o, r, n) {
      return Q.isNode && b.isBuffer(t) ? (this.append(o, t.toString("base64")), !1) : n.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function Ro(a) {
  return b.matchAll(/\w+|\[(\w*)]/g, a).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function bo(a) {
  const e = {}, t = Object.keys(a);
  let o;
  const r = t.length;
  let n;
  for (o = 0; o < r; o++)
    n = t[o], e[n] = a[n];
  return e;
}
function tr(a) {
  function e(t, o, r, n) {
    let l = t[n++];
    if (l === "__proto__")
      return !0;
    const s = Number.isFinite(+l), i = n >= t.length;
    return l = !l && b.isArray(r) ? r.length : l, i ? (b.hasOwnProp(r, l) ? r[l] = [r[l], o] : r[l] = o, !s) : ((!r[l] || !b.isObject(r[l])) && (r[l] = []), e(t, o, r[l], n) && b.isArray(r[l]) && (r[l] = bo(r[l])), !s);
  }
  if (b.isFormData(a) && b.isFunction(a.entries)) {
    const t = {};
    return b.forEachEntry(a, (o, r) => {
      e(Ro(o), r, t, 0);
    }), t;
  }
  return null;
}
function So(a, e, t) {
  if (b.isString(a))
    try {
      return (e || JSON.parse)(a), b.trim(a);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (t || JSON.stringify)(a);
}
const ft = {
  transitional: qt,
  adapter: ["xhr", "http"],
  transformRequest: [function(e, t) {
    const o = t.getContentType() || "", r = o.indexOf("application/json") > -1, n = b.isObject(e);
    if (n && b.isHTMLForm(e) && (e = new FormData(e)), b.isFormData(e))
      return r ? JSON.stringify(tr(e)) : e;
    if (b.isArrayBuffer(e) || b.isBuffer(e) || b.isStream(e) || b.isFile(e) || b.isBlob(e))
      return e;
    if (b.isArrayBufferView(e))
      return e.buffer;
    if (b.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let s;
    if (n) {
      if (o.indexOf("application/x-www-form-urlencoded") > -1)
        return Ao(e, this.formSerializer).toString();
      if ((s = b.isFileList(e)) || o.indexOf("multipart/form-data") > -1) {
        const i = this.env && this.env.FormData;
        return ze(
          s ? { "files[]": e } : e,
          i && new i(),
          this.formSerializer
        );
      }
    }
    return n || r ? (t.setContentType("application/json", !1), So(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || ft.transitional, o = t && t.forcedJSONParsing, r = this.responseType === "json";
    if (e && b.isString(e) && (o && !this.responseType || r)) {
      const l = !(t && t.silentJSONParsing) && r;
      try {
        return JSON.parse(e);
      } catch (s) {
        if (l)
          throw s.name === "SyntaxError" ? x.from(s, x.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Q.classes.FormData,
    Blob: Q.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
b.forEach(["delete", "get", "head", "post", "put", "patch"], (a) => {
  ft.headers[a] = {};
});
const wt = ft, To = b.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Go = (a) => {
  const e = {};
  let t, o, r;
  return a && a.split(`
`).forEach(function(l) {
    r = l.indexOf(":"), t = l.substring(0, r).trim().toLowerCase(), o = l.substring(r + 1).trim(), !(!t || e[t] && To[t]) && (t === "set-cookie" ? e[t] ? e[t].push(o) : e[t] = [o] : e[t] = e[t] ? e[t] + ", " + o : o);
  }), e;
}, Et = Symbol("internals");
function ie(a) {
  return a && String(a).trim().toLowerCase();
}
function Le(a) {
  return a === !1 || a == null ? a : b.isArray(a) ? a.map(Le) : String(a);
}
function vo(a) {
  const e = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = t.exec(a); )
    e[o[1]] = o[2];
  return e;
}
const Uo = (a) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(a.trim());
function Ze(a, e, t, o, r) {
  if (b.isFunction(o))
    return o.call(this, e, t);
  if (r && (e = t), !!b.isString(e)) {
    if (b.isString(o))
      return e.indexOf(o) !== -1;
    if (b.isRegExp(o))
      return o.test(e);
  }
}
function go(a) {
  return a.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, o) => t.toUpperCase() + o);
}
function xo(a, e) {
  const t = b.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(a, o + t, {
      value: function(r, n, l) {
        return this[o].call(this, e, r, n, l);
      },
      configurable: !0
    });
  });
}
class Ke {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, o) {
    const r = this;
    function n(s, i, c) {
      const d = ie(i);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const h = b.findKey(r, d);
      (!h || r[h] === void 0 || c === !0 || c === void 0 && r[h] !== !1) && (r[h || i] = Le(s));
    }
    const l = (s, i) => b.forEach(s, (c, d) => n(c, d, i));
    return b.isPlainObject(e) || e instanceof this.constructor ? l(e, t) : b.isString(e) && (e = e.trim()) && !Uo(e) ? l(Go(e), t) : e != null && n(t, e, o), this;
  }
  get(e, t) {
    if (e = ie(e), e) {
      const o = b.findKey(this, e);
      if (o) {
        const r = this[o];
        if (!t)
          return r;
        if (t === !0)
          return vo(r);
        if (b.isFunction(t))
          return t.call(this, r, o);
        if (b.isRegExp(t))
          return t.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = ie(e), e) {
      const o = b.findKey(this, e);
      return !!(o && this[o] !== void 0 && (!t || Ze(this, this[o], o, t)));
    }
    return !1;
  }
  delete(e, t) {
    const o = this;
    let r = !1;
    function n(l) {
      if (l = ie(l), l) {
        const s = b.findKey(o, l);
        s && (!t || Ze(o, o[s], s, t)) && (delete o[s], r = !0);
      }
    }
    return b.isArray(e) ? e.forEach(n) : n(e), r;
  }
  clear(e) {
    const t = Object.keys(this);
    let o = t.length, r = !1;
    for (; o--; ) {
      const n = t[o];
      (!e || Ze(this, this[n], n, e, !0)) && (delete this[n], r = !0);
    }
    return r;
  }
  normalize(e) {
    const t = this, o = {};
    return b.forEach(this, (r, n) => {
      const l = b.findKey(o, n);
      if (l) {
        t[l] = Le(r), delete t[n];
        return;
      }
      const s = e ? go(n) : String(n).trim();
      s !== n && delete t[n], t[s] = Le(r), o[s] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return b.forEach(this, (o, r) => {
      o != null && o !== !1 && (t[r] = e && b.isArray(o) ? o.join(", ") : o);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const o = new this(e);
    return t.forEach((r) => o.set(r)), o;
  }
  static accessor(e) {
    const o = (this[Et] = this[Et] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function n(l) {
      const s = ie(l);
      o[s] || (xo(r, l), o[s] = !0);
    }
    return b.isArray(e) ? e.forEach(n) : n(e), this;
  }
}
Ke.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
b.reduceDescriptors(Ke.prototype, ({ value: a }, e) => {
  let t = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => a,
    set(o) {
      this[t] = o;
    }
  };
});
b.freezeMethods(Ke);
const N = Ke;
function Ye(a, e) {
  const t = this || wt, o = e || t, r = N.from(o.headers);
  let n = o.data;
  return b.forEach(a, function(s) {
    n = s.call(t, n, r.normalize(), e ? e.status : void 0);
  }), r.normalize(), n;
}
function rr(a) {
  return !!(a && a.__CANCEL__);
}
function xe(a, e, t) {
  x.call(this, a ?? "canceled", x.ERR_CANCELED, e, t), this.name = "CanceledError";
}
b.inherits(xe, x, {
  __CANCEL__: !0
});
function Eo(a, e, t) {
  const o = t.config.validateStatus;
  !t.status || !o || o(t.status) ? a(t) : e(new x(
    "Request failed with status code " + t.status,
    [x.ERR_BAD_REQUEST, x.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
const Io = Q.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(a, e, t, o, r, n) {
      const l = [a + "=" + encodeURIComponent(e)];
      b.isNumber(t) && l.push("expires=" + new Date(t).toGMTString()), b.isString(o) && l.push("path=" + o), b.isString(r) && l.push("domain=" + r), n === !0 && l.push("secure"), document.cookie = l.join("; ");
    },
    read(a) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + a + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(a) {
      this.write(a, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Fo(a) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(a);
}
function Lo(a, e) {
  return e ? a.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : a;
}
function or(a, e) {
  return a && !Fo(e) ? Lo(a, e) : e;
}
const Do = Q.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a");
    let o;
    function r(n) {
      let l = n;
      return e && (t.setAttribute("href", l), l = t.href), t.setAttribute("href", l), {
        href: t.href,
        protocol: t.protocol ? t.protocol.replace(/:$/, "") : "",
        host: t.host,
        search: t.search ? t.search.replace(/^\?/, "") : "",
        hash: t.hash ? t.hash.replace(/^#/, "") : "",
        hostname: t.hostname,
        port: t.port,
        pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname
      };
    }
    return o = r(window.location.href), function(l) {
      const s = b.isString(l) ? r(l) : l;
      return s.protocol === o.protocol && s.host === o.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
);
function Bo(a) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(a);
  return e && e[1] || "";
}
function jo(a, e) {
  a = a || 10;
  const t = new Array(a), o = new Array(a);
  let r = 0, n = 0, l;
  return e = e !== void 0 ? e : 1e3, function(i) {
    const c = Date.now(), d = o[n];
    l || (l = c), t[r] = i, o[r] = c;
    let h = n, f = 0;
    for (; h !== r; )
      f += t[h++], h = h % a;
    if (r = (r + 1) % a, r === n && (n = (n + 1) % a), c - l < e)
      return;
    const R = d && c - d;
    return R ? Math.round(f * 1e3 / R) : void 0;
  };
}
function It(a, e) {
  let t = 0;
  const o = jo(50, 250);
  return (r) => {
    const n = r.loaded, l = r.lengthComputable ? r.total : void 0, s = n - t, i = o(s), c = n <= l;
    t = n;
    const d = {
      loaded: n,
      total: l,
      progress: l ? n / l : void 0,
      bytes: s,
      rate: i || void 0,
      estimated: i && l && c ? (l - n) / i : void 0,
      event: r
    };
    d[e ? "download" : "upload"] = !0, a(d);
  };
}
const ko = typeof XMLHttpRequest < "u", Ho = ko && function(a) {
  return new Promise(function(t, o) {
    let r = a.data;
    const n = N.from(a.headers).normalize();
    let { responseType: l, withXSRFToken: s } = a, i;
    function c() {
      a.cancelToken && a.cancelToken.unsubscribe(i), a.signal && a.signal.removeEventListener("abort", i);
    }
    let d;
    if (b.isFormData(r)) {
      if (Q.hasStandardBrowserEnv || Q.hasStandardBrowserWebWorkerEnv)
        n.setContentType(!1);
      else if ((d = n.getContentType()) !== !1) {
        const [w, ...T] = d ? d.split(";").map((g) => g.trim()).filter(Boolean) : [];
        n.setContentType([w || "multipart/form-data", ...T].join("; "));
      }
    }
    let h = new XMLHttpRequest();
    if (a.auth) {
      const w = a.auth.username || "", T = a.auth.password ? unescape(encodeURIComponent(a.auth.password)) : "";
      n.set("Authorization", "Basic " + btoa(w + ":" + T));
    }
    const f = or(a.baseURL, a.url);
    h.open(a.method.toUpperCase(), Yt(f, a.params, a.paramsSerializer), !0), h.timeout = a.timeout;
    function R() {
      if (!h)
        return;
      const w = N.from(
        "getAllResponseHeaders" in h && h.getAllResponseHeaders()
      ), g = {
        data: !l || l === "text" || l === "json" ? h.responseText : h.response,
        status: h.status,
        statusText: h.statusText,
        headers: w,
        config: a,
        request: h
      };
      Eo(function(E) {
        t(E), c();
      }, function(E) {
        o(E), c();
      }, g), h = null;
    }
    if ("onloadend" in h ? h.onloadend = R : h.onreadystatechange = function() {
      !h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.indexOf("file:") === 0) || setTimeout(R);
    }, h.onabort = function() {
      h && (o(new x("Request aborted", x.ECONNABORTED, a, h)), h = null);
    }, h.onerror = function() {
      o(new x("Network Error", x.ERR_NETWORK, a, h)), h = null;
    }, h.ontimeout = function() {
      let T = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const g = a.transitional || qt;
      a.timeoutErrorMessage && (T = a.timeoutErrorMessage), o(new x(
        T,
        g.clarifyTimeoutError ? x.ETIMEDOUT : x.ECONNABORTED,
        a,
        h
      )), h = null;
    }, Q.hasStandardBrowserEnv && (s && b.isFunction(s) && (s = s(a)), s || s !== !1 && Do(f))) {
      const w = a.xsrfHeaderName && a.xsrfCookieName && Io.read(a.xsrfCookieName);
      w && n.set(a.xsrfHeaderName, w);
    }
    r === void 0 && n.setContentType(null), "setRequestHeader" in h && b.forEach(n.toJSON(), function(T, g) {
      h.setRequestHeader(g, T);
    }), b.isUndefined(a.withCredentials) || (h.withCredentials = !!a.withCredentials), l && l !== "json" && (h.responseType = a.responseType), typeof a.onDownloadProgress == "function" && h.addEventListener("progress", It(a.onDownloadProgress, !0)), typeof a.onUploadProgress == "function" && h.upload && h.upload.addEventListener("progress", It(a.onUploadProgress)), (a.cancelToken || a.signal) && (i = (w) => {
      h && (o(!w || w.type ? new xe(null, a, h) : w), h.abort(), h = null);
    }, a.cancelToken && a.cancelToken.subscribe(i), a.signal && (a.signal.aborted ? i() : a.signal.addEventListener("abort", i)));
    const A = Bo(f);
    if (A && Q.protocols.indexOf(A) === -1) {
      o(new x("Unsupported protocol " + A + ":", x.ERR_BAD_REQUEST, a));
      return;
    }
    h.send(r || null);
  });
}, ot = {
  http: po,
  xhr: Ho
};
b.forEach(ot, (a, e) => {
  if (a) {
    try {
      Object.defineProperty(a, "name", { value: e });
    } catch {
    }
    Object.defineProperty(a, "adapterName", { value: e });
  }
});
const Ft = (a) => `- ${a}`, Qo = (a) => b.isFunction(a) || a === null || a === !1, ar = {
  getAdapter: (a) => {
    a = b.isArray(a) ? a : [a];
    const { length: e } = a;
    let t, o;
    const r = {};
    for (let n = 0; n < e; n++) {
      t = a[n];
      let l;
      if (o = t, !Qo(t) && (o = ot[(l = String(t)).toLowerCase()], o === void 0))
        throw new x(`Unknown adapter '${l}'`);
      if (o)
        break;
      r[l || "#" + n] = o;
    }
    if (!o) {
      const n = Object.entries(r).map(
        ([s, i]) => `adapter ${s} ` + (i === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let l = e ? n.length > 1 ? `since :
` + n.map(Ft).join(`
`) : " " + Ft(n[0]) : "as no adapter specified";
      throw new x(
        "There is no suitable adapter to dispatch the request " + l,
        "ERR_NOT_SUPPORT"
      );
    }
    return o;
  },
  adapters: ot
};
function qe(a) {
  if (a.cancelToken && a.cancelToken.throwIfRequested(), a.signal && a.signal.aborted)
    throw new xe(null, a);
}
function Lt(a) {
  return qe(a), a.headers = N.from(a.headers), a.data = Ye.call(
    a,
    a.transformRequest
  ), ["post", "put", "patch"].indexOf(a.method) !== -1 && a.headers.setContentType("application/x-www-form-urlencoded", !1), ar.getAdapter(a.adapter || wt.adapter)(a).then(function(o) {
    return qe(a), o.data = Ye.call(
      a,
      a.transformResponse,
      o
    ), o.headers = N.from(o.headers), o;
  }, function(o) {
    return rr(o) || (qe(a), o && o.response && (o.response.data = Ye.call(
      a,
      a.transformResponse,
      o.response
    ), o.response.headers = N.from(o.response.headers))), Promise.reject(o);
  });
}
const Dt = (a) => a instanceof N ? { ...a } : a;
function ne(a, e) {
  e = e || {};
  const t = {};
  function o(c, d, h) {
    return b.isPlainObject(c) && b.isPlainObject(d) ? b.merge.call({ caseless: h }, c, d) : b.isPlainObject(d) ? b.merge({}, d) : b.isArray(d) ? d.slice() : d;
  }
  function r(c, d, h) {
    if (b.isUndefined(d)) {
      if (!b.isUndefined(c))
        return o(void 0, c, h);
    } else
      return o(c, d, h);
  }
  function n(c, d) {
    if (!b.isUndefined(d))
      return o(void 0, d);
  }
  function l(c, d) {
    if (b.isUndefined(d)) {
      if (!b.isUndefined(c))
        return o(void 0, c);
    } else
      return o(void 0, d);
  }
  function s(c, d, h) {
    if (h in e)
      return o(c, d);
    if (h in a)
      return o(void 0, c);
  }
  const i = {
    url: n,
    method: n,
    data: n,
    baseURL: l,
    transformRequest: l,
    transformResponse: l,
    paramsSerializer: l,
    timeout: l,
    timeoutMessage: l,
    withCredentials: l,
    withXSRFToken: l,
    adapter: l,
    responseType: l,
    xsrfCookieName: l,
    xsrfHeaderName: l,
    onUploadProgress: l,
    onDownloadProgress: l,
    decompress: l,
    maxContentLength: l,
    maxBodyLength: l,
    beforeRedirect: l,
    transport: l,
    httpAgent: l,
    httpsAgent: l,
    cancelToken: l,
    socketPath: l,
    responseEncoding: l,
    validateStatus: s,
    headers: (c, d) => r(Dt(c), Dt(d), !0)
  };
  return b.forEach(Object.keys(Object.assign({}, a, e)), function(d) {
    const h = i[d] || r, f = h(a[d], e[d], d);
    b.isUndefined(f) && h !== s || (t[d] = f);
  }), t;
}
const nr = "1.6.8", At = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((a, e) => {
  At[a] = function(o) {
    return typeof o === a || "a" + (e < 1 ? "n " : " ") + a;
  };
});
const Bt = {};
At.transitional = function(e, t, o) {
  function r(n, l) {
    return "[Axios v" + nr + "] Transitional option '" + n + "'" + l + (o ? ". " + o : "");
  }
  return (n, l, s) => {
    if (e === !1)
      throw new x(
        r(l, " has been removed" + (t ? " in " + t : "")),
        x.ERR_DEPRECATED
      );
    return t && !Bt[l] && (Bt[l] = !0, console.warn(
      r(
        l,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(n, l, s) : !0;
  };
};
function Wo(a, e, t) {
  if (typeof a != "object")
    throw new x("options must be an object", x.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(a);
  let r = o.length;
  for (; r-- > 0; ) {
    const n = o[r], l = e[n];
    if (l) {
      const s = a[n], i = s === void 0 || l(s, n, a);
      if (i !== !0)
        throw new x("option " + n + " must be " + i, x.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new x("Unknown option " + n, x.ERR_BAD_OPTION);
  }
}
const at = {
  assertOptions: Wo,
  validators: At
}, _ = at.validators;
class $e {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new xt(),
      response: new xt()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (o) {
      if (o instanceof Error) {
        let r;
        Error.captureStackTrace ? Error.captureStackTrace(r = {}) : r = new Error();
        const n = r.stack ? r.stack.replace(/^.+\n/, "") : "";
        o.stack ? n && !String(o.stack).endsWith(n.replace(/^.+\n.+\n/, "")) && (o.stack += `
` + n) : o.stack = n;
      }
      throw o;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = ne(this.defaults, t);
    const { transitional: o, paramsSerializer: r, headers: n } = t;
    o !== void 0 && at.assertOptions(o, {
      silentJSONParsing: _.transitional(_.boolean),
      forcedJSONParsing: _.transitional(_.boolean),
      clarifyTimeoutError: _.transitional(_.boolean)
    }, !1), r != null && (b.isFunction(r) ? t.paramsSerializer = {
      serialize: r
    } : at.assertOptions(r, {
      encode: _.function,
      serialize: _.function
    }, !0)), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let l = n && b.merge(
      n.common,
      n[t.method]
    );
    n && b.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (A) => {
        delete n[A];
      }
    ), t.headers = N.concat(l, n);
    const s = [];
    let i = !0;
    this.interceptors.request.forEach(function(w) {
      typeof w.runWhen == "function" && w.runWhen(t) === !1 || (i = i && w.synchronous, s.unshift(w.fulfilled, w.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(w) {
      c.push(w.fulfilled, w.rejected);
    });
    let d, h = 0, f;
    if (!i) {
      const A = [Lt.bind(this), void 0];
      for (A.unshift.apply(A, s), A.push.apply(A, c), f = A.length, d = Promise.resolve(t); h < f; )
        d = d.then(A[h++], A[h++]);
      return d;
    }
    f = s.length;
    let R = t;
    for (h = 0; h < f; ) {
      const A = s[h++], w = s[h++];
      try {
        R = A(R);
      } catch (T) {
        w.call(this, T);
        break;
      }
    }
    try {
      d = Lt.call(this, R);
    } catch (A) {
      return Promise.reject(A);
    }
    for (h = 0, f = c.length; h < f; )
      d = d.then(c[h++], c[h++]);
    return d;
  }
  getUri(e) {
    e = ne(this.defaults, e);
    const t = or(e.baseURL, e.url);
    return Yt(t, e.params, e.paramsSerializer);
  }
}
b.forEach(["delete", "get", "head", "options"], function(e) {
  $e.prototype[e] = function(t, o) {
    return this.request(ne(o || {}, {
      method: e,
      url: t,
      data: (o || {}).data
    }));
  };
});
b.forEach(["post", "put", "patch"], function(e) {
  function t(o) {
    return function(n, l, s) {
      return this.request(ne(s || {}, {
        method: e,
        headers: o ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: n,
        data: l
      }));
    };
  }
  $e.prototype[e] = t(), $e.prototype[e + "Form"] = t(!0);
});
const De = $e;
class Rt {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(n) {
      t = n;
    });
    const o = this;
    this.promise.then((r) => {
      if (!o._listeners)
        return;
      let n = o._listeners.length;
      for (; n-- > 0; )
        o._listeners[n](r);
      o._listeners = null;
    }), this.promise.then = (r) => {
      let n;
      const l = new Promise((s) => {
        o.subscribe(s), n = s;
      }).then(r);
      return l.cancel = function() {
        o.unsubscribe(n);
      }, l;
    }, e(function(n, l, s) {
      o.reason || (o.reason = new xe(n, l, s), t(o.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(e);
    t !== -1 && this._listeners.splice(t, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new Rt(function(r) {
        e = r;
      }),
      cancel: e
    };
  }
}
const $o = Rt;
function No(a) {
  return function(t) {
    return a.apply(null, t);
  };
}
function _o(a) {
  return b.isObject(a) && a.isAxiosError === !0;
}
const nt = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(nt).forEach(([a, e]) => {
  nt[e] = a;
});
const Mo = nt;
function lr(a) {
  const e = new De(a), t = Ht(De.prototype.request, e);
  return b.extend(t, De.prototype, e, { allOwnKeys: !0 }), b.extend(t, e, null, { allOwnKeys: !0 }), t.create = function(r) {
    return lr(ne(a, r));
  }, t;
}
const u = lr(wt);
u.Axios = De;
u.CanceledError = xe;
u.CancelToken = $o;
u.isCancel = rr;
u.VERSION = nr;
u.toFormData = ze;
u.AxiosError = x;
u.Cancel = u.CanceledError;
u.all = function(e) {
  return Promise.all(e);
};
u.spread = No;
u.isAxiosError = _o;
u.mergeConfig = ne;
u.AxiosHeaders = N;
u.formToJSON = (a) => tr(b.isHTMLForm(a) ? new FormData(a) : a);
u.getAdapter = ar.getAdapter;
u.HttpStatusCode = Mo;
u.default = u;
const C = "http://localhost".replace(/\/+$/, "");
class v {
  constructor(e, t = C, o = u) {
    $(this, "configuration");
    this.basePath = t, this.axios = o, e && (this.configuration = e, this.basePath = e.basePath || this.basePath);
  }
}
class zo extends Error {
  constructor(e, t) {
    super(t), this.field = e, this.name = "RequiredError";
  }
}
const y = "https://example.com", p = function(a, e, t) {
  if (t == null)
    throw new zo(e, `Required parameter ${e} was null or undefined when calling ${a}.`);
}, P = async function(a, e) {
  if (e && e.accessToken) {
    const t = typeof e.accessToken == "function" ? await e.accessToken() : await e.accessToken;
    a.Authorization = "Bearer " + t;
  }
};
function Be(a, e, t = "") {
  e != null && (typeof e == "object" ? Array.isArray(e) ? t ? e.forEach((o, r) => Be(a, o, t + "[" + r + "]")) : e.forEach((o) => Be(a, o, t)) : Object.keys(e).forEach(
    (o) => Be(a, e[o], `${t}${t !== "" ? "." : ""}${o}`)
  ) : a.has(t) ? a.append(t, e) : a.set(t, e));
}
const m = function(a, ...e) {
  const t = new URLSearchParams(a.search);
  Be(t, e), a.search = t.toString();
}, S = function(a, e, t) {
  const o = typeof a != "string";
  return (o && t && t.isJsonMime ? t.isJsonMime(e.headers["Content-Type"]) : o) ? JSON.stringify(a !== void 0 ? a : {}) : a || "";
}, O = function(a) {
  return a.pathname + a.search + a.hash;
}, V = function(a, e, t, o) {
  return (r = e, n = t) => {
    const l = { ...a.options, url: ((o == null ? void 0 : o.basePath) || n) + a.url };
    return r.request(l);
  };
}, Il = {
  QuarterHourly: "quarter-hourly",
  Hourly: "hourly",
  Daily: "daily",
  Weekly: "weekly",
  Monthly: "monthly"
}, Fl = {
  QuarterHourly: "quarter-hourly",
  Hourly: "hourly",
  Daily: "daily",
  Weekly: "weekly",
  Monthly: "monthly"
}, Ll = {
  New: "new",
  Processing: "processing",
  Completed: "completed",
  Canceled: "canceled",
  Error: "error"
}, Ko = function(a) {
  return {
    /**
     * 
     * @summary Checking the existence of an account
     * @param {CheckExistsReq} checkExistsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerCheckAccountExists: async (e, t = {}) => {
      p("accountControllerCheckAccountExists", "checkExistsReq", e);
      const o = "/api3/account/check-exists", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Soft account deletion
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerDelete: async (e, t = {}) => {
      p("accountControllerDelete", "id", e);
      const o = "/api3/account/{id}".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "DELETE", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Deactivating account
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerDisable: async (e, t = {}) => {
      p("accountControllerDisable", "id", e);
      const o = "/api3/account/{id}/disable".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns account information
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerGetAccount: async (e, t = {}) => {
      p("accountControllerGetAccount", "id", e);
      const o = "/api3/account/{id}/info".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns a list of accounts
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerGetAccounts: async (e, t, o = {}) => {
      p("accountControllerGetAccounts", "limit", e), p("accountControllerGetAccounts", "page", t);
      const r = "/api3/account", n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      await P(i, a), e !== void 0 && (c.limit = e), t !== void 0 && (c.page = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Starts export operation
     * @param {AccountExportReq} accountExportReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerStartExport: async (e, t = {}) => {
      p("accountControllerStartExport", "accountExportReq", e);
      const o = "/api3/account/export", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Undelete account
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerUndelete: async (e, t = {}) => {
      p("accountControllerUndelete", "id", e);
      const o = "/api3/account/{id}/undelete".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Retrieving data about the current network account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountCurrentControllerGetAccountCurrent: async (e = {}) => {
      const t = "/api3/account/current", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Getting a list of account\'s periods
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {any} [positionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPeriodControllerGetAccountPeriods: async (e, t, o, r, n = {}) => {
      p("accountPeriodControllerGetAccountPeriods", "limit", e), p("accountPeriodControllerGetAccountPeriods", "page", t), p("accountPeriodControllerGetAccountPeriods", "id", o);
      const l = "/api3/account/{id}/available-period".replace("{id}", encodeURIComponent(String(o))), s = new URL(l, y);
      let i;
      a && (i = a.baseOptions);
      const c = { method: "GET", ...i, ...n }, d = {}, h = {};
      await P(d, a), e !== void 0 && (h.limit = e), t !== void 0 && (h.page = t), r !== void 0 && (h.positionId = r), m(s, h);
      let f = i && i.headers ? i.headers : {};
      return c.headers = { ...d, ...f, ...n.headers }, {
        url: O(s),
        options: c
      };
    },
    /**
     * Use the v2 version
     * @summary Getting the tree of children of the position
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {any} [treeId] 
     * @param {any} [positionId] 
     * @param {any} [offset] 
     * @param {any} [depth] Sampling depth
     * @param {boolean} [showInactiveAccounts] Show deleted or disabled accounts. Administrator only
     * @param {object} [properties] Requested marketing properties
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    downlineControllerGetDownline: async (e, t, o, r, n, l, s, i, c, d, h, f = {}) => {
      p("downlineControllerGetDownline", "limit", e), p("downlineControllerGetDownline", "page", t), p("downlineControllerGetDownline", "id", o);
      const R = "/api3/account/{id}/downline".replace("{id}", encodeURIComponent(String(o))), A = new URL(R, y);
      let w;
      a && (w = a.baseOptions);
      const T = { method: "GET", ...w, ...f }, g = {}, G = {};
      await P(g, a), e !== void 0 && (G.limit = e), t !== void 0 && (G.page = t), r !== void 0 && (G.treeId = r), n !== void 0 && (G.positionId = n), l !== void 0 && (G.offset = l), s !== void 0 && (G.depth = s), i !== void 0 && (G.showInactiveAccounts = i), c !== void 0 && (G.properties = c), d !== void 0 && (G.orderBy = d), h !== void 0 && (G.filter = h), m(A, G);
      let E = w && w.headers ? w.headers : {};
      return T.headers = { ...g, ...E, ...f.headers }, {
        url: O(A),
        options: T
      };
    },
    /**
     * Use the v2 version
     * @summary Getting the children of the position
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {any} [treeId] 
     * @param {boolean} [showInactiveAccounts] Show deleted or disabled accounts. Administrator only
     * @param {object} [properties] Requested marketing properties
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    frontLineControllerGetFrontline: async (e, t, o, r, n, l, s, i = {}) => {
      p("frontLineControllerGetFrontline", "limit", e), p("frontLineControllerGetFrontline", "page", t), p("frontLineControllerGetFrontline", "id", o);
      const c = "/api3/account/{id}/frontline".replace("{id}", encodeURIComponent(String(o))), d = new URL(c, y);
      let h;
      a && (h = a.baseOptions);
      const f = { method: "GET", ...h, ...i }, R = {}, A = {};
      await P(R, a), e !== void 0 && (A.limit = e), t !== void 0 && (A.page = t), r !== void 0 && (A.treeId = r), n !== void 0 && (A.showInactiveAccounts = n), l !== void 0 && (A.properties = l), s !== void 0 && (A.filter = s), m(d, A);
      let w = h && h.headers ? h.headers : {};
      return f.headers = { ...R, ...w, ...i.headers }, {
        url: O(d),
        options: f
      };
    },
    /**
     * 
     * @summary Checking the uniqueness of email and phone
     * @param {UniquenessCheckReq} uniquenessCheckReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uniquenessControllerOtpUniquenessCheck: async (e, t = {}) => {
      p("uniquenessControllerOtpUniquenessCheck", "uniquenessCheckReq", e);
      const o = "/api3/account/uniqueness-check", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Getting the upline of the position
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {any} [treeId] 
     * @param {any} [includeTree] 
     * @param {any} [positionId] 
     * @param {any} [offset] 
     * @param {any} [targetPositionId] target position to which the upline is requested
     * @param {string} [properties] Requested marketing properties
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uplineControllerGetUpline: async (e, t, o, r, n, l, s, i, c, d = {}) => {
      p("uplineControllerGetUpline", "limit", e), p("uplineControllerGetUpline", "page", t), p("uplineControllerGetUpline", "id", o);
      const h = "/api3/account/{id}/upline".replace("{id}", encodeURIComponent(String(o))), f = new URL(h, y);
      let R;
      a && (R = a.baseOptions);
      const A = { method: "GET", ...R, ...d }, w = {}, T = {};
      await P(w, a), e !== void 0 && (T.limit = e), t !== void 0 && (T.page = t), r !== void 0 && (T.treeId = r), n !== void 0 && (T.includeTree = n), l !== void 0 && (T.positionId = l), s !== void 0 && (T.offset = s), i !== void 0 && (T.targetPositionId = i), c !== void 0 && (T.properties = c), m(f, T);
      let g = R && R.headers ? R.headers : {};
      return A.headers = { ...w, ...g, ...d.headers }, {
        url: O(f),
        options: A
      };
    },
    /**
     * 
     * @summary Getting the tree of children of the position
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {any} [treeId] 
     * @param {any} [includeTree] 
     * @param {any} [positionId] 
     * @param {any} [offset] 
     * @param {any} [depth] Sampling depth
     * @param {boolean} [showInactiveAccounts] Show deleted or disabled accounts. Administrator only
     * @param {boolean} [showDisabledAccounts] Show disabled accounts
     * @param {any} [periodId] Period ID
     * @param {string} [properties] Requested marketing properties
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] Filtering parameters
     * @param {boolean} [includeCountryBranches] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2DownlineControllerGetDownline: async (e, t, o, r, n, l, s, i, c, d, h, f, R, A, w, T = {}) => {
      p("v2DownlineControllerGetDownline", "limit", e), p("v2DownlineControllerGetDownline", "page", t), p("v2DownlineControllerGetDownline", "id", o);
      const g = "/api3/v2/account/{id}/downline".replace("{id}", encodeURIComponent(String(o))), G = new URL(g, y);
      let E;
      a && (E = a.baseOptions);
      const q = { method: "GET", ...E, ...T }, Tt = {}, L = {};
      await P(Tt, a), e !== void 0 && (L.limit = e), t !== void 0 && (L.page = t), r !== void 0 && (L.treeId = r), n !== void 0 && (L.includeTree = n), l !== void 0 && (L.positionId = l), s !== void 0 && (L.offset = s), i !== void 0 && (L.depth = i), c !== void 0 && (L.showInactiveAccounts = c), d !== void 0 && (L.showDisabledAccounts = d), h !== void 0 && (L.periodId = h), f !== void 0 && (L.properties = f), R !== void 0 && (L.orderBy = R), A !== void 0 && (L.filter = A), w !== void 0 && (L.includeCountryBranches = w), m(G, L);
      let Tr = E && E.headers ? E.headers : {};
      return q.headers = { ...Tt, ...Tr, ...T.headers }, {
        url: O(G),
        options: q
      };
    },
    /**
     * 
     * @summary Returns export headers
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2DownlineControllerGetExportHeaders: async (e, t = {}) => {
      p("v2DownlineControllerGetExportHeaders", "id", e);
      const o = "/api3/v2/account/{id}/downline/export/headers".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Starts export operation
     * @param {number} id 
     * @param {ExportDownlineReq} exportDownlineReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2DownlineControllerStartExport: async (e, t, o = {}) => {
      p("v2DownlineControllerStartExport", "id", e), p("v2DownlineControllerStartExport", "exportDownlineReq", t);
      const r = "/api3/v2/account/{id}/downline/export".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "POST", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Getting the children of the position
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {any} [treeId] 
     * @param {any} [positionId] 
     * @param {any} [offset] 
     * @param {boolean} [showInactiveAccounts] Show deleted or disabled accounts. Administrator only
     * @param {boolean} [showDisabledAccounts] Show disabled accounts
     * @param {string} [properties] Requested marketing properties
     * @param {object} [filter] Filtering parameters
     * @param {object} [orderBy] Sort options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2FrontLineControllerGetFrontline: async (e, t, o, r, n, l, s, i, c, d, h, f = {}) => {
      p("v2FrontLineControllerGetFrontline", "limit", e), p("v2FrontLineControllerGetFrontline", "page", t), p("v2FrontLineControllerGetFrontline", "id", o);
      const R = "/api3/v2/account/{id}/frontline".replace("{id}", encodeURIComponent(String(o))), A = new URL(R, y);
      let w;
      a && (w = a.baseOptions);
      const T = { method: "GET", ...w, ...f }, g = {}, G = {};
      await P(g, a), e !== void 0 && (G.limit = e), t !== void 0 && (G.page = t), r !== void 0 && (G.treeId = r), n !== void 0 && (G.positionId = n), l !== void 0 && (G.offset = l), s !== void 0 && (G.showInactiveAccounts = s), i !== void 0 && (G.showDisabledAccounts = i), c !== void 0 && (G.properties = c), d !== void 0 && (G.filter = d), h !== void 0 && (G.orderBy = h), m(A, G);
      let E = w && w.headers ? w.headers : {};
      return T.headers = { ...g, ...E, ...f.headers }, {
        url: O(A),
        options: T
      };
    }
  };
}, F = function(a) {
  const e = Ko(a);
  return {
    /**
     * 
     * @summary Checking the existence of an account
     * @param {CheckExistsReq} checkExistsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountControllerCheckAccountExists(t, o) {
      const r = await e.accountControllerCheckAccountExists(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Soft account deletion
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountControllerDelete(t, o) {
      const r = await e.accountControllerDelete(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Deactivating account
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountControllerDisable(t, o) {
      const r = await e.accountControllerDisable(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns account information
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountControllerGetAccount(t, o) {
      const r = await e.accountControllerGetAccount(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns a list of accounts
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountControllerGetAccounts(t, o, r) {
      const n = await e.accountControllerGetAccounts(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Starts export operation
     * @param {AccountExportReq} accountExportReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountControllerStartExport(t, o) {
      const r = await e.accountControllerStartExport(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Undelete account
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountControllerUndelete(t, o) {
      const r = await e.accountControllerUndelete(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Retrieving data about the current network account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountCurrentControllerGetAccountCurrent(t) {
      const o = await e.accountCurrentControllerGetAccountCurrent(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Getting a list of account\'s periods
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {any} [positionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountPeriodControllerGetAccountPeriods(t, o, r, n, l) {
      const s = await e.accountPeriodControllerGetAccountPeriods(t, o, r, n, l);
      return V(s, u, C, a);
    },
    /**
     * Use the v2 version
     * @summary Getting the tree of children of the position
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {any} [treeId] 
     * @param {any} [positionId] 
     * @param {any} [offset] 
     * @param {any} [depth] Sampling depth
     * @param {boolean} [showInactiveAccounts] Show deleted or disabled accounts. Administrator only
     * @param {object} [properties] Requested marketing properties
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async downlineControllerGetDownline(t, o, r, n, l, s, i, c, d, h, f, R) {
      const A = await e.downlineControllerGetDownline(t, o, r, n, l, s, i, c, d, h, f, R);
      return V(A, u, C, a);
    },
    /**
     * Use the v2 version
     * @summary Getting the children of the position
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {any} [treeId] 
     * @param {boolean} [showInactiveAccounts] Show deleted or disabled accounts. Administrator only
     * @param {object} [properties] Requested marketing properties
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async frontLineControllerGetFrontline(t, o, r, n, l, s, i, c) {
      const d = await e.frontLineControllerGetFrontline(t, o, r, n, l, s, i, c);
      return V(d, u, C, a);
    },
    /**
     * 
     * @summary Checking the uniqueness of email and phone
     * @param {UniquenessCheckReq} uniquenessCheckReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uniquenessControllerOtpUniquenessCheck(t, o) {
      const r = await e.uniquenessControllerOtpUniquenessCheck(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Getting the upline of the position
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {any} [treeId] 
     * @param {any} [includeTree] 
     * @param {any} [positionId] 
     * @param {any} [offset] 
     * @param {any} [targetPositionId] target position to which the upline is requested
     * @param {string} [properties] Requested marketing properties
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uplineControllerGetUpline(t, o, r, n, l, s, i, c, d, h) {
      const f = await e.uplineControllerGetUpline(t, o, r, n, l, s, i, c, d, h);
      return V(f, u, C, a);
    },
    /**
     * 
     * @summary Getting the tree of children of the position
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {any} [treeId] 
     * @param {any} [includeTree] 
     * @param {any} [positionId] 
     * @param {any} [offset] 
     * @param {any} [depth] Sampling depth
     * @param {boolean} [showInactiveAccounts] Show deleted or disabled accounts. Administrator only
     * @param {boolean} [showDisabledAccounts] Show disabled accounts
     * @param {any} [periodId] Period ID
     * @param {string} [properties] Requested marketing properties
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] Filtering parameters
     * @param {boolean} [includeCountryBranches] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async v2DownlineControllerGetDownline(t, o, r, n, l, s, i, c, d, h, f, R, A, w, T, g) {
      const G = await e.v2DownlineControllerGetDownline(t, o, r, n, l, s, i, c, d, h, f, R, A, w, T, g);
      return V(G, u, C, a);
    },
    /**
     * 
     * @summary Returns export headers
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async v2DownlineControllerGetExportHeaders(t, o) {
      const r = await e.v2DownlineControllerGetExportHeaders(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Starts export operation
     * @param {number} id 
     * @param {ExportDownlineReq} exportDownlineReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async v2DownlineControllerStartExport(t, o, r) {
      const n = await e.v2DownlineControllerStartExport(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Getting the children of the position
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {any} [treeId] 
     * @param {any} [positionId] 
     * @param {any} [offset] 
     * @param {boolean} [showInactiveAccounts] Show deleted or disabled accounts. Administrator only
     * @param {boolean} [showDisabledAccounts] Show disabled accounts
     * @param {string} [properties] Requested marketing properties
     * @param {object} [filter] Filtering parameters
     * @param {object} [orderBy] Sort options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async v2FrontLineControllerGetFrontline(t, o, r, n, l, s, i, c, d, h, f, R) {
      const A = await e.v2FrontLineControllerGetFrontline(t, o, r, n, l, s, i, c, d, h, f, R);
      return V(A, u, C, a);
    }
  };
}, Dl = function(a, e, t) {
  const o = F(a);
  return {
    /**
     * 
     * @summary Checking the existence of an account
     * @param {AccountApiAccountControllerCheckAccountExistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerCheckAccountExists(r, n) {
      return o.accountControllerCheckAccountExists(r.checkExistsReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Soft account deletion
     * @param {AccountApiAccountControllerDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerDelete(r, n) {
      return o.accountControllerDelete(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Deactivating account
     * @param {AccountApiAccountControllerDisableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerDisable(r, n) {
      return o.accountControllerDisable(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns account information
     * @param {AccountApiAccountControllerGetAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerGetAccount(r, n) {
      return o.accountControllerGetAccount(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns a list of accounts
     * @param {AccountApiAccountControllerGetAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerGetAccounts(r, n) {
      return o.accountControllerGetAccounts(r.limit, r.page, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Starts export operation
     * @param {AccountApiAccountControllerStartExportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerStartExport(r, n) {
      return o.accountControllerStartExport(r.accountExportReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Undelete account
     * @param {AccountApiAccountControllerUndeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountControllerUndelete(r, n) {
      return o.accountControllerUndelete(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Retrieving data about the current network account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountCurrentControllerGetAccountCurrent(r) {
      return o.accountCurrentControllerGetAccountCurrent(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Getting a list of account\'s periods
     * @param {AccountApiAccountPeriodControllerGetAccountPeriodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPeriodControllerGetAccountPeriods(r, n) {
      return o.accountPeriodControllerGetAccountPeriods(r.limit, r.page, r.id, r.positionId, n).then((l) => l(t, e));
    },
    /**
     * Use the v2 version
     * @summary Getting the tree of children of the position
     * @param {AccountApiDownlineControllerGetDownlineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    downlineControllerGetDownline(r, n) {
      return o.downlineControllerGetDownline(r.limit, r.page, r.id, r.treeId, r.positionId, r.offset, r.depth, r.showInactiveAccounts, r.properties, r.orderBy, r.filter, n).then((l) => l(t, e));
    },
    /**
     * Use the v2 version
     * @summary Getting the children of the position
     * @param {AccountApiFrontLineControllerGetFrontlineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    frontLineControllerGetFrontline(r, n) {
      return o.frontLineControllerGetFrontline(r.limit, r.page, r.id, r.treeId, r.showInactiveAccounts, r.properties, r.filter, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Checking the uniqueness of email and phone
     * @param {AccountApiUniquenessControllerOtpUniquenessCheckRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uniquenessControllerOtpUniquenessCheck(r, n) {
      return o.uniquenessControllerOtpUniquenessCheck(r.uniquenessCheckReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting the upline of the position
     * @param {AccountApiUplineControllerGetUplineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uplineControllerGetUpline(r, n) {
      return o.uplineControllerGetUpline(r.limit, r.page, r.id, r.treeId, r.includeTree, r.positionId, r.offset, r.targetPositionId, r.properties, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting the tree of children of the position
     * @param {AccountApiV2DownlineControllerGetDownlineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2DownlineControllerGetDownline(r, n) {
      return o.v2DownlineControllerGetDownline(r.limit, r.page, r.id, r.treeId, r.includeTree, r.positionId, r.offset, r.depth, r.showInactiveAccounts, r.showDisabledAccounts, r.periodId, r.properties, r.orderBy, r.filter, r.includeCountryBranches, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns export headers
     * @param {AccountApiV2DownlineControllerGetExportHeadersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2DownlineControllerGetExportHeaders(r, n) {
      return o.v2DownlineControllerGetExportHeaders(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Starts export operation
     * @param {AccountApiV2DownlineControllerStartExportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2DownlineControllerStartExport(r, n) {
      return o.v2DownlineControllerStartExport(r.id, r.exportDownlineReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting the children of the position
     * @param {AccountApiV2FrontLineControllerGetFrontlineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2FrontLineControllerGetFrontline(r, n) {
      return o.v2FrontLineControllerGetFrontline(r.limit, r.page, r.id, r.treeId, r.positionId, r.offset, r.showInactiveAccounts, r.showDisabledAccounts, r.properties, r.filter, r.orderBy, n).then((l) => l(t, e));
    }
  };
};
class Jo extends v {
  /**
   * 
   * @summary Checking the existence of an account
   * @param {AccountApiAccountControllerCheckAccountExistsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  checkAccountExists(e, t) {
    return F(this.configuration).accountControllerCheckAccountExists(e.checkExistsReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Soft account deletion
   * @param {AccountApiAccountControllerDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  delete(e, t) {
    return F(this.configuration).accountControllerDelete(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Deactivating account
   * @param {AccountApiAccountControllerDisableRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  disable(e, t) {
    return F(this.configuration).accountControllerDisable(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns account information
   * @param {AccountApiAccountControllerGetAccountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  getAccount(e, t) {
    return F(this.configuration).accountControllerGetAccount(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns a list of accounts
   * @param {AccountApiAccountControllerGetAccountsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  getAccounts(e, t) {
    return F(this.configuration).accountControllerGetAccounts(e.limit, e.page, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Starts export operation
   * @param {AccountApiAccountControllerStartExportRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  accountControllerStartExport(e, t) {
    return F(this.configuration).accountControllerStartExport(e.accountExportReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Undelete account
   * @param {AccountApiAccountControllerUndeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  undelete(e, t) {
    return F(this.configuration).accountControllerUndelete(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Retrieving data about the current network account
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  getAccountCurrent(e) {
    return F(this.configuration).accountCurrentControllerGetAccountCurrent(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting a list of account\'s periods
   * @param {AccountApiAccountPeriodControllerGetAccountPeriodsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  getAccountPeriods(e, t) {
    return F(this.configuration).accountPeriodControllerGetAccountPeriods(e.limit, e.page, e.id, e.positionId, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Use the v2 version
   * @summary Getting the tree of children of the position
   * @param {AccountApiDownlineControllerGetDownlineRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  downlineControllerGetDownline(e, t) {
    return F(this.configuration).downlineControllerGetDownline(e.limit, e.page, e.id, e.treeId, e.positionId, e.offset, e.depth, e.showInactiveAccounts, e.properties, e.orderBy, e.filter, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Use the v2 version
   * @summary Getting the children of the position
   * @param {AccountApiFrontLineControllerGetFrontlineRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  frontLineControllerGetFrontline(e, t) {
    return F(this.configuration).frontLineControllerGetFrontline(e.limit, e.page, e.id, e.treeId, e.showInactiveAccounts, e.properties, e.filter, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Checking the uniqueness of email and phone
   * @param {AccountApiUniquenessControllerOtpUniquenessCheckRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  otpUniquenessCheck(e, t) {
    return F(this.configuration).uniquenessControllerOtpUniquenessCheck(e.uniquenessCheckReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting the upline of the position
   * @param {AccountApiUplineControllerGetUplineRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  getUpline(e, t) {
    return F(this.configuration).uplineControllerGetUpline(e.limit, e.page, e.id, e.treeId, e.includeTree, e.positionId, e.offset, e.targetPositionId, e.properties, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting the tree of children of the position
   * @param {AccountApiV2DownlineControllerGetDownlineRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  v2DownlineControllerGetDownline(e, t) {
    return F(this.configuration).v2DownlineControllerGetDownline(e.limit, e.page, e.id, e.treeId, e.includeTree, e.positionId, e.offset, e.depth, e.showInactiveAccounts, e.showDisabledAccounts, e.periodId, e.properties, e.orderBy, e.filter, e.includeCountryBranches, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns export headers
   * @param {AccountApiV2DownlineControllerGetExportHeadersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  getExportHeaders(e, t) {
    return F(this.configuration).v2DownlineControllerGetExportHeaders(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Starts export operation
   * @param {AccountApiV2DownlineControllerStartExportRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  v2DownlineControllerStartExport(e, t) {
    return F(this.configuration).v2DownlineControllerStartExport(e.id, e.exportDownlineReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting the children of the position
   * @param {AccountApiV2FrontLineControllerGetFrontlineRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountApi
   */
  v2FrontLineControllerGetFrontline(e, t) {
    return F(this.configuration).v2FrontLineControllerGetFrontline(e.limit, e.page, e.id, e.treeId, e.positionId, e.offset, e.showInactiveAccounts, e.showDisabledAccounts, e.properties, e.filter, e.orderBy, t).then((o) => o(this.axios, this.basePath));
  }
}
const Xo = function(a) {
  return {
    /**
     *      Function to be used in the NRM and in the cabinet component      if an already authorized user registers a new user below the network.         
     * @summary Account registration
     * @param {AccountCreateReq} accountCreateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountCreateControllerCreateAccount: async (e, t = {}) => {
      p("accountCreateControllerCreateAccount", "accountCreateReq", e);
      const o = "/api3/account/create", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     *      Self-registration, which is used on the public page onlineoffice.     Since there is no authorization in the API at this stage, the function only works with OTP.         
     * @summary Account registration
     * @param {AccountSignupReq} accountSignupReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountSignupControllerCreateAccount: async (e, t = {}) => {
      p("accountSignupControllerCreateAccount", "accountSignupReq", e);
      const o = "/api3/account/signup", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    }
  };
}, lt = function(a) {
  const e = Xo(a);
  return {
    /**
     *      Function to be used in the NRM and in the cabinet component      if an already authorized user registers a new user below the network.         
     * @summary Account registration
     * @param {AccountCreateReq} accountCreateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountCreateControllerCreateAccount(t, o) {
      const r = await e.accountCreateControllerCreateAccount(t, o);
      return V(r, u, C, a);
    },
    /**
     *      Self-registration, which is used on the public page onlineoffice.     Since there is no authorization in the API at this stage, the function only works with OTP.         
     * @summary Account registration
     * @param {AccountSignupReq} accountSignupReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountSignupControllerCreateAccount(t, o) {
      const r = await e.accountSignupControllerCreateAccount(t, o);
      return V(r, u, C, a);
    }
  };
}, Bl = function(a, e, t) {
  const o = lt(a);
  return {
    /**
     *      Function to be used in the NRM and in the cabinet component      if an already authorized user registers a new user below the network.         
     * @summary Account registration
     * @param {AccountCreationApiAccountCreateControllerCreateAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountCreateControllerCreateAccount(r, n) {
      return o.accountCreateControllerCreateAccount(r.accountCreateReq, n).then((l) => l(t, e));
    },
    /**
     *      Self-registration, which is used on the public page onlineoffice.     Since there is no authorization in the API at this stage, the function only works with OTP.         
     * @summary Account registration
     * @param {AccountCreationApiAccountSignupControllerCreateAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountSignupControllerCreateAccount(r, n) {
      return o.accountSignupControllerCreateAccount(r.accountSignupReq, n).then((l) => l(t, e));
    }
  };
};
class Zo extends v {
  /**
   *      Function to be used in the NRM and in the cabinet component      if an already authorized user registers a new user below the network.         
   * @summary Account registration
   * @param {AccountCreationApiAccountCreateControllerCreateAccountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountCreationApi
   */
  accountCreateControllerCreateAccount(e, t) {
    return lt(this.configuration).accountCreateControllerCreateAccount(e.accountCreateReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   *      Self-registration, which is used on the public page onlineoffice.     Since there is no authorization in the API at this stage, the function only works with OTP.         
   * @summary Account registration
   * @param {AccountCreationApiAccountSignupControllerCreateAccountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountCreationApi
   */
  accountSignupControllerCreateAccount(e, t) {
    return lt(this.configuration).accountSignupControllerCreateAccount(e.accountSignupReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const Yo = function(a) {
  return {
    /**
     * 
     * @summary Get account access tokens
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountImpersonateControllerImpersonate: async (e, t = {}) => {
      p("accountImpersonateControllerImpersonate", "id", e);
      const o = "/api3/account/{id}/impersonate/login".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    }
  };
}, sr = function(a) {
  const e = Yo(a);
  return {
    /**
     * 
     * @summary Get account access tokens
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountImpersonateControllerImpersonate(t, o) {
      const r = await e.accountImpersonateControllerImpersonate(t, o);
      return V(r, u, C, a);
    }
  };
}, jl = function(a, e, t) {
  const o = sr(a);
  return {
    /**
     * 
     * @summary Get account access tokens
     * @param {AccountImpersonateApiAccountImpersonateControllerImpersonateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountImpersonateControllerImpersonate(r, n) {
      return o.accountImpersonateControllerImpersonate(r.id, n).then((l) => l(t, e));
    }
  };
};
class qo extends v {
  /**
   * 
   * @summary Get account access tokens
   * @param {AccountImpersonateApiAccountImpersonateControllerImpersonateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountImpersonateApi
   */
  impersonate(e, t) {
    return sr(this.configuration).accountImpersonateControllerImpersonate(e.id, t).then((o) => o(this.axios, this.basePath));
  }
}
const ea = function(a) {
  return {
    /**
     * 
     * @summary Creating an order
     * @param {number} id 
     * @param {PosOrderData} posOrderData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPosOrderControllerCreateOrder: async (e, t, o = {}) => {
      p("accountPosOrderControllerCreateOrder", "id", e), p("accountPosOrderControllerCreateOrder", "posOrderData", t);
      const r = "/api3/account/{id}/pos/order".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "POST", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Getting a list of account orders
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPosOrderControllerGetAccountOrders: async (e, t, o, r = {}) => {
      p("accountPosOrderControllerGetAccountOrders", "limit", e), p("accountPosOrderControllerGetAccountOrders", "page", t), p("accountPosOrderControllerGetAccountOrders", "id", o);
      const n = "/api3/account/{id}/pos/order".replace("{id}", encodeURIComponent(String(o))), l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "GET", ...s, ...r }, c = {}, d = {};
      await P(c, a), e !== void 0 && (d.limit = e), t !== void 0 && (d.page = t), m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, {
        url: O(l),
        options: i
      };
    },
    /**
     * 
     * @summary Update order
     * @param {number} id 
     * @param {PosOrderData} posOrderData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPosOrderControllerUpdateOrder: async (e, t, o = {}) => {
      p("accountPosOrderControllerUpdateOrder", "id", e), p("accountPosOrderControllerUpdateOrder", "posOrderData", t);
      const r = "/api3/account/{id}/pos/order".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, je = function(a) {
  const e = ea(a);
  return {
    /**
     * 
     * @summary Creating an order
     * @param {number} id 
     * @param {PosOrderData} posOrderData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountPosOrderControllerCreateOrder(t, o, r) {
      const n = await e.accountPosOrderControllerCreateOrder(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Getting a list of account orders
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountPosOrderControllerGetAccountOrders(t, o, r, n) {
      const l = await e.accountPosOrderControllerGetAccountOrders(t, o, r, n);
      return V(l, u, C, a);
    },
    /**
     * 
     * @summary Update order
     * @param {number} id 
     * @param {PosOrderData} posOrderData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountPosOrderControllerUpdateOrder(t, o, r) {
      const n = await e.accountPosOrderControllerUpdateOrder(t, o, r);
      return V(n, u, C, a);
    }
  };
}, kl = function(a, e, t) {
  const o = je(a);
  return {
    /**
     * 
     * @summary Creating an order
     * @param {AccountPOSApiAccountPosOrderControllerCreateOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPosOrderControllerCreateOrder(r, n) {
      return o.accountPosOrderControllerCreateOrder(r.id, r.posOrderData, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting a list of account orders
     * @param {AccountPOSApiAccountPosOrderControllerGetAccountOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPosOrderControllerGetAccountOrders(r, n) {
      return o.accountPosOrderControllerGetAccountOrders(r.limit, r.page, r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Update order
     * @param {AccountPOSApiAccountPosOrderControllerUpdateOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPosOrderControllerUpdateOrder(r, n) {
      return o.accountPosOrderControllerUpdateOrder(r.id, r.posOrderData, n).then((l) => l(t, e));
    }
  };
};
class ta extends v {
  /**
   * 
   * @summary Creating an order
   * @param {AccountPOSApiAccountPosOrderControllerCreateOrderRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountPOSApi
   */
  createOrder(e, t) {
    return je(this.configuration).accountPosOrderControllerCreateOrder(e.id, e.posOrderData, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting a list of account orders
   * @param {AccountPOSApiAccountPosOrderControllerGetAccountOrdersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountPOSApi
   */
  getAccountOrders(e, t) {
    return je(this.configuration).accountPosOrderControllerGetAccountOrders(e.limit, e.page, e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update order
   * @param {AccountPOSApiAccountPosOrderControllerUpdateOrderRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountPOSApi
   */
  updateOrder(e, t) {
    return je(this.configuration).accountPosOrderControllerUpdateOrder(e.id, e.posOrderData, t).then((o) => o(this.axios, this.basePath));
  }
}
const ra = function(a) {
  return {
    /**
     * 
     * @summary Getting a last binary position
     * @param {number} id 
     * @param {number} [treeId] 
     * @param {number} [positionId] 
     * @param {Array<string>} [properties] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPositionControllerGetLastBinaryPosition: async (e, t, o, r, n = {}) => {
      p("accountPositionControllerGetLastBinaryPosition", "id", e);
      const l = "/api3/account/{id}/position/last-binary".replace("{id}", encodeURIComponent(String(e))), s = new URL(l, y);
      let i;
      a && (i = a.baseOptions);
      const c = { method: "GET", ...i, ...n }, d = {}, h = {};
      await P(d, a), t !== void 0 && (h.treeId = t), o !== void 0 && (h.positionId = o), r && (h.properties = r), m(s, h);
      let f = i && i.headers ? i.headers : {};
      return c.headers = { ...d, ...f, ...n.headers }, {
        url: O(s),
        options: c
      };
    },
    /**
     * 
     * @summary Getting a list of account positions
     * @param {number} id 
     * @param {number} [treeId] 
     * @param {Array<string>} [properties] 
     * @param {number} [offset] 
     * @param {number} [numberPeriodsBack] 
     * @param {number} [periodId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPositionControllerGetPosition: async (e, t, o, r, n, l, s = {}) => {
      p("accountPositionControllerGetPosition", "id", e);
      const i = "/api3/account/{id}/position".replace("{id}", encodeURIComponent(String(e))), c = new URL(i, y);
      let d;
      a && (d = a.baseOptions);
      const h = { method: "GET", ...d, ...s }, f = {}, R = {};
      await P(f, a), t !== void 0 && (R.treeId = t), o && (R.properties = o), r !== void 0 && (R.offset = r), n !== void 0 && (R.numberPeriodsBack = n), l !== void 0 && (R.periodId = l), m(c, R);
      let A = d && d.headers ? d.headers : {};
      return h.headers = { ...f, ...A, ...s.headers }, {
        url: O(c),
        options: h
      };
    },
    /**
     * 
     * @summary Changes the frontline\'s sponsor
     * @param {any} positionId 
     * @param {ChangeSponsorFrontlineReq} changeSponsorFrontlineReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeSponsorControllerChangeFrontlineSponsor: async (e, t, o = {}) => {
      p("changeSponsorControllerChangeFrontlineSponsor", "positionId", e), p("changeSponsorControllerChangeFrontlineSponsor", "changeSponsorFrontlineReq", t);
      const r = "/api3/account/{id}/position/{positionId}/change-sponsor/frontline".replace("{positionId}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "POST", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Changes the position sponsor
     * @param {any} positionId 
     * @param {ChangeSponsorReq} changeSponsorReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeSponsorControllerChangeSponsor: async (e, t, o = {}) => {
      p("changeSponsorControllerChangeSponsor", "positionId", e), p("changeSponsorControllerChangeSponsor", "changeSponsorReq", t);
      const r = "/api3/account/{id}/position/{positionId}/change-sponsor".replace("{positionId}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "POST", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, ce = function(a) {
  const e = ra(a);
  return {
    /**
     * 
     * @summary Getting a last binary position
     * @param {number} id 
     * @param {number} [treeId] 
     * @param {number} [positionId] 
     * @param {Array<string>} [properties] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountPositionControllerGetLastBinaryPosition(t, o, r, n, l) {
      const s = await e.accountPositionControllerGetLastBinaryPosition(t, o, r, n, l);
      return V(s, u, C, a);
    },
    /**
     * 
     * @summary Getting a list of account positions
     * @param {number} id 
     * @param {number} [treeId] 
     * @param {Array<string>} [properties] 
     * @param {number} [offset] 
     * @param {number} [numberPeriodsBack] 
     * @param {number} [periodId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountPositionControllerGetPosition(t, o, r, n, l, s, i) {
      const c = await e.accountPositionControllerGetPosition(t, o, r, n, l, s, i);
      return V(c, u, C, a);
    },
    /**
     * 
     * @summary Changes the frontline\'s sponsor
     * @param {any} positionId 
     * @param {ChangeSponsorFrontlineReq} changeSponsorFrontlineReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async changeSponsorControllerChangeFrontlineSponsor(t, o, r) {
      const n = await e.changeSponsorControllerChangeFrontlineSponsor(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Changes the position sponsor
     * @param {any} positionId 
     * @param {ChangeSponsorReq} changeSponsorReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async changeSponsorControllerChangeSponsor(t, o, r) {
      const n = await e.changeSponsorControllerChangeSponsor(t, o, r);
      return V(n, u, C, a);
    }
  };
}, Hl = function(a, e, t) {
  const o = ce(a);
  return {
    /**
     * 
     * @summary Getting a last binary position
     * @param {AccountPositionApiAccountPositionControllerGetLastBinaryPositionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPositionControllerGetLastBinaryPosition(r, n) {
      return o.accountPositionControllerGetLastBinaryPosition(r.id, r.treeId, r.positionId, r.properties, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting a list of account positions
     * @param {AccountPositionApiAccountPositionControllerGetPositionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPositionControllerGetPosition(r, n) {
      return o.accountPositionControllerGetPosition(r.id, r.treeId, r.properties, r.offset, r.numberPeriodsBack, r.periodId, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Changes the frontline\'s sponsor
     * @param {AccountPositionApiChangeSponsorControllerChangeFrontlineSponsorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeSponsorControllerChangeFrontlineSponsor(r, n) {
      return o.changeSponsorControllerChangeFrontlineSponsor(r.positionId, r.changeSponsorFrontlineReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Changes the position sponsor
     * @param {AccountPositionApiChangeSponsorControllerChangeSponsorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeSponsorControllerChangeSponsor(r, n) {
      return o.changeSponsorControllerChangeSponsor(r.positionId, r.changeSponsorReq, n).then((l) => l(t, e));
    }
  };
};
class oa extends v {
  /**
   * 
   * @summary Getting a last binary position
   * @param {AccountPositionApiAccountPositionControllerGetLastBinaryPositionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountPositionApi
   */
  getLastBinaryPosition(e, t) {
    return ce(this.configuration).accountPositionControllerGetLastBinaryPosition(e.id, e.treeId, e.positionId, e.properties, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting a list of account positions
   * @param {AccountPositionApiAccountPositionControllerGetPositionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountPositionApi
   */
  getPosition(e, t) {
    return ce(this.configuration).accountPositionControllerGetPosition(e.id, e.treeId, e.properties, e.offset, e.numberPeriodsBack, e.periodId, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Changes the frontline\'s sponsor
   * @param {AccountPositionApiChangeSponsorControllerChangeFrontlineSponsorRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountPositionApi
   */
  changeFrontlineSponsor(e, t) {
    return ce(this.configuration).changeSponsorControllerChangeFrontlineSponsor(e.positionId, e.changeSponsorFrontlineReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Changes the position sponsor
   * @param {AccountPositionApiChangeSponsorControllerChangeSponsorRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountPositionApi
   */
  changeSponsor(e, t) {
    return ce(this.configuration).changeSponsorControllerChangeSponsor(e.positionId, e.changeSponsorReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const aa = function(a) {
  return {
    /**
     * 
     * @summary Checking a field for confirmation
     * @param {string} alias 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmationControllerIsConfirmed: async (e, t, o = {}) => {
      p("confirmationControllerIsConfirmed", "alias", e), p("confirmationControllerIsConfirmed", "id", t);
      const r = "/api3/account/{id}/{alias}-confirm".replace("{alias}", encodeURIComponent(String(e))).replace("{id}", encodeURIComponent(String(t))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      await P(i, a), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Setting the field confirmation
     * @param {string} alias 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmationControllerSetConfirmed: async (e, t, o = {}) => {
      p("confirmationControllerSetConfirmed", "alias", e), p("confirmationControllerSetConfirmed", "id", t);
      const r = "/api3/account/{id}/{alias}-confirm".replace("{alias}", encodeURIComponent(String(e))).replace("{id}", encodeURIComponent(String(t))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Setting a password
     * @param {SetPasswordReq} setPasswordReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    passwordControllerSetPassword: async (e, t = {}) => {
      p("passwordControllerSetPassword", "setPasswordReq", e);
      const o = "/api3/account/set-password", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Setting a password
     * @param {number} id 
     * @param {SetPasswordByIdReq} setPasswordByIdReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    passwordControllerSetPasswordById: async (e, t, o = {}) => {
      p("passwordControllerSetPasswordById", "id", e), p("passwordControllerSetPasswordById", "setPasswordByIdReq", t);
      const r = "/api3/account/{id}/set-password".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "POST", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Removing the value of the profile field with the passed alias
     * @param {string} alias 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileControllerDeleteProfileField: async (e, t, o = {}) => {
      p("profileControllerDeleteProfileField", "alias", e), p("profileControllerDeleteProfileField", "id", t);
      const r = "/api3/account/{id}/profile/{alias}".replace("{alias}", encodeURIComponent(String(e))).replace("{id}", encodeURIComponent(String(t))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "DELETE", ...l, ...o }, i = {}, c = {};
      await P(i, a), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Returns the list of values of the profile fields
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileControllerGetProfile: async (e, t = {}) => {
      p("profileControllerGetProfile", "id", e);
      const o = "/api3/account/{id}/profile".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns the value of the field with the passed alias
     * @param {string} alias 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileControllerGetProfileField: async (e, t, o = {}) => {
      p("profileControllerGetProfileField", "alias", e), p("profileControllerGetProfileField", "id", t);
      const r = "/api3/account/{id}/profile/{alias}".replace("{alias}", encodeURIComponent(String(e))).replace("{id}", encodeURIComponent(String(t))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      await P(i, a), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Sets the profile fields
     * @param {number} id 
     * @param {SetProfileReq} setProfileReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileControllerSetProfile: async (e, t, o = {}) => {
      p("profileControllerSetProfile", "id", e), p("profileControllerSetProfile", "setProfileReq", t);
      const r = "/api3/account/{id}/profile".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Sets the value of the field with the passed alias
     * @param {string} alias 
     * @param {number} id 
     * @param {SetProfileValueReq} setProfileValueReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileControllerSetProfileField: async (e, t, o, r = {}) => {
      p("profileControllerSetProfileField", "alias", e), p("profileControllerSetProfileField", "id", t), p("profileControllerSetProfileField", "setProfileValueReq", o);
      const n = "/api3/account/{id}/profile/{alias}".replace("{alias}", encodeURIComponent(String(e))).replace("{id}", encodeURIComponent(String(t))), l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "PUT", ...s, ...r }, c = {}, d = {};
      await P(c, a), c["Content-Type"] = "application/json", m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, i.data = S(o, i, a), {
        url: O(l),
        options: i
      };
    }
  };
}, H = function(a) {
  const e = aa(a);
  return {
    /**
     * 
     * @summary Checking a field for confirmation
     * @param {string} alias 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async confirmationControllerIsConfirmed(t, o, r) {
      const n = await e.confirmationControllerIsConfirmed(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Setting the field confirmation
     * @param {string} alias 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async confirmationControllerSetConfirmed(t, o, r) {
      const n = await e.confirmationControllerSetConfirmed(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Setting a password
     * @param {SetPasswordReq} setPasswordReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async passwordControllerSetPassword(t, o) {
      const r = await e.passwordControllerSetPassword(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Setting a password
     * @param {number} id 
     * @param {SetPasswordByIdReq} setPasswordByIdReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async passwordControllerSetPasswordById(t, o, r) {
      const n = await e.passwordControllerSetPasswordById(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Removing the value of the profile field with the passed alias
     * @param {string} alias 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profileControllerDeleteProfileField(t, o, r) {
      const n = await e.profileControllerDeleteProfileField(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Returns the list of values of the profile fields
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profileControllerGetProfile(t, o) {
      const r = await e.profileControllerGetProfile(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns the value of the field with the passed alias
     * @param {string} alias 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profileControllerGetProfileField(t, o, r) {
      const n = await e.profileControllerGetProfileField(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Sets the profile fields
     * @param {number} id 
     * @param {SetProfileReq} setProfileReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profileControllerSetProfile(t, o, r) {
      const n = await e.profileControllerSetProfile(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Sets the value of the field with the passed alias
     * @param {string} alias 
     * @param {number} id 
     * @param {SetProfileValueReq} setProfileValueReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profileControllerSetProfileField(t, o, r, n) {
      const l = await e.profileControllerSetProfileField(t, o, r, n);
      return V(l, u, C, a);
    }
  };
}, Ql = function(a, e, t) {
  const o = H(a);
  return {
    /**
     * 
     * @summary Checking a field for confirmation
     * @param {AccountProfileApiConfirmationControllerIsConfirmedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmationControllerIsConfirmed(r, n) {
      return o.confirmationControllerIsConfirmed(r.alias, r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Setting the field confirmation
     * @param {AccountProfileApiConfirmationControllerSetConfirmedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmationControllerSetConfirmed(r, n) {
      return o.confirmationControllerSetConfirmed(r.alias, r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Setting a password
     * @param {AccountProfileApiPasswordControllerSetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    passwordControllerSetPassword(r, n) {
      return o.passwordControllerSetPassword(r.setPasswordReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Setting a password
     * @param {AccountProfileApiPasswordControllerSetPasswordByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    passwordControllerSetPasswordById(r, n) {
      return o.passwordControllerSetPasswordById(r.id, r.setPasswordByIdReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Removing the value of the profile field with the passed alias
     * @param {AccountProfileApiProfileControllerDeleteProfileFieldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileControllerDeleteProfileField(r, n) {
      return o.profileControllerDeleteProfileField(r.alias, r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns the list of values of the profile fields
     * @param {AccountProfileApiProfileControllerGetProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileControllerGetProfile(r, n) {
      return o.profileControllerGetProfile(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns the value of the field with the passed alias
     * @param {AccountProfileApiProfileControllerGetProfileFieldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileControllerGetProfileField(r, n) {
      return o.profileControllerGetProfileField(r.alias, r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Sets the profile fields
     * @param {AccountProfileApiProfileControllerSetProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileControllerSetProfile(r, n) {
      return o.profileControllerSetProfile(r.id, r.setProfileReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Sets the value of the field with the passed alias
     * @param {AccountProfileApiProfileControllerSetProfileFieldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileControllerSetProfileField(r, n) {
      return o.profileControllerSetProfileField(r.alias, r.id, r.setProfileValueReq, n).then((l) => l(t, e));
    }
  };
};
class na extends v {
  /**
   * 
   * @summary Checking a field for confirmation
   * @param {AccountProfileApiConfirmationControllerIsConfirmedRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountProfileApi
   */
  isConfirmed(e, t) {
    return H(this.configuration).confirmationControllerIsConfirmed(e.alias, e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Setting the field confirmation
   * @param {AccountProfileApiConfirmationControllerSetConfirmedRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountProfileApi
   */
  setConfirmed(e, t) {
    return H(this.configuration).confirmationControllerSetConfirmed(e.alias, e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Setting a password
   * @param {AccountProfileApiPasswordControllerSetPasswordRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountProfileApi
   */
  setPassword(e, t) {
    return H(this.configuration).passwordControllerSetPassword(e.setPasswordReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Setting a password
   * @param {AccountProfileApiPasswordControllerSetPasswordByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountProfileApi
   */
  setPasswordById(e, t) {
    return H(this.configuration).passwordControllerSetPasswordById(e.id, e.setPasswordByIdReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Removing the value of the profile field with the passed alias
   * @param {AccountProfileApiProfileControllerDeleteProfileFieldRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountProfileApi
   */
  deleteProfileField(e, t) {
    return H(this.configuration).profileControllerDeleteProfileField(e.alias, e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns the list of values of the profile fields
   * @param {AccountProfileApiProfileControllerGetProfileRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountProfileApi
   */
  getProfile(e, t) {
    return H(this.configuration).profileControllerGetProfile(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns the value of the field with the passed alias
   * @param {AccountProfileApiProfileControllerGetProfileFieldRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountProfileApi
   */
  getProfileField(e, t) {
    return H(this.configuration).profileControllerGetProfileField(e.alias, e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Sets the profile fields
   * @param {AccountProfileApiProfileControllerSetProfileRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountProfileApi
   */
  setProfile(e, t) {
    return H(this.configuration).profileControllerSetProfile(e.id, e.setProfileReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Sets the value of the field with the passed alias
   * @param {AccountProfileApiProfileControllerSetProfileFieldRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountProfileApi
   */
  setProfileField(e, t) {
    return H(this.configuration).profileControllerSetProfileField(e.alias, e.id, e.setProfileValueReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const la = function(a) {
  return {
    /**
     * 
     * @summary Getting the account properties
     * @param {any} id 
     * @param {number} [positionOffset] 
     * @param {string} [properties] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPropertyControllerGetProperties: async (e, t, o, r = {}) => {
      p("accountPropertyControllerGetProperties", "id", e);
      const n = "/api3/account/{id}/property".replace("{id}", encodeURIComponent(String(e))), l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "GET", ...s, ...r }, c = {}, d = {};
      await P(c, a), t !== void 0 && (d.positionOffset = t), o !== void 0 && (d.properties = o), m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, {
        url: O(l),
        options: i
      };
    },
    /**
     * 
     * @summary Getting the history of account properties
     * @param {number} limit 
     * @param {number} page 
     * @param {any} id 
     * @param {number} [positionOffset] 
     * @param {Array<string>} [properties] 
     * @param {boolean} [includeCurrent] 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPropertyControllerGetPropertiesHistory: async (e, t, o, r, n, l, s, i, c = {}) => {
      p("accountPropertyControllerGetPropertiesHistory", "limit", e), p("accountPropertyControllerGetPropertiesHistory", "page", t), p("accountPropertyControllerGetPropertiesHistory", "id", o);
      const d = "/api3/account/{id}/property/history".replace("{id}", encodeURIComponent(String(o))), h = new URL(d, y);
      let f;
      a && (f = a.baseOptions);
      const R = { method: "GET", ...f, ...c }, A = {}, w = {};
      await P(A, a), e !== void 0 && (w.limit = e), t !== void 0 && (w.page = t), r !== void 0 && (w.positionOffset = r), n && (w.properties = n), l !== void 0 && (w.includeCurrent = l), s !== void 0 && (w.orderBy = s), i !== void 0 && (w.filter = i), m(h, w);
      let T = f && f.headers ? f.headers : {};
      return R.headers = { ...A, ...T, ...c.headers }, {
        url: O(h),
        options: R
      };
    },
    /**
     * 
     * @summary Getting the account property
     * @param {number} propertyId 
     * @param {any} id 
     * @param {number} [positionOffset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPropertyControllerGetProperty: async (e, t, o, r = {}) => {
      p("accountPropertyControllerGetProperty", "propertyId", e), p("accountPropertyControllerGetProperty", "id", t);
      const n = "/api3/account/{id}/property/{propertyId}".replace("{propertyId}", encodeURIComponent(String(e))).replace("{id}", encodeURIComponent(String(t))), l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "GET", ...s, ...r }, c = {}, d = {};
      await P(c, a), o !== void 0 && (d.positionOffset = o), m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, {
        url: O(l),
        options: i
      };
    },
    /**
     * 
     * @summary Getting the history of the account property
     * @param {number} propertyId 
     * @param {number} limit 
     * @param {number} page 
     * @param {any} id 
     * @param {number} [positionOffset] 
     * @param {boolean} [includeCurrent] 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPropertyControllerGetPropertyHistory: async (e, t, o, r, n, l, s, i, c = {}) => {
      p("accountPropertyControllerGetPropertyHistory", "propertyId", e), p("accountPropertyControllerGetPropertyHistory", "limit", t), p("accountPropertyControllerGetPropertyHistory", "page", o), p("accountPropertyControllerGetPropertyHistory", "id", r);
      const d = "/api3/account/{id}/property/{propertyId}/history".replace("{propertyId}", encodeURIComponent(String(e))).replace("{id}", encodeURIComponent(String(r))), h = new URL(d, y);
      let f;
      a && (f = a.baseOptions);
      const R = { method: "GET", ...f, ...c }, A = {}, w = {};
      await P(A, a), t !== void 0 && (w.limit = t), o !== void 0 && (w.page = o), n !== void 0 && (w.positionOffset = n), l !== void 0 && (w.includeCurrent = l), s !== void 0 && (w.orderBy = s), i !== void 0 && (w.filter = i), m(h, w);
      let T = f && f.headers ? f.headers : {};
      return R.headers = { ...A, ...T, ...c.headers }, {
        url: O(h),
        options: R
      };
    },
    /**
     * 
     * @summary Sets the account plan property
     * @param {any} id 
     * @param {any} propertyId 
     * @param {EditPropertyReq} editPropertyReq 
     * @param {boolean} [directEdit] 
     * @param {any} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPropertyControllerSetProperty: async (e, t, o, r, n, l = {}) => {
      p("accountPropertyControllerSetProperty", "id", e), p("accountPropertyControllerSetProperty", "propertyId", t), p("accountPropertyControllerSetProperty", "editPropertyReq", o);
      const s = "/api3/account/{id}/property/{propertyId}".replace("{id}", encodeURIComponent(String(e))).replace("{propertyId}", encodeURIComponent(String(t))), i = new URL(s, y);
      let c;
      a && (c = a.baseOptions);
      const d = { method: "PUT", ...c, ...l }, h = {}, f = {};
      await P(h, a), r !== void 0 && (f.directEdit = r), n !== void 0 && (f.offset = n), h["Content-Type"] = "application/json", m(i, f);
      let R = c && c.headers ? c.headers : {};
      return d.headers = { ...h, ...R, ...l.headers }, d.data = S(o, d, a), {
        url: O(i),
        options: d
      };
    }
  };
}, ee = function(a) {
  const e = la(a);
  return {
    /**
     * 
     * @summary Getting the account properties
     * @param {any} id 
     * @param {number} [positionOffset] 
     * @param {string} [properties] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountPropertyControllerGetProperties(t, o, r, n) {
      const l = await e.accountPropertyControllerGetProperties(t, o, r, n);
      return V(l, u, C, a);
    },
    /**
     * 
     * @summary Getting the history of account properties
     * @param {number} limit 
     * @param {number} page 
     * @param {any} id 
     * @param {number} [positionOffset] 
     * @param {Array<string>} [properties] 
     * @param {boolean} [includeCurrent] 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountPropertyControllerGetPropertiesHistory(t, o, r, n, l, s, i, c, d) {
      const h = await e.accountPropertyControllerGetPropertiesHistory(t, o, r, n, l, s, i, c, d);
      return V(h, u, C, a);
    },
    /**
     * 
     * @summary Getting the account property
     * @param {number} propertyId 
     * @param {any} id 
     * @param {number} [positionOffset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountPropertyControllerGetProperty(t, o, r, n) {
      const l = await e.accountPropertyControllerGetProperty(t, o, r, n);
      return V(l, u, C, a);
    },
    /**
     * 
     * @summary Getting the history of the account property
     * @param {number} propertyId 
     * @param {number} limit 
     * @param {number} page 
     * @param {any} id 
     * @param {number} [positionOffset] 
     * @param {boolean} [includeCurrent] 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountPropertyControllerGetPropertyHistory(t, o, r, n, l, s, i, c, d) {
      const h = await e.accountPropertyControllerGetPropertyHistory(t, o, r, n, l, s, i, c, d);
      return V(h, u, C, a);
    },
    /**
     * 
     * @summary Sets the account plan property
     * @param {any} id 
     * @param {any} propertyId 
     * @param {EditPropertyReq} editPropertyReq 
     * @param {boolean} [directEdit] 
     * @param {any} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountPropertyControllerSetProperty(t, o, r, n, l, s) {
      const i = await e.accountPropertyControllerSetProperty(t, o, r, n, l, s);
      return V(i, u, C, a);
    }
  };
}, Wl = function(a, e, t) {
  const o = ee(a);
  return {
    /**
     * 
     * @summary Getting the account properties
     * @param {AccountPropertiesApiAccountPropertyControllerGetPropertiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPropertyControllerGetProperties(r, n) {
      return o.accountPropertyControllerGetProperties(r.id, r.positionOffset, r.properties, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting the history of account properties
     * @param {AccountPropertiesApiAccountPropertyControllerGetPropertiesHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPropertyControllerGetPropertiesHistory(r, n) {
      return o.accountPropertyControllerGetPropertiesHistory(r.limit, r.page, r.id, r.positionOffset, r.properties, r.includeCurrent, r.orderBy, r.filter, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting the account property
     * @param {AccountPropertiesApiAccountPropertyControllerGetPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPropertyControllerGetProperty(r, n) {
      return o.accountPropertyControllerGetProperty(r.propertyId, r.id, r.positionOffset, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting the history of the account property
     * @param {AccountPropertiesApiAccountPropertyControllerGetPropertyHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPropertyControllerGetPropertyHistory(r, n) {
      return o.accountPropertyControllerGetPropertyHistory(r.propertyId, r.limit, r.page, r.id, r.positionOffset, r.includeCurrent, r.orderBy, r.filter, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Sets the account plan property
     * @param {AccountPropertiesApiAccountPropertyControllerSetPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPropertyControllerSetProperty(r, n) {
      return o.accountPropertyControllerSetProperty(r.id, r.propertyId, r.editPropertyReq, r.directEdit, r.offset, n).then((l) => l(t, e));
    }
  };
};
class sa extends v {
  /**
   * 
   * @summary Getting the account properties
   * @param {AccountPropertiesApiAccountPropertyControllerGetPropertiesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountPropertiesApi
   */
  getProperties(e, t) {
    return ee(this.configuration).accountPropertyControllerGetProperties(e.id, e.positionOffset, e.properties, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting the history of account properties
   * @param {AccountPropertiesApiAccountPropertyControllerGetPropertiesHistoryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountPropertiesApi
   */
  getPropertiesHistory(e, t) {
    return ee(this.configuration).accountPropertyControllerGetPropertiesHistory(e.limit, e.page, e.id, e.positionOffset, e.properties, e.includeCurrent, e.orderBy, e.filter, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting the account property
   * @param {AccountPropertiesApiAccountPropertyControllerGetPropertyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountPropertiesApi
   */
  getProperty(e, t) {
    return ee(this.configuration).accountPropertyControllerGetProperty(e.propertyId, e.id, e.positionOffset, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting the history of the account property
   * @param {AccountPropertiesApiAccountPropertyControllerGetPropertyHistoryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountPropertiesApi
   */
  getPropertyHistory(e, t) {
    return ee(this.configuration).accountPropertyControllerGetPropertyHistory(e.propertyId, e.limit, e.page, e.id, e.positionOffset, e.includeCurrent, e.orderBy, e.filter, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Sets the account plan property
   * @param {AccountPropertiesApiAccountPropertyControllerSetPropertyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountPropertiesApi
   */
  setProperty(e, t) {
    return ee(this.configuration).accountPropertyControllerSetProperty(e.id, e.propertyId, e.editPropertyReq, e.directEdit, e.offset, t).then((o) => o(this.axios, this.basePath));
  }
}
const ia = function(a) {
  return {
    /**
     * 
     * @summary Returns the account by external id
     * @param {string} externalId 
     * @param {boolean} [showInactive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchControllerGetAccountByExternalId: async (e, t, o = {}) => {
      p("searchControllerGetAccountByExternalId", "externalId", e);
      const r = "/api3/account/search/by-external-id", n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      e !== void 0 && (c.externalId = e), t !== void 0 && (c.showInactive = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Returns the account by id
     * @param {number} id 
     * @param {boolean} [showInactive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchControllerGetAccountById: async (e, t, o = {}) => {
      p("searchControllerGetAccountById", "id", e);
      const r = "/api3/account/search/by-id", n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      e !== void 0 && (c.id = e), t !== void 0 && (c.showInactive = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Returns the account by invite code
     * @param {string} inviteCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchControllerGetAccountByInviteCode: async (e, t = {}) => {
      p("searchControllerGetAccountByInviteCode", "inviteCode", e);
      const o = "/api3/account/search/by-invite-code", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      e !== void 0 && (i.inviteCode = e), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns the account by login
     * @param {string} login 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchControllerGetAccountByLogin: async (e, t = {}) => {
      p("searchControllerGetAccountByLogin", "login", e);
      const o = "/api3/account/search/by-login", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      await P(s, a), e !== void 0 && (i.login = e), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Performs an account search
     * @param {string} searchText 
     * @param {boolean} [networkSearch] 
     * @param {boolean} [showDisabledAccounts] Show disabled accounts
     * @param {Array<string>} [profileFields] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchControllerSearchAccount: async (e, t, o, r, n = {}) => {
      p("searchControllerSearchAccount", "searchText", e);
      const l = "/api3/account/search", s = new URL(l, y);
      let i;
      a && (i = a.baseOptions);
      const c = { method: "GET", ...i, ...n }, d = {}, h = {};
      await P(d, a), e !== void 0 && (h.searchText = e), t !== void 0 && (h.networkSearch = t), o !== void 0 && (h.showDisabledAccounts = o), r && (h.profileFields = r), m(s, h);
      let f = i && i.headers ? i.headers : {};
      return c.headers = { ...d, ...f, ...n.headers }, {
        url: O(s),
        options: c
      };
    }
  };
}, te = function(a) {
  const e = ia(a);
  return {
    /**
     * 
     * @summary Returns the account by external id
     * @param {string} externalId 
     * @param {boolean} [showInactive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchControllerGetAccountByExternalId(t, o, r) {
      const n = await e.searchControllerGetAccountByExternalId(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Returns the account by id
     * @param {number} id 
     * @param {boolean} [showInactive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchControllerGetAccountById(t, o, r) {
      const n = await e.searchControllerGetAccountById(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Returns the account by invite code
     * @param {string} inviteCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchControllerGetAccountByInviteCode(t, o) {
      const r = await e.searchControllerGetAccountByInviteCode(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns the account by login
     * @param {string} login 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchControllerGetAccountByLogin(t, o) {
      const r = await e.searchControllerGetAccountByLogin(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Performs an account search
     * @param {string} searchText 
     * @param {boolean} [networkSearch] 
     * @param {boolean} [showDisabledAccounts] Show disabled accounts
     * @param {Array<string>} [profileFields] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchControllerSearchAccount(t, o, r, n, l) {
      const s = await e.searchControllerSearchAccount(t, o, r, n, l);
      return V(s, u, C, a);
    }
  };
}, $l = function(a, e, t) {
  const o = te(a);
  return {
    /**
     * 
     * @summary Returns the account by external id
     * @param {AccountSearchApiSearchControllerGetAccountByExternalIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchControllerGetAccountByExternalId(r, n) {
      return o.searchControllerGetAccountByExternalId(r.externalId, r.showInactive, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns the account by id
     * @param {AccountSearchApiSearchControllerGetAccountByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchControllerGetAccountById(r, n) {
      return o.searchControllerGetAccountById(r.id, r.showInactive, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns the account by invite code
     * @param {AccountSearchApiSearchControllerGetAccountByInviteCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchControllerGetAccountByInviteCode(r, n) {
      return o.searchControllerGetAccountByInviteCode(r.inviteCode, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns the account by login
     * @param {AccountSearchApiSearchControllerGetAccountByLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchControllerGetAccountByLogin(r, n) {
      return o.searchControllerGetAccountByLogin(r.login, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Performs an account search
     * @param {AccountSearchApiSearchControllerSearchAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchControllerSearchAccount(r, n) {
      return o.searchControllerSearchAccount(r.searchText, r.networkSearch, r.showDisabledAccounts, r.profileFields, n).then((l) => l(t, e));
    }
  };
};
class ca extends v {
  /**
   * 
   * @summary Returns the account by external id
   * @param {AccountSearchApiSearchControllerGetAccountByExternalIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountSearchApi
   */
  getAccountByExternalId(e, t) {
    return te(this.configuration).searchControllerGetAccountByExternalId(e.externalId, e.showInactive, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns the account by id
   * @param {AccountSearchApiSearchControllerGetAccountByIdRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountSearchApi
   */
  getAccountById(e, t) {
    return te(this.configuration).searchControllerGetAccountById(e.id, e.showInactive, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns the account by invite code
   * @param {AccountSearchApiSearchControllerGetAccountByInviteCodeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountSearchApi
   */
  getAccountByInviteCode(e, t) {
    return te(this.configuration).searchControllerGetAccountByInviteCode(e.inviteCode, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns the account by login
   * @param {AccountSearchApiSearchControllerGetAccountByLoginRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountSearchApi
   */
  getAccountByLogin(e, t) {
    return te(this.configuration).searchControllerGetAccountByLogin(e.login, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Performs an account search
   * @param {AccountSearchApiSearchControllerSearchAccountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountSearchApi
   */
  searchAccount(e, t) {
    return te(this.configuration).searchControllerSearchAccount(e.searchText, e.networkSearch, e.showDisabledAccounts, e.profileFields, t).then((o) => o(this.axios, this.basePath));
  }
}
const da = function(a) {
  return {
    /**
     * 
     * @summary Send support mail
     * @param {SendSupportMailReq} sendSupportMailReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendControllerSendSupportMail: async (e, t = {}) => {
      p("sendControllerSendSupportMail", "sendSupportMailReq", e);
      const o = "/api3/account/send/support-mail", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    }
  };
}, ir = function(a) {
  const e = da(a);
  return {
    /**
     * 
     * @summary Send support mail
     * @param {SendSupportMailReq} sendSupportMailReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendControllerSendSupportMail(t, o) {
      const r = await e.sendControllerSendSupportMail(t, o);
      return V(r, u, C, a);
    }
  };
}, Nl = function(a, e, t) {
  const o = ir(a);
  return {
    /**
     * 
     * @summary Send support mail
     * @param {AccountSendApiSendControllerSendSupportMailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendControllerSendSupportMail(r, n) {
      return o.sendControllerSendSupportMail(r.sendSupportMailReq, n).then((l) => l(t, e));
    }
  };
};
class pa extends v {
  /**
   * 
   * @summary Send support mail
   * @param {AccountSendApiSendControllerSendSupportMailRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountSendApi
   */
  sendSupportMail(e, t) {
    return ir(this.configuration).sendControllerSendSupportMail(e.sendSupportMailReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const ha = function(a) {
  return {
    /**
     * 
     * @summary Getting the account transaction log
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {any} [docId] 
     * @param {string} [documentType] 
     * @param {any} [periodId] 
     * @param {string} [planProperty] 
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountTransactionLogControllerGetAccountTransactionLog: async (e, t, o, r, n, l, s, i, c = {}) => {
      p("accountTransactionLogControllerGetAccountTransactionLog", "limit", e), p("accountTransactionLogControllerGetAccountTransactionLog", "page", t), p("accountTransactionLogControllerGetAccountTransactionLog", "id", o);
      const d = "/api3/account/{id}/transaction-log".replace("{id}", encodeURIComponent(String(o))), h = new URL(d, y);
      let f;
      a && (f = a.baseOptions);
      const R = { method: "GET", ...f, ...c }, A = {}, w = {};
      await P(A, a), e !== void 0 && (w.limit = e), t !== void 0 && (w.page = t), r !== void 0 && (w.docId = r), n !== void 0 && (w.documentType = n), l !== void 0 && (w.periodId = l), s !== void 0 && (w.planProperty = s), i !== void 0 && (w.filter = i), m(h, w);
      let T = f && f.headers ? f.headers : {};
      return R.headers = { ...A, ...T, ...c.headers }, {
        url: O(h),
        options: R
      };
    }
  };
}, cr = function(a) {
  const e = ha(a);
  return {
    /**
     * 
     * @summary Getting the account transaction log
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {any} [docId] 
     * @param {string} [documentType] 
     * @param {any} [periodId] 
     * @param {string} [planProperty] 
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountTransactionLogControllerGetAccountTransactionLog(t, o, r, n, l, s, i, c, d) {
      const h = await e.accountTransactionLogControllerGetAccountTransactionLog(t, o, r, n, l, s, i, c, d);
      return V(h, u, C, a);
    }
  };
}, _l = function(a, e, t) {
  const o = cr(a);
  return {
    /**
     * 
     * @summary Getting the account transaction log
     * @param {AccountTransactionLogApiAccountTransactionLogControllerGetAccountTransactionLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountTransactionLogControllerGetAccountTransactionLog(r, n) {
      return o.accountTransactionLogControllerGetAccountTransactionLog(r.limit, r.page, r.id, r.docId, r.documentType, r.periodId, r.planProperty, r.filter, n).then((l) => l(t, e));
    }
  };
};
class ua extends v {
  /**
   * 
   * @summary Getting the account transaction log
   * @param {AccountTransactionLogApiAccountTransactionLogControllerGetAccountTransactionLogRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountTransactionLogApi
   */
  getAccountTransactionLog(e, t) {
    return cr(this.configuration).accountTransactionLogControllerGetAccountTransactionLog(e.limit, e.page, e.id, e.docId, e.documentType, e.periodId, e.planProperty, e.filter, t).then((o) => o(this.axios, this.basePath));
  }
}
const Ca = function(a) {
  return {
    /**
     * Please use the /account/:id/property/:propertyId method
     * @summary Sets the account plan property
     * @param {number} id 
     * @param {number} treeId 
     * @param {number} propertyId 
     * @param {EditPropertyReq} editPropertyReq 
     * @param {boolean} [directEdit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    accountTreeControllerSetAccountProperty: async (e, t, o, r, n, l, s = {}) => {
      p("accountTreeControllerSetAccountProperty", "id", e), p("accountTreeControllerSetAccountProperty", "treeId", t), p("accountTreeControllerSetAccountProperty", "propertyId", o), p("accountTreeControllerSetAccountProperty", "editPropertyReq", r);
      const i = "/api3/account/{id}/tree/{treeId}/property/{propertyId}".replace("{id}", encodeURIComponent(String(e))).replace("{treeId}", encodeURIComponent(String(t))).replace("{propertyId}", encodeURIComponent(String(o))), c = new URL(i, y);
      let d;
      a && (d = a.baseOptions);
      const h = { method: "PUT", ...d, ...s }, f = {}, R = {};
      await P(f, a), n !== void 0 && (R.directEdit = n), l !== void 0 && (R.offset = l), f["Content-Type"] = "application/json", m(c, R);
      let A = d && d.headers ? d.headers : {};
      return h.headers = { ...f, ...A, ...s.headers }, h.data = S(r, h, a), {
        url: O(c),
        options: h
      };
    }
  };
}, dr = function(a) {
  const e = Ca(a);
  return {
    /**
     * Please use the /account/:id/property/:propertyId method
     * @summary Sets the account plan property
     * @param {number} id 
     * @param {number} treeId 
     * @param {number} propertyId 
     * @param {EditPropertyReq} editPropertyReq 
     * @param {boolean} [directEdit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async accountTreeControllerSetAccountProperty(t, o, r, n, l, s, i) {
      const c = await e.accountTreeControllerSetAccountProperty(t, o, r, n, l, s, i);
      return V(c, u, C, a);
    }
  };
}, Ml = function(a, e, t) {
  const o = dr(a);
  return {
    /**
     * Please use the /account/:id/property/:propertyId method
     * @summary Sets the account plan property
     * @param {AccountTreesApiAccountTreeControllerSetAccountPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    accountTreeControllerSetAccountProperty(r, n) {
      return o.accountTreeControllerSetAccountProperty(r.id, r.treeId, r.propertyId, r.editPropertyReq, r.directEdit, r.offset, n).then((l) => l(t, e));
    }
  };
};
class ya extends v {
  /**
   * Please use the /account/:id/property/:propertyId method
   * @summary Sets the account plan property
   * @param {AccountTreesApiAccountTreeControllerSetAccountPropertyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof AccountTreesApi
   */
  setAccountProperty(e, t) {
    return dr(this.configuration).accountTreeControllerSetAccountProperty(e.id, e.treeId, e.propertyId, e.editPropertyReq, e.directEdit, e.offset, t).then((o) => o(this.axios, this.basePath));
  }
}
const ma = function(a) {
  return {
    /**
     * 
     * @summary Checking the connection with the application
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    connectionCheckControllerConnectionCheck: async (e = {}) => {
      const t = "/api3/app/connection-check", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {};
      m(o, {});
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Health check application
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthCheckControllerHealthCheck: async (e = {}) => {
      const t = "/api3/app/health-check", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {};
      m(o, {});
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    }
  };
}, st = function(a) {
  const e = ma(a);
  return {
    /**
     * 
     * @summary Checking the connection with the application
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async connectionCheckControllerConnectionCheck(t) {
      const o = await e.connectionCheckControllerConnectionCheck(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Health check application
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async healthCheckControllerHealthCheck(t) {
      const o = await e.healthCheckControllerHealthCheck(t);
      return V(o, u, C, a);
    }
  };
}, zl = function(a, e, t) {
  const o = st(a);
  return {
    /**
     * 
     * @summary Checking the connection with the application
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    connectionCheckControllerConnectionCheck(r) {
      return o.connectionCheckControllerConnectionCheck(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Health check application
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthCheckControllerHealthCheck(r) {
      return o.healthCheckControllerHealthCheck(r).then((n) => n(t, e));
    }
  };
};
class Oa extends v {
  /**
   * 
   * @summary Checking the connection with the application
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationApi
   */
  connectionCheck(e) {
    return st(this.configuration).connectionCheckControllerConnectionCheck(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Health check application
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationApi
   */
  healthCheck(e) {
    return st(this.configuration).healthCheckControllerHealthCheck(e).then((t) => t(this.axios, this.basePath));
  }
}
const Va = function(a) {
  return {
    /**
     * 
     * @summary Login
     * @param {LoginReq} loginReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerLogin: async (e, t = {}) => {
      p("authControllerLogin", "loginReq", e);
      const o = "/api3/auth/login", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Token refresh
     * @param {RefreshReq} refreshReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerRefreshToken: async (e, t = {}) => {
      p("authControllerRefreshToken", "refreshReq", e);
      const o = "/api3/auth/refresh-token", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    }
  };
}, it = function(a) {
  const e = Va(a);
  return {
    /**
     * 
     * @summary Login
     * @param {LoginReq} loginReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authControllerLogin(t, o) {
      const r = await e.authControllerLogin(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Token refresh
     * @param {RefreshReq} refreshReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authControllerRefreshToken(t, o) {
      const r = await e.authControllerRefreshToken(t, o);
      return V(r, u, C, a);
    }
  };
}, Kl = function(a, e, t) {
  const o = it(a);
  return {
    /**
     * 
     * @summary Login
     * @param {AuthApiAuthControllerLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerLogin(r, n) {
      return o.authControllerLogin(r.loginReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Token refresh
     * @param {AuthApiAuthControllerRefreshTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerRefreshToken(r, n) {
      return o.authControllerRefreshToken(r.refreshReq, n).then((l) => l(t, e));
    }
  };
};
class Pa extends v {
  /**
   * 
   * @summary Login
   * @param {AuthApiAuthControllerLoginRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  login(e, t) {
    return it(this.configuration).authControllerLogin(e.loginReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Token refresh
   * @param {AuthApiAuthControllerRefreshTokenRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  refreshToken(e, t) {
    return it(this.configuration).authControllerRefreshToken(e.refreshReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const fa = function(a) {
  return {
    /**
     * 
     * @summary Creating a batch of documents
     * @param {DocumentBatchCreateReq} documentBatchCreateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerDocumentBatchCreate: async (e, t = {}) => {
      p("documentControllerDocumentBatchCreate", "documentBatchCreateReq", e);
      const o = "/api3/document/batch-create", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Creating a document
     * @param {DocumentCreateReq} documentCreateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerDocumentCreate: async (e, t = {}) => {
      p("documentControllerDocumentCreate", "documentCreateReq", e);
      const o = "/api3/document/create", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns document state
     * @param {string} guid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerGetDocumentStatus: async (e, t = {}) => {
      p("documentControllerGetDocumentStatus", "guid", e);
      const o = "/api3/document/state/{guid}".replace("{guid}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns documents
     * @param {number} limit 
     * @param {number} page 
     * @param {boolean} [includeEmpty] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerGetDocuments: async (e, t, o, r = {}) => {
      p("documentControllerGetDocuments", "limit", e), p("documentControllerGetDocuments", "page", t);
      const n = "/api3/document", l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "GET", ...s, ...r }, c = {}, d = {};
      await P(c, a), e !== void 0 && (d.limit = e), t !== void 0 && (d.page = t), o !== void 0 && (d.includeEmpty = o), m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, {
        url: O(l),
        options: i
      };
    }
  };
}, de = function(a) {
  const e = fa(a);
  return {
    /**
     * 
     * @summary Creating a batch of documents
     * @param {DocumentBatchCreateReq} documentBatchCreateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentControllerDocumentBatchCreate(t, o) {
      const r = await e.documentControllerDocumentBatchCreate(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Creating a document
     * @param {DocumentCreateReq} documentCreateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentControllerDocumentCreate(t, o) {
      const r = await e.documentControllerDocumentCreate(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns document state
     * @param {string} guid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentControllerGetDocumentStatus(t, o) {
      const r = await e.documentControllerGetDocumentStatus(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns documents
     * @param {number} limit 
     * @param {number} page 
     * @param {boolean} [includeEmpty] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentControllerGetDocuments(t, o, r, n) {
      const l = await e.documentControllerGetDocuments(t, o, r, n);
      return V(l, u, C, a);
    }
  };
}, Jl = function(a, e, t) {
  const o = de(a);
  return {
    /**
     * 
     * @summary Creating a batch of documents
     * @param {CPE3ApiDocumentControllerDocumentBatchCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerDocumentBatchCreate(r, n) {
      return o.documentControllerDocumentBatchCreate(r.documentBatchCreateReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Creating a document
     * @param {CPE3ApiDocumentControllerDocumentCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerDocumentCreate(r, n) {
      return o.documentControllerDocumentCreate(r.documentCreateReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns document state
     * @param {CPE3ApiDocumentControllerGetDocumentStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerGetDocumentStatus(r, n) {
      return o.documentControllerGetDocumentStatus(r.guid, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns documents
     * @param {CPE3ApiDocumentControllerGetDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentControllerGetDocuments(r, n) {
      return o.documentControllerGetDocuments(r.limit, r.page, r.includeEmpty, n).then((l) => l(t, e));
    }
  };
};
class wa extends v {
  /**
   * 
   * @summary Creating a batch of documents
   * @param {CPE3ApiDocumentControllerDocumentBatchCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CPE3Api
   */
  documentBatchCreate(e, t) {
    return de(this.configuration).documentControllerDocumentBatchCreate(e.documentBatchCreateReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Creating a document
   * @param {CPE3ApiDocumentControllerDocumentCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CPE3Api
   */
  documentCreate(e, t) {
    return de(this.configuration).documentControllerDocumentCreate(e.documentCreateReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns document state
   * @param {CPE3ApiDocumentControllerGetDocumentStatusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CPE3Api
   */
  getDocumentStatus(e, t) {
    return de(this.configuration).documentControllerGetDocumentStatus(e.guid, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns documents
   * @param {CPE3ApiDocumentControllerGetDocumentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CPE3Api
   */
  getDocuments(e, t) {
    return de(this.configuration).documentControllerGetDocuments(e.limit, e.page, e.includeEmpty, t).then((o) => o(this.axios, this.basePath));
  }
}
const Aa = function(a) {
  return {
    /**
     * 
     * @summary Getting a list of profile-field-value changes
     * @param {number} limit 
     * @param {number} page 
     * @param {number} [accountId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeLogProfileFieldValueControllerGetProfileFieldValueChanges: async (e, t, o, r = {}) => {
      p("changeLogProfileFieldValueControllerGetProfileFieldValueChanges", "limit", e), p("changeLogProfileFieldValueControllerGetProfileFieldValueChanges", "page", t);
      const n = "/api3/change-log/profile-field-value", l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "GET", ...s, ...r }, c = {}, d = {};
      e !== void 0 && (d.limit = e), t !== void 0 && (d.page = t), o !== void 0 && (d.accountId = o), m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, {
        url: O(l),
        options: i
      };
    }
  };
}, pr = function(a) {
  const e = Aa(a);
  return {
    /**
     * 
     * @summary Getting a list of profile-field-value changes
     * @param {number} limit 
     * @param {number} page 
     * @param {number} [accountId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async changeLogProfileFieldValueControllerGetProfileFieldValueChanges(t, o, r, n) {
      const l = await e.changeLogProfileFieldValueControllerGetProfileFieldValueChanges(t, o, r, n);
      return V(l, u, C, a);
    }
  };
}, Xl = function(a, e, t) {
  const o = pr(a);
  return {
    /**
     * 
     * @summary Getting a list of profile-field-value changes
     * @param {ChangeLogApiChangeLogProfileFieldValueControllerGetProfileFieldValueChangesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changeLogProfileFieldValueControllerGetProfileFieldValueChanges(r, n) {
      return o.changeLogProfileFieldValueControllerGetProfileFieldValueChanges(r.limit, r.page, r.accountId, n).then((l) => l(t, e));
    }
  };
};
class Ra extends v {
  /**
   * 
   * @summary Getting a list of profile-field-value changes
   * @param {ChangeLogApiChangeLogProfileFieldValueControllerGetProfileFieldValueChangesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChangeLogApi
   */
  getProfileFieldValueChanges(e, t) {
    return pr(this.configuration).changeLogProfileFieldValueControllerGetProfileFieldValueChanges(e.limit, e.page, e.accountId, t).then((o) => o(this.axios, this.basePath));
  }
}
const ba = function(a) {
  return {
    /**
     * 
     * @summary Sending a message through a communication service (CS)
     * @param {CSDirectSendReq} cSDirectSendReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cSControllerDirectSendMessage: async (e, t = {}) => {
      p("cSControllerDirectSendMessage", "cSDirectSendReq", e);
      const o = "/api3/cs/directsend", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    }
  };
}, hr = function(a) {
  const e = ba(a);
  return {
    /**
     * 
     * @summary Sending a message through a communication service (CS)
     * @param {CSDirectSendReq} cSDirectSendReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cSControllerDirectSendMessage(t, o) {
      const r = await e.cSControllerDirectSendMessage(t, o);
      return V(r, u, C, a);
    }
  };
}, Zl = function(a, e, t) {
  const o = hr(a);
  return {
    /**
     * 
     * @summary Sending a message through a communication service (CS)
     * @param {CommunicationServiceApiCSControllerDirectSendMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cSControllerDirectSendMessage(r, n) {
      return o.cSControllerDirectSendMessage(r.cSDirectSendReq, n).then((l) => l(t, e));
    }
  };
};
class Sa extends v {
  /**
   * 
   * @summary Sending a message through a communication service (CS)
   * @param {CommunicationServiceApiCSControllerDirectSendMessageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunicationServiceApi
   */
  directSendMessage(e, t) {
    return hr(this.configuration).cSControllerDirectSendMessage(e.cSDirectSendReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const Ta = function(a) {
  return {
    /**
     * 
     * @summary Getting a list of countries
     * @param {number} limit 
     * @param {number} page 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countryControllerGetCountries: async (e, t, o, r, n = {}) => {
      p("countryControllerGetCountries", "limit", e), p("countryControllerGetCountries", "page", t);
      const l = "/api3/country", s = new URL(l, y);
      let i;
      a && (i = a.baseOptions);
      const c = { method: "GET", ...i, ...n }, d = {}, h = {};
      e !== void 0 && (h.limit = e), t !== void 0 && (h.page = t), o !== void 0 && (h.orderBy = o), r !== void 0 && (h.filter = r), m(s, h);
      let f = i && i.headers ? i.headers : {};
      return c.headers = { ...d, ...f, ...n.headers }, {
        url: O(s),
        options: c
      };
    },
    /**
     * 
     * @summary Get country
     * @param {string} countryId Country ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countryControllerGetCountry: async (e, t = {}) => {
      p("countryControllerGetCountry", "countryId", e);
      const o = "/api3/country/{countryId}".replace("{countryId}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {};
      m(r, {});
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Getting a list of region
     * @param {string} countryId Country ID
     * @param {number} limit 
     * @param {number} page 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countryControllerGetRegions: async (e, t, o, r, n, l = {}) => {
      p("countryControllerGetRegions", "countryId", e), p("countryControllerGetRegions", "limit", t), p("countryControllerGetRegions", "page", o);
      const s = "/api3/country/{countryId}/region".replace("{countryId}", encodeURIComponent(String(e))), i = new URL(s, y);
      let c;
      a && (c = a.baseOptions);
      const d = { method: "GET", ...c, ...l }, h = {}, f = {};
      t !== void 0 && (f.limit = t), o !== void 0 && (f.page = o), r !== void 0 && (f.orderBy = r), n !== void 0 && (f.filter = n), m(i, f);
      let R = c && c.headers ? c.headers : {};
      return d.headers = { ...h, ...R, ...l.headers }, {
        url: O(i),
        options: d
      };
    }
  };
}, ke = function(a) {
  const e = Ta(a);
  return {
    /**
     * 
     * @summary Getting a list of countries
     * @param {number} limit 
     * @param {number} page 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async countryControllerGetCountries(t, o, r, n, l) {
      const s = await e.countryControllerGetCountries(t, o, r, n, l);
      return V(s, u, C, a);
    },
    /**
     * 
     * @summary Get country
     * @param {string} countryId Country ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async countryControllerGetCountry(t, o) {
      const r = await e.countryControllerGetCountry(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Getting a list of region
     * @param {string} countryId Country ID
     * @param {number} limit 
     * @param {number} page 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async countryControllerGetRegions(t, o, r, n, l, s) {
      const i = await e.countryControllerGetRegions(t, o, r, n, l, s);
      return V(i, u, C, a);
    }
  };
}, Yl = function(a, e, t) {
  const o = ke(a);
  return {
    /**
     * 
     * @summary Getting a list of countries
     * @param {CountryApiCountryControllerGetCountriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countryControllerGetCountries(r, n) {
      return o.countryControllerGetCountries(r.limit, r.page, r.orderBy, r.filter, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Get country
     * @param {CountryApiCountryControllerGetCountryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countryControllerGetCountry(r, n) {
      return o.countryControllerGetCountry(r.countryId, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting a list of region
     * @param {CountryApiCountryControllerGetRegionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countryControllerGetRegions(r, n) {
      return o.countryControllerGetRegions(r.countryId, r.limit, r.page, r.orderBy, r.filter, n).then((l) => l(t, e));
    }
  };
};
class Ga extends v {
  /**
   * 
   * @summary Getting a list of countries
   * @param {CountryApiCountryControllerGetCountriesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CountryApi
   */
  getCountries(e, t) {
    return ke(this.configuration).countryControllerGetCountries(e.limit, e.page, e.orderBy, e.filter, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get country
   * @param {CountryApiCountryControllerGetCountryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CountryApi
   */
  getCountry(e, t) {
    return ke(this.configuration).countryControllerGetCountry(e.countryId, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting a list of region
   * @param {CountryApiCountryControllerGetRegionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CountryApi
   */
  getRegions(e, t) {
    return ke(this.configuration).countryControllerGetRegions(e.countryId, e.limit, e.page, e.orderBy, e.filter, t).then((o) => o(this.axios, this.basePath));
  }
}
const va = function(a) {
  return {
    /**
     * Returns a list of currency
     * @summary Getting a list of currency
     * @param {boolean} [withRates] Including a rate in response
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    currenciesControllerGetCurrencies: async (e, t = {}) => {
      const o = "/api3/currencies", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      await P(s, a), e !== void 0 && (i.with_rates = e), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * Returns a list of currency rates
     * @summary Getting currency rates
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    currenciesControllerGetCurrenciesRates: async (e = {}) => {
      const t = "/api3/currencies/rates", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Creating a currency
     * @param {AddCurrencyReq} addCurrencyReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currencyControllerCreateCurrency: async (e, t = {}) => {
      p("currencyControllerCreateCurrency", "addCurrencyReq", e);
      const o = "/api3/currency", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Deleting a currency
     * @param {string} id Currency code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currencyControllerDeleteCurrency: async (e, t = {}) => {
      p("currencyControllerDeleteCurrency", "id", e);
      const o = "/api3/currency/{id}".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "DELETE", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Getting a list of currencies
     * @param {boolean} [withRates] Including a rate in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currencyControllerGetCurrencies: async (e, t = {}) => {
      const o = "/api3/currency", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      await P(s, a), e !== void 0 && (i.withRates = e), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Updating a currency
     * @param {string} id Currency code
     * @param {UpdateCurrencyReq} updateCurrencyReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currencyControllerUpdateCurrency: async (e, t, o = {}) => {
      p("currencyControllerUpdateCurrency", "id", e), p("currencyControllerUpdateCurrency", "updateCurrencyReq", t);
      const r = "/api3/currency/{id}".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, K = function(a) {
  const e = va(a);
  return {
    /**
     * Returns a list of currency
     * @summary Getting a list of currency
     * @param {boolean} [withRates] Including a rate in response
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async currenciesControllerGetCurrencies(t, o) {
      const r = await e.currenciesControllerGetCurrencies(t, o);
      return V(r, u, C, a);
    },
    /**
     * Returns a list of currency rates
     * @summary Getting currency rates
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async currenciesControllerGetCurrenciesRates(t) {
      const o = await e.currenciesControllerGetCurrenciesRates(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Creating a currency
     * @param {AddCurrencyReq} addCurrencyReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async currencyControllerCreateCurrency(t, o) {
      const r = await e.currencyControllerCreateCurrency(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Deleting a currency
     * @param {string} id Currency code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async currencyControllerDeleteCurrency(t, o) {
      const r = await e.currencyControllerDeleteCurrency(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Getting a list of currencies
     * @param {boolean} [withRates] Including a rate in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async currencyControllerGetCurrencies(t, o) {
      const r = await e.currencyControllerGetCurrencies(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Updating a currency
     * @param {string} id Currency code
     * @param {UpdateCurrencyReq} updateCurrencyReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async currencyControllerUpdateCurrency(t, o, r) {
      const n = await e.currencyControllerUpdateCurrency(t, o, r);
      return V(n, u, C, a);
    }
  };
}, ql = function(a, e, t) {
  const o = K(a);
  return {
    /**
     * Returns a list of currency
     * @summary Getting a list of currency
     * @param {CurrencyApiCurrenciesControllerGetCurrenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    currenciesControllerGetCurrencies(r = {}, n) {
      return o.currenciesControllerGetCurrencies(r.withRates, n).then((l) => l(t, e));
    },
    /**
     * Returns a list of currency rates
     * @summary Getting currency rates
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    currenciesControllerGetCurrenciesRates(r) {
      return o.currenciesControllerGetCurrenciesRates(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Creating a currency
     * @param {CurrencyApiCurrencyControllerCreateCurrencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currencyControllerCreateCurrency(r, n) {
      return o.currencyControllerCreateCurrency(r.addCurrencyReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Deleting a currency
     * @param {CurrencyApiCurrencyControllerDeleteCurrencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currencyControllerDeleteCurrency(r, n) {
      return o.currencyControllerDeleteCurrency(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting a list of currencies
     * @param {CurrencyApiCurrencyControllerGetCurrenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currencyControllerGetCurrencies(r = {}, n) {
      return o.currencyControllerGetCurrencies(r.withRates, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Updating a currency
     * @param {CurrencyApiCurrencyControllerUpdateCurrencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currencyControllerUpdateCurrency(r, n) {
      return o.currencyControllerUpdateCurrency(r.id, r.updateCurrencyReq, n).then((l) => l(t, e));
    }
  };
};
class Ua extends v {
  /**
   * Returns a list of currency
   * @summary Getting a list of currency
   * @param {CurrencyApiCurrenciesControllerGetCurrenciesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CurrencyApi
   */
  currenciesControllerGetCurrencies(e = {}, t) {
    return K(this.configuration).currenciesControllerGetCurrencies(e.withRates, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Returns a list of currency rates
   * @summary Getting currency rates
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CurrencyApi
   */
  getCurrenciesRates(e) {
    return K(this.configuration).currenciesControllerGetCurrenciesRates(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Creating a currency
   * @param {CurrencyApiCurrencyControllerCreateCurrencyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CurrencyApi
   */
  createCurrency(e, t) {
    return K(this.configuration).currencyControllerCreateCurrency(e.addCurrencyReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Deleting a currency
   * @param {CurrencyApiCurrencyControllerDeleteCurrencyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CurrencyApi
   */
  deleteCurrency(e, t) {
    return K(this.configuration).currencyControllerDeleteCurrency(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting a list of currencies
   * @param {CurrencyApiCurrencyControllerGetCurrenciesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CurrencyApi
   */
  currencyControllerGetCurrencies(e = {}, t) {
    return K(this.configuration).currencyControllerGetCurrencies(e.withRates, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updating a currency
   * @param {CurrencyApiCurrencyControllerUpdateCurrencyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CurrencyApi
   */
  updateCurrency(e, t) {
    return K(this.configuration).currencyControllerUpdateCurrency(e.id, e.updateCurrencyReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const ga = function(a) {
  return {
    /**
     * 
     * @summary Creating a currency rate
     * @param {CreateCurrencyRateReq} createCurrencyRateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currencyRateControllerCreateCurrencyRate: async (e, t = {}) => {
      p("currencyRateControllerCreateCurrencyRate", "createCurrencyRateReq", e);
      const o = "/api3/currency-rate", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Deleting a currency rate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currencyRateControllerDeleteCurrencyRate: async (e = {}) => {
      const t = "/api3/currency-rate/{id}", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "DELETE", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Getting all currency rates
     * @param {number} limit 
     * @param {number} page 
     * @param {string} currency 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currencyRateControllerGetAllCurrencyRates: async (e, t, o, r = {}) => {
      p("currencyRateControllerGetAllCurrencyRates", "limit", e), p("currencyRateControllerGetAllCurrencyRates", "page", t), p("currencyRateControllerGetAllCurrencyRates", "currency", o);
      const n = "/api3/currency-rate", l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "GET", ...s, ...r }, c = {}, d = {};
      await P(c, a), e !== void 0 && (d.limit = e), t !== void 0 && (d.page = t), o !== void 0 && (d.currency = o), m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, {
        url: O(l),
        options: i
      };
    },
    /**
     * 
     * @summary Updating a currency rate
     * @param {UpdateCurrencyRateReq} updateCurrencyRateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currencyRateControllerUpdateCurrencyRate: async (e, t = {}) => {
      p("currencyRateControllerUpdateCurrencyRate", "updateCurrencyRateReq", e);
      const o = "/api3/currency-rate/{id}", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "PUT", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    }
  };
}, pe = function(a) {
  const e = ga(a);
  return {
    /**
     * 
     * @summary Creating a currency rate
     * @param {CreateCurrencyRateReq} createCurrencyRateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async currencyRateControllerCreateCurrencyRate(t, o) {
      const r = await e.currencyRateControllerCreateCurrencyRate(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Deleting a currency rate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async currencyRateControllerDeleteCurrencyRate(t) {
      const o = await e.currencyRateControllerDeleteCurrencyRate(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Getting all currency rates
     * @param {number} limit 
     * @param {number} page 
     * @param {string} currency 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async currencyRateControllerGetAllCurrencyRates(t, o, r, n) {
      const l = await e.currencyRateControllerGetAllCurrencyRates(t, o, r, n);
      return V(l, u, C, a);
    },
    /**
     * 
     * @summary Updating a currency rate
     * @param {UpdateCurrencyRateReq} updateCurrencyRateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async currencyRateControllerUpdateCurrencyRate(t, o) {
      const r = await e.currencyRateControllerUpdateCurrencyRate(t, o);
      return V(r, u, C, a);
    }
  };
}, es = function(a, e, t) {
  const o = pe(a);
  return {
    /**
     * 
     * @summary Creating a currency rate
     * @param {CurrencyRateApiCurrencyRateControllerCreateCurrencyRateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currencyRateControllerCreateCurrencyRate(r, n) {
      return o.currencyRateControllerCreateCurrencyRate(r.createCurrencyRateReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Deleting a currency rate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currencyRateControllerDeleteCurrencyRate(r) {
      return o.currencyRateControllerDeleteCurrencyRate(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Getting all currency rates
     * @param {CurrencyRateApiCurrencyRateControllerGetAllCurrencyRatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currencyRateControllerGetAllCurrencyRates(r, n) {
      return o.currencyRateControllerGetAllCurrencyRates(r.limit, r.page, r.currency, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Updating a currency rate
     * @param {CurrencyRateApiCurrencyRateControllerUpdateCurrencyRateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    currencyRateControllerUpdateCurrencyRate(r, n) {
      return o.currencyRateControllerUpdateCurrencyRate(r.updateCurrencyRateReq, n).then((l) => l(t, e));
    }
  };
};
class xa extends v {
  /**
   * 
   * @summary Creating a currency rate
   * @param {CurrencyRateApiCurrencyRateControllerCreateCurrencyRateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CurrencyRateApi
   */
  createCurrencyRate(e, t) {
    return pe(this.configuration).currencyRateControllerCreateCurrencyRate(e.createCurrencyRateReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Deleting a currency rate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CurrencyRateApi
   */
  deleteCurrencyRate(e) {
    return pe(this.configuration).currencyRateControllerDeleteCurrencyRate(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting all currency rates
   * @param {CurrencyRateApiCurrencyRateControllerGetAllCurrencyRatesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CurrencyRateApi
   */
  getAllCurrencyRates(e, t) {
    return pe(this.configuration).currencyRateControllerGetAllCurrencyRates(e.limit, e.page, e.currency, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updating a currency rate
   * @param {CurrencyRateApiCurrencyRateControllerUpdateCurrencyRateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CurrencyRateApi
   */
  updateCurrencyRate(e, t) {
    return pe(this.configuration).currencyRateControllerUpdateCurrencyRate(e.updateCurrencyRateReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const Ea = function(a) {
  return {
    /**
     * 
     * @summary Returns data exports history
     * @param {number} limit 
     * @param {number} page 
     * @param {object} [filter] 
     * @param {object} [orderBy] Sort options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataExportControllerGetDeliveries: async (e, t, o, r, n = {}) => {
      p("dataExportControllerGetDeliveries", "limit", e), p("dataExportControllerGetDeliveries", "page", t);
      const l = "/api3/data-export", s = new URL(l, y);
      let i;
      a && (i = a.baseOptions);
      const c = { method: "GET", ...i, ...n }, d = {}, h = {};
      await P(d, a), e !== void 0 && (h.limit = e), t !== void 0 && (h.page = t), o !== void 0 && (h.filter = o), r !== void 0 && (h.orderBy = r), m(s, h);
      let f = i && i.headers ? i.headers : {};
      return c.headers = { ...d, ...f, ...n.headers }, {
        url: O(s),
        options: c
      };
    }
  };
}, ur = function(a) {
  const e = Ea(a);
  return {
    /**
     * 
     * @summary Returns data exports history
     * @param {number} limit 
     * @param {number} page 
     * @param {object} [filter] 
     * @param {object} [orderBy] Sort options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataExportControllerGetDeliveries(t, o, r, n, l) {
      const s = await e.dataExportControllerGetDeliveries(t, o, r, n, l);
      return V(s, u, C, a);
    }
  };
}, ts = function(a, e, t) {
  const o = ur(a);
  return {
    /**
     * 
     * @summary Returns data exports history
     * @param {DataExportApiDataExportControllerGetDeliveriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataExportControllerGetDeliveries(r, n) {
      return o.dataExportControllerGetDeliveries(r.limit, r.page, r.filter, r.orderBy, n).then((l) => l(t, e));
    }
  };
};
class Ia extends v {
  /**
   * 
   * @summary Returns data exports history
   * @param {DataExportApiDataExportControllerGetDeliveriesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataExportApi
   */
  getDeliveries(e, t) {
    return ur(this.configuration).dataExportControllerGetDeliveries(e.limit, e.page, e.filter, e.orderBy, t).then((o) => o(this.axios, this.basePath));
  }
}
const Fa = function(a) {
  return {
    /**
     * 
     * @summary Returns delivery configuration
     * @param {string} alias 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryControllerGetConfiguration: async (e, t = {}) => {
      p("deliveryControllerGetConfiguration", "alias", e);
      const o = "/api3/delivery/{alias}/config".replace("{alias}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns all delivery handlers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryControllerGetDeliveries: async (e = {}) => {
      const t = "/api3/delivery", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Returns price for delivery options
     * @param {string} alias 
     * @param {GetDeliveryOptionPriceReq} getDeliveryOptionPriceReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryControllerGetDeliveryOptionPrice: async (e, t, o = {}) => {
      p("deliveryControllerGetDeliveryOptionPrice", "alias", e), p("deliveryControllerGetDeliveryOptionPrice", "getDeliveryOptionPriceReq", t);
      const r = "/api3/delivery/{alias}/price".replace("{alias}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "POST", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Returns delivery options for the specified delivery method
     * @param {string} alias 
     * @param {GetDeliveryOptionsReq} getDeliveryOptionsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryControllerGetDeliveryOptions: async (e, t, o = {}) => {
      p("deliveryControllerGetDeliveryOptions", "alias", e), p("deliveryControllerGetDeliveryOptions", "getDeliveryOptionsReq", t);
      const r = "/api3/delivery/{alias}/options".replace("{alias}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "POST", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Sets delivery configuration
     * @param {string} alias 
     * @param {SetDeliveryConfigurationReq} setDeliveryConfigurationReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryControllerSetConfiguration: async (e, t, o = {}) => {
      p("deliveryControllerSetConfiguration", "alias", e), p("deliveryControllerSetConfiguration", "setDeliveryConfigurationReq", t);
      const r = "/api3/delivery/{alias}/config".replace("{alias}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, re = function(a) {
  const e = Fa(a);
  return {
    /**
     * 
     * @summary Returns delivery configuration
     * @param {string} alias 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryControllerGetConfiguration(t, o) {
      const r = await e.deliveryControllerGetConfiguration(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns all delivery handlers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryControllerGetDeliveries(t) {
      const o = await e.deliveryControllerGetDeliveries(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Returns price for delivery options
     * @param {string} alias 
     * @param {GetDeliveryOptionPriceReq} getDeliveryOptionPriceReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryControllerGetDeliveryOptionPrice(t, o, r) {
      const n = await e.deliveryControllerGetDeliveryOptionPrice(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Returns delivery options for the specified delivery method
     * @param {string} alias 
     * @param {GetDeliveryOptionsReq} getDeliveryOptionsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryControllerGetDeliveryOptions(t, o, r) {
      const n = await e.deliveryControllerGetDeliveryOptions(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Sets delivery configuration
     * @param {string} alias 
     * @param {SetDeliveryConfigurationReq} setDeliveryConfigurationReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryControllerSetConfiguration(t, o, r) {
      const n = await e.deliveryControllerSetConfiguration(t, o, r);
      return V(n, u, C, a);
    }
  };
}, rs = function(a, e, t) {
  const o = re(a);
  return {
    /**
     * 
     * @summary Returns delivery configuration
     * @param {DeliveryApiDeliveryControllerGetConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryControllerGetConfiguration(r, n) {
      return o.deliveryControllerGetConfiguration(r.alias, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns all delivery handlers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryControllerGetDeliveries(r) {
      return o.deliveryControllerGetDeliveries(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Returns price for delivery options
     * @param {DeliveryApiDeliveryControllerGetDeliveryOptionPriceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryControllerGetDeliveryOptionPrice(r, n) {
      return o.deliveryControllerGetDeliveryOptionPrice(r.alias, r.getDeliveryOptionPriceReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns delivery options for the specified delivery method
     * @param {DeliveryApiDeliveryControllerGetDeliveryOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryControllerGetDeliveryOptions(r, n) {
      return o.deliveryControllerGetDeliveryOptions(r.alias, r.getDeliveryOptionsReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Sets delivery configuration
     * @param {DeliveryApiDeliveryControllerSetConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryControllerSetConfiguration(r, n) {
      return o.deliveryControllerSetConfiguration(r.alias, r.setDeliveryConfigurationReq, n).then((l) => l(t, e));
    }
  };
};
class La extends v {
  /**
   * 
   * @summary Returns delivery configuration
   * @param {DeliveryApiDeliveryControllerGetConfigurationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  getConfiguration(e, t) {
    return re(this.configuration).deliveryControllerGetConfiguration(e.alias, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns all delivery handlers
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  getDeliveries(e) {
    return re(this.configuration).deliveryControllerGetDeliveries(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns price for delivery options
   * @param {DeliveryApiDeliveryControllerGetDeliveryOptionPriceRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  getDeliveryOptionPrice(e, t) {
    return re(this.configuration).deliveryControllerGetDeliveryOptionPrice(e.alias, e.getDeliveryOptionPriceReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns delivery options for the specified delivery method
   * @param {DeliveryApiDeliveryControllerGetDeliveryOptionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  getDeliveryOptions(e, t) {
    return re(this.configuration).deliveryControllerGetDeliveryOptions(e.alias, e.getDeliveryOptionsReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Sets delivery configuration
   * @param {DeliveryApiDeliveryControllerSetConfigurationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */
  setConfiguration(e, t) {
    return re(this.configuration).deliveryControllerSetConfiguration(e.alias, e.setDeliveryConfigurationReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const Da = function(a) {
  return {
    /**
     * 
     * @summary Creates dictionary
     * @param {AddDictionaryReq} addDictionaryReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dictionaryControllerCreateDictionary: async (e, t = {}) => {
      p("dictionaryControllerCreateDictionary", "addDictionaryReq", e);
      const o = "/api3/dictionary", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Deletes dictionary
     * @param {number} id 
     * @param {boolean} [hardRemove] Hard remove item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dictionaryControllerDeleteDictionary: async (e, t, o = {}) => {
      p("dictionaryControllerDeleteDictionary", "id", e);
      const r = "/api3/dictionary/{id}".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "DELETE", ...l, ...o }, i = {}, c = {};
      await P(i, a), t !== void 0 && (c.hardRemove = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Returns dictionary list
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dictionaryControllerGetDictionaryList: async (e, t, o = {}) => {
      p("dictionaryControllerGetDictionaryList", "limit", e), p("dictionaryControllerGetDictionaryList", "page", t);
      const r = "/api3/dictionary", n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      await P(i, a), e !== void 0 && (c.limit = e), t !== void 0 && (c.page = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Updates dictionary
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dictionaryControllerUpdateDictionary: async (e, t = {}) => {
      p("dictionaryControllerUpdateDictionary", "id", e);
      const o = "/api3/dictionary/{id}".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "PUT", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    }
  };
}, he = function(a) {
  const e = Da(a);
  return {
    /**
     * 
     * @summary Creates dictionary
     * @param {AddDictionaryReq} addDictionaryReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dictionaryControllerCreateDictionary(t, o) {
      const r = await e.dictionaryControllerCreateDictionary(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Deletes dictionary
     * @param {number} id 
     * @param {boolean} [hardRemove] Hard remove item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dictionaryControllerDeleteDictionary(t, o, r) {
      const n = await e.dictionaryControllerDeleteDictionary(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Returns dictionary list
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dictionaryControllerGetDictionaryList(t, o, r) {
      const n = await e.dictionaryControllerGetDictionaryList(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Updates dictionary
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dictionaryControllerUpdateDictionary(t, o) {
      const r = await e.dictionaryControllerUpdateDictionary(t, o);
      return V(r, u, C, a);
    }
  };
}, os = function(a, e, t) {
  const o = he(a);
  return {
    /**
     * 
     * @summary Creates dictionary
     * @param {DictionaryApiDictionaryControllerCreateDictionaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dictionaryControllerCreateDictionary(r, n) {
      return o.dictionaryControllerCreateDictionary(r.addDictionaryReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Deletes dictionary
     * @param {DictionaryApiDictionaryControllerDeleteDictionaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dictionaryControllerDeleteDictionary(r, n) {
      return o.dictionaryControllerDeleteDictionary(r.id, r.hardRemove, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns dictionary list
     * @param {DictionaryApiDictionaryControllerGetDictionaryListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dictionaryControllerGetDictionaryList(r, n) {
      return o.dictionaryControllerGetDictionaryList(r.limit, r.page, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Updates dictionary
     * @param {DictionaryApiDictionaryControllerUpdateDictionaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dictionaryControllerUpdateDictionary(r, n) {
      return o.dictionaryControllerUpdateDictionary(r.id, n).then((l) => l(t, e));
    }
  };
};
class Ba extends v {
  /**
   * 
   * @summary Creates dictionary
   * @param {DictionaryApiDictionaryControllerCreateDictionaryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DictionaryApi
   */
  createDictionary(e, t) {
    return he(this.configuration).dictionaryControllerCreateDictionary(e.addDictionaryReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Deletes dictionary
   * @param {DictionaryApiDictionaryControllerDeleteDictionaryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DictionaryApi
   */
  deleteDictionary(e, t) {
    return he(this.configuration).dictionaryControllerDeleteDictionary(e.id, e.hardRemove, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns dictionary list
   * @param {DictionaryApiDictionaryControllerGetDictionaryListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DictionaryApi
   */
  getDictionaryList(e, t) {
    return he(this.configuration).dictionaryControllerGetDictionaryList(e.limit, e.page, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updates dictionary
   * @param {DictionaryApiDictionaryControllerUpdateDictionaryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DictionaryApi
   */
  updateDictionary(e, t) {
    return he(this.configuration).dictionaryControllerUpdateDictionary(e.id, t).then((o) => o(this.axios, this.basePath));
  }
}
const ja = function(a) {
  return {
    /**
     * 
     * @summary Creates dictionary item
     * @param {number} id 
     * @param {AddDictionaryItemReq} addDictionaryItemReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dictionaryItemControllerCreateDictionaryItem: async (e, t, o = {}) => {
      p("dictionaryItemControllerCreateDictionaryItem", "id", e), p("dictionaryItemControllerCreateDictionaryItem", "addDictionaryItemReq", t);
      const r = "/api3/dictionary/{id}/item".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "POST", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Deletes dictionary item
     * @param {number} id 
     * @param {number} itemId 
     * @param {boolean} [hardRemove] Hard remove item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dictionaryItemControllerDeleteDictionaryItem: async (e, t, o, r = {}) => {
      p("dictionaryItemControllerDeleteDictionaryItem", "id", e), p("dictionaryItemControllerDeleteDictionaryItem", "itemId", t);
      const n = "/api3/dictionary/{id}/item/{itemId}".replace("{id}", encodeURIComponent(String(e))).replace("{itemId}", encodeURIComponent(String(t))), l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "DELETE", ...s, ...r }, c = {}, d = {};
      await P(c, a), o !== void 0 && (d.hardRemove = o), m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, {
        url: O(l),
        options: i
      };
    },
    /**
     * 
     * @summary Returns dictionary item list
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dictionaryItemControllerGetDictionaryItemList: async (e, t = {}) => {
      p("dictionaryItemControllerGetDictionaryItemList", "id", e);
      const o = "/api3/dictionary/{id}/item".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Updates dictionary item
     * @param {number} id 
     * @param {number} itemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dictionaryItemControllerUpdateDictionaryItem: async (e, t, o = {}) => {
      p("dictionaryItemControllerUpdateDictionaryItem", "id", e), p("dictionaryItemControllerUpdateDictionaryItem", "itemId", t);
      const r = "/api3/dictionary/{id}/item/{itemId}".replace("{id}", encodeURIComponent(String(e))).replace("{itemId}", encodeURIComponent(String(t))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    }
  };
}, ue = function(a) {
  const e = ja(a);
  return {
    /**
     * 
     * @summary Creates dictionary item
     * @param {number} id 
     * @param {AddDictionaryItemReq} addDictionaryItemReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dictionaryItemControllerCreateDictionaryItem(t, o, r) {
      const n = await e.dictionaryItemControllerCreateDictionaryItem(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Deletes dictionary item
     * @param {number} id 
     * @param {number} itemId 
     * @param {boolean} [hardRemove] Hard remove item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dictionaryItemControllerDeleteDictionaryItem(t, o, r, n) {
      const l = await e.dictionaryItemControllerDeleteDictionaryItem(t, o, r, n);
      return V(l, u, C, a);
    },
    /**
     * 
     * @summary Returns dictionary item list
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dictionaryItemControllerGetDictionaryItemList(t, o) {
      const r = await e.dictionaryItemControllerGetDictionaryItemList(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Updates dictionary item
     * @param {number} id 
     * @param {number} itemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dictionaryItemControllerUpdateDictionaryItem(t, o, r) {
      const n = await e.dictionaryItemControllerUpdateDictionaryItem(t, o, r);
      return V(n, u, C, a);
    }
  };
}, as = function(a, e, t) {
  const o = ue(a);
  return {
    /**
     * 
     * @summary Creates dictionary item
     * @param {DictionaryItemApiDictionaryItemControllerCreateDictionaryItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dictionaryItemControllerCreateDictionaryItem(r, n) {
      return o.dictionaryItemControllerCreateDictionaryItem(r.id, r.addDictionaryItemReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Deletes dictionary item
     * @param {DictionaryItemApiDictionaryItemControllerDeleteDictionaryItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dictionaryItemControllerDeleteDictionaryItem(r, n) {
      return o.dictionaryItemControllerDeleteDictionaryItem(r.id, r.itemId, r.hardRemove, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns dictionary item list
     * @param {DictionaryItemApiDictionaryItemControllerGetDictionaryItemListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dictionaryItemControllerGetDictionaryItemList(r, n) {
      return o.dictionaryItemControllerGetDictionaryItemList(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Updates dictionary item
     * @param {DictionaryItemApiDictionaryItemControllerUpdateDictionaryItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dictionaryItemControllerUpdateDictionaryItem(r, n) {
      return o.dictionaryItemControllerUpdateDictionaryItem(r.id, r.itemId, n).then((l) => l(t, e));
    }
  };
};
class ka extends v {
  /**
   * 
   * @summary Creates dictionary item
   * @param {DictionaryItemApiDictionaryItemControllerCreateDictionaryItemRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DictionaryItemApi
   */
  createDictionaryItem(e, t) {
    return ue(this.configuration).dictionaryItemControllerCreateDictionaryItem(e.id, e.addDictionaryItemReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Deletes dictionary item
   * @param {DictionaryItemApiDictionaryItemControllerDeleteDictionaryItemRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DictionaryItemApi
   */
  deleteDictionaryItem(e, t) {
    return ue(this.configuration).dictionaryItemControllerDeleteDictionaryItem(e.id, e.itemId, e.hardRemove, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns dictionary item list
   * @param {DictionaryItemApiDictionaryItemControllerGetDictionaryItemListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DictionaryItemApi
   */
  getDictionaryItemList(e, t) {
    return ue(this.configuration).dictionaryItemControllerGetDictionaryItemList(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updates dictionary item
   * @param {DictionaryItemApiDictionaryItemControllerUpdateDictionaryItemRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DictionaryItemApi
   */
  updateDictionaryItem(e, t) {
    return ue(this.configuration).dictionaryItemControllerUpdateDictionaryItem(e.id, e.itemId, t).then((o) => o(this.axios, this.basePath));
  }
}
const Ha = function(a) {
  return {
    /**
     * 
     * @summary Starts export operation
     * @param {number} limit 
     * @param {number} page 
     * @param {ExportDocumentsReq} exportDocumentsReq 
     * @param {string} [documentType] 
     * @param {number} [accountId] 
     * @param {boolean} [isBatch] 
     * @param {Array<string>} [filter] 
     * @param {object} [orderBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentRegistryControllerExportDocuments: async (e, t, o, r, n, l, s, i, c = {}) => {
      p("documentRegistryControllerExportDocuments", "limit", e), p("documentRegistryControllerExportDocuments", "page", t), p("documentRegistryControllerExportDocuments", "exportDocumentsReq", o);
      const d = "/api3/document-registry/document/export", h = new URL(d, y);
      let f;
      a && (f = a.baseOptions);
      const R = { method: "POST", ...f, ...c }, A = {}, w = {};
      await P(A, a), e !== void 0 && (w.limit = e), t !== void 0 && (w.page = t), r !== void 0 && (w.documentType = r), n !== void 0 && (w.accountId = n), l !== void 0 && (w.isBatch = l), s && (w.filter = s), i !== void 0 && (w.orderBy = i), A["Content-Type"] = "application/json", m(h, w);
      let T = f && f.headers ? f.headers : {};
      return R.headers = { ...A, ...T, ...c.headers }, R.data = S(o, R, a), {
        url: O(h),
        options: R
      };
    },
    /**
     * 
     * @summary Returns document types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentRegistryControllerGetDocumentTypes: async (e = {}) => {
      const t = "/api3/document-registry/document-type", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Returns documents
     * @param {number} limit 
     * @param {number} page 
     * @param {string} [documentType] 
     * @param {number} [accountId] 
     * @param {boolean} [isBatch] 
     * @param {Array<string>} [filter] 
     * @param {object} [orderBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentRegistryControllerGetDocuments: async (e, t, o, r, n, l, s, i = {}) => {
      p("documentRegistryControllerGetDocuments", "limit", e), p("documentRegistryControllerGetDocuments", "page", t);
      const c = "/api3/document-registry/document", d = new URL(c, y);
      let h;
      a && (h = a.baseOptions);
      const f = { method: "GET", ...h, ...i }, R = {}, A = {};
      await P(R, a), e !== void 0 && (A.limit = e), t !== void 0 && (A.page = t), o !== void 0 && (A.documentType = o), r !== void 0 && (A.accountId = r), n !== void 0 && (A.isBatch = n), l && (A.filter = l), s !== void 0 && (A.orderBy = s), m(d, A);
      let w = h && h.headers ? h.headers : {};
      return f.headers = { ...R, ...w, ...i.headers }, {
        url: O(d),
        options: f
      };
    },
    /**
     * 
     * @summary Returns export headers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentRegistryControllerGetExportHeaders: async (e = {}) => {
      const t = "/api3/document-registry/document/export/headers", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    }
  };
}, Ce = function(a) {
  const e = Ha(a);
  return {
    /**
     * 
     * @summary Starts export operation
     * @param {number} limit 
     * @param {number} page 
     * @param {ExportDocumentsReq} exportDocumentsReq 
     * @param {string} [documentType] 
     * @param {number} [accountId] 
     * @param {boolean} [isBatch] 
     * @param {Array<string>} [filter] 
     * @param {object} [orderBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentRegistryControllerExportDocuments(t, o, r, n, l, s, i, c, d) {
      const h = await e.documentRegistryControllerExportDocuments(t, o, r, n, l, s, i, c, d);
      return V(h, u, C, a);
    },
    /**
     * 
     * @summary Returns document types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentRegistryControllerGetDocumentTypes(t) {
      const o = await e.documentRegistryControllerGetDocumentTypes(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Returns documents
     * @param {number} limit 
     * @param {number} page 
     * @param {string} [documentType] 
     * @param {number} [accountId] 
     * @param {boolean} [isBatch] 
     * @param {Array<string>} [filter] 
     * @param {object} [orderBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentRegistryControllerGetDocuments(t, o, r, n, l, s, i, c) {
      const d = await e.documentRegistryControllerGetDocuments(t, o, r, n, l, s, i, c);
      return V(d, u, C, a);
    },
    /**
     * 
     * @summary Returns export headers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentRegistryControllerGetExportHeaders(t) {
      const o = await e.documentRegistryControllerGetExportHeaders(t);
      return V(o, u, C, a);
    }
  };
}, ns = function(a, e, t) {
  const o = Ce(a);
  return {
    /**
     * 
     * @summary Starts export operation
     * @param {DocumentRegistryApiDocumentRegistryControllerExportDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentRegistryControllerExportDocuments(r, n) {
      return o.documentRegistryControllerExportDocuments(r.limit, r.page, r.exportDocumentsReq, r.documentType, r.accountId, r.isBatch, r.filter, r.orderBy, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns document types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentRegistryControllerGetDocumentTypes(r) {
      return o.documentRegistryControllerGetDocumentTypes(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Returns documents
     * @param {DocumentRegistryApiDocumentRegistryControllerGetDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentRegistryControllerGetDocuments(r, n) {
      return o.documentRegistryControllerGetDocuments(r.limit, r.page, r.documentType, r.accountId, r.isBatch, r.filter, r.orderBy, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns export headers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentRegistryControllerGetExportHeaders(r) {
      return o.documentRegistryControllerGetExportHeaders(r).then((n) => n(t, e));
    }
  };
};
class Qa extends v {
  /**
   * 
   * @summary Starts export operation
   * @param {DocumentRegistryApiDocumentRegistryControllerExportDocumentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentRegistryApi
   */
  exportDocuments(e, t) {
    return Ce(this.configuration).documentRegistryControllerExportDocuments(e.limit, e.page, e.exportDocumentsReq, e.documentType, e.accountId, e.isBatch, e.filter, e.orderBy, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns document types
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentRegistryApi
   */
  getDocumentTypes(e) {
    return Ce(this.configuration).documentRegistryControllerGetDocumentTypes(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns documents
   * @param {DocumentRegistryApiDocumentRegistryControllerGetDocumentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentRegistryApi
   */
  getDocuments(e, t) {
    return Ce(this.configuration).documentRegistryControllerGetDocuments(e.limit, e.page, e.documentType, e.accountId, e.isBatch, e.filter, e.orderBy, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns export headers
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentRegistryApi
   */
  getExportHeaders(e) {
    return Ce(this.configuration).documentRegistryControllerGetExportHeaders(e).then((t) => t(this.axios, this.basePath));
  }
}
const Wa = function(a) {
  return {
    /**
     * 
     * @summary Creating the document schedule
     * @param {CreateDocumentScheduleReq} createDocumentScheduleReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentScheduleControllerCreateScheduledDoc: async (e, t = {}) => {
      p("documentScheduleControllerCreateScheduledDoc", "createDocumentScheduleReq", e);
      const o = "/api3/document/schedule", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Deleting the document schedule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentScheduleControllerDeleteScheduleDoc: async (e = {}) => {
      const t = "/api3/document/schedule/{scheduleId}", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "DELETE", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Getting the document schedule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentScheduleControllerGetScheduledDocs: async (e = {}) => {
      const t = "/api3/document/schedule", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Updating the document schedule
     * @param {UpdateDocumentScheduleReq} updateDocumentScheduleReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentScheduleControllerUpdateScheduledDoc: async (e, t = {}) => {
      p("documentScheduleControllerUpdateScheduledDoc", "updateDocumentScheduleReq", e);
      const o = "/api3/document/schedule", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "PUT", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    }
  };
}, ye = function(a) {
  const e = Wa(a);
  return {
    /**
     * 
     * @summary Creating the document schedule
     * @param {CreateDocumentScheduleReq} createDocumentScheduleReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentScheduleControllerCreateScheduledDoc(t, o) {
      const r = await e.documentScheduleControllerCreateScheduledDoc(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Deleting the document schedule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentScheduleControllerDeleteScheduleDoc(t) {
      const o = await e.documentScheduleControllerDeleteScheduleDoc(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Getting the document schedule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentScheduleControllerGetScheduledDocs(t) {
      const o = await e.documentScheduleControllerGetScheduledDocs(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Updating the document schedule
     * @param {UpdateDocumentScheduleReq} updateDocumentScheduleReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentScheduleControllerUpdateScheduledDoc(t, o) {
      const r = await e.documentScheduleControllerUpdateScheduledDoc(t, o);
      return V(r, u, C, a);
    }
  };
}, ls = function(a, e, t) {
  const o = ye(a);
  return {
    /**
     * 
     * @summary Creating the document schedule
     * @param {DocumentScheduleApiDocumentScheduleControllerCreateScheduledDocRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentScheduleControllerCreateScheduledDoc(r, n) {
      return o.documentScheduleControllerCreateScheduledDoc(r.createDocumentScheduleReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Deleting the document schedule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentScheduleControllerDeleteScheduleDoc(r) {
      return o.documentScheduleControllerDeleteScheduleDoc(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Getting the document schedule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentScheduleControllerGetScheduledDocs(r) {
      return o.documentScheduleControllerGetScheduledDocs(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Updating the document schedule
     * @param {DocumentScheduleApiDocumentScheduleControllerUpdateScheduledDocRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentScheduleControllerUpdateScheduledDoc(r, n) {
      return o.documentScheduleControllerUpdateScheduledDoc(r.updateDocumentScheduleReq, n).then((l) => l(t, e));
    }
  };
};
class $a extends v {
  /**
   * 
   * @summary Creating the document schedule
   * @param {DocumentScheduleApiDocumentScheduleControllerCreateScheduledDocRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentScheduleApi
   */
  createScheduledDoc(e, t) {
    return ye(this.configuration).documentScheduleControllerCreateScheduledDoc(e.createDocumentScheduleReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Deleting the document schedule
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentScheduleApi
   */
  deleteScheduleDoc(e) {
    return ye(this.configuration).documentScheduleControllerDeleteScheduleDoc(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting the document schedule
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentScheduleApi
   */
  getScheduledDocs(e) {
    return ye(this.configuration).documentScheduleControllerGetScheduledDocs(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updating the document schedule
   * @param {DocumentScheduleApiDocumentScheduleControllerUpdateScheduledDocRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentScheduleApi
   */
  updateScheduledDoc(e, t) {
    return ye(this.configuration).documentScheduleControllerUpdateScheduledDoc(e.updateDocumentScheduleReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const Na = function(a) {
  return {
    /**
     * 
     * @summary Returns available entity names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityControllerGetEntities: async (e = {}) => {
      const t = "/api3/entity-info", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Returns information about entity
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityControllerGetEntityInfo: async (e, t = {}) => {
      p("entityControllerGetEntityInfo", "name", e);
      const o = "/api3/entity-info/{name}".replace("{name}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    }
  };
}, ct = function(a) {
  const e = Na(a);
  return {
    /**
     * 
     * @summary Returns available entity names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async entityControllerGetEntities(t) {
      const o = await e.entityControllerGetEntities(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Returns information about entity
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async entityControllerGetEntityInfo(t, o) {
      const r = await e.entityControllerGetEntityInfo(t, o);
      return V(r, u, C, a);
    }
  };
}, ss = function(a, e, t) {
  const o = ct(a);
  return {
    /**
     * 
     * @summary Returns available entity names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityControllerGetEntities(r) {
      return o.entityControllerGetEntities(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Returns information about entity
     * @param {EntityApiEntityControllerGetEntityInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityControllerGetEntityInfo(r, n) {
      return o.entityControllerGetEntityInfo(r.name, n).then((l) => l(t, e));
    }
  };
};
class _a extends v {
  /**
   * 
   * @summary Returns available entity names
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  getEntities(e) {
    return ct(this.configuration).entityControllerGetEntities(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns information about entity
   * @param {EntityApiEntityControllerGetEntityInfoRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  getEntityInfo(e, t) {
    return ct(this.configuration).entityControllerGetEntityInfo(e.name, t).then((o) => o(this.axios, this.basePath));
  }
}
const Ma = function(a) {
  return {
    /**
     * 
     * @summary Returns a list of event channels
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventChannelControllerGetEventChannels: async (e, t, o = {}) => {
      p("eventChannelControllerGetEventChannels", "limit", e), p("eventChannelControllerGetEventChannels", "page", t);
      const r = "/api3/event/channel", n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      await P(i, a), e !== void 0 && (c.limit = e), t !== void 0 && (c.page = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    }
  };
}, Cr = function(a) {
  const e = Ma(a);
  return {
    /**
     * 
     * @summary Returns a list of event channels
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventChannelControllerGetEventChannels(t, o, r) {
      const n = await e.eventChannelControllerGetEventChannels(t, o, r);
      return V(n, u, C, a);
    }
  };
}, is = function(a, e, t) {
  const o = Cr(a);
  return {
    /**
     * 
     * @summary Returns a list of event channels
     * @param {EventChannelApiEventChannelControllerGetEventChannelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventChannelControllerGetEventChannels(r, n) {
      return o.eventChannelControllerGetEventChannels(r.limit, r.page, n).then((l) => l(t, e));
    }
  };
};
class za extends v {
  /**
   * 
   * @summary Returns a list of event channels
   * @param {EventChannelApiEventChannelControllerGetEventChannelsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventChannelApi
   */
  getEventChannels(e, t) {
    return Cr(this.configuration).eventChannelControllerGetEventChannels(e.limit, e.page, t).then((o) => o(this.axios, this.basePath));
  }
}
const Ka = function(a) {
  return {
    /**
     * 
     * @summary Creates a new event template
     * @param {AddEventTemplateReq} addEventTemplateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTemplateControllerCreateEventTemplate: async (e, t = {}) => {
      p("eventTemplateControllerCreateEventTemplate", "addEventTemplateReq", e);
      const o = "/api3/event/template", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Deletes event template
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTemplateControllerDeleteEventTemplate: async (e, t = {}) => {
      p("eventTemplateControllerDeleteEventTemplate", "id", e);
      const o = "/api3/event/template/{id}".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "DELETE", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns a list of event templates
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTemplateControllerGetEventTemplateList: async (e, t, o = {}) => {
      p("eventTemplateControllerGetEventTemplateList", "limit", e), p("eventTemplateControllerGetEventTemplateList", "page", t);
      const r = "/api3/event/template", n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      await P(i, a), e !== void 0 && (c.limit = e), t !== void 0 && (c.page = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Updates event template
     * @param {number} id 
     * @param {UpdateEventTemplateReq} updateEventTemplateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTemplateControllerUpdateEventTemplate: async (e, t, o = {}) => {
      p("eventTemplateControllerUpdateEventTemplate", "id", e), p("eventTemplateControllerUpdateEventTemplate", "updateEventTemplateReq", t);
      const r = "/api3/event/template/{id}".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, me = function(a) {
  const e = Ka(a);
  return {
    /**
     * 
     * @summary Creates a new event template
     * @param {AddEventTemplateReq} addEventTemplateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventTemplateControllerCreateEventTemplate(t, o) {
      const r = await e.eventTemplateControllerCreateEventTemplate(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Deletes event template
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventTemplateControllerDeleteEventTemplate(t, o) {
      const r = await e.eventTemplateControllerDeleteEventTemplate(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns a list of event templates
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventTemplateControllerGetEventTemplateList(t, o, r) {
      const n = await e.eventTemplateControllerGetEventTemplateList(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Updates event template
     * @param {number} id 
     * @param {UpdateEventTemplateReq} updateEventTemplateReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventTemplateControllerUpdateEventTemplate(t, o, r) {
      const n = await e.eventTemplateControllerUpdateEventTemplate(t, o, r);
      return V(n, u, C, a);
    }
  };
}, cs = function(a, e, t) {
  const o = me(a);
  return {
    /**
     * 
     * @summary Creates a new event template
     * @param {EventTemplateApiEventTemplateControllerCreateEventTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTemplateControllerCreateEventTemplate(r, n) {
      return o.eventTemplateControllerCreateEventTemplate(r.addEventTemplateReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Deletes event template
     * @param {EventTemplateApiEventTemplateControllerDeleteEventTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTemplateControllerDeleteEventTemplate(r, n) {
      return o.eventTemplateControllerDeleteEventTemplate(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns a list of event templates
     * @param {EventTemplateApiEventTemplateControllerGetEventTemplateListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTemplateControllerGetEventTemplateList(r, n) {
      return o.eventTemplateControllerGetEventTemplateList(r.limit, r.page, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Updates event template
     * @param {EventTemplateApiEventTemplateControllerUpdateEventTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTemplateControllerUpdateEventTemplate(r, n) {
      return o.eventTemplateControllerUpdateEventTemplate(r.id, r.updateEventTemplateReq, n).then((l) => l(t, e));
    }
  };
};
class Ja extends v {
  /**
   * 
   * @summary Creates a new event template
   * @param {EventTemplateApiEventTemplateControllerCreateEventTemplateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventTemplateApi
   */
  createEventTemplate(e, t) {
    return me(this.configuration).eventTemplateControllerCreateEventTemplate(e.addEventTemplateReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Deletes event template
   * @param {EventTemplateApiEventTemplateControllerDeleteEventTemplateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventTemplateApi
   */
  deleteEventTemplate(e, t) {
    return me(this.configuration).eventTemplateControllerDeleteEventTemplate(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns a list of event templates
   * @param {EventTemplateApiEventTemplateControllerGetEventTemplateListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventTemplateApi
   */
  getEventTemplateList(e, t) {
    return me(this.configuration).eventTemplateControllerGetEventTemplateList(e.limit, e.page, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updates event template
   * @param {EventTemplateApiEventTemplateControllerUpdateEventTemplateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventTemplateApi
   */
  updateEventTemplate(e, t) {
    return me(this.configuration).eventTemplateControllerUpdateEventTemplate(e.id, e.updateEventTemplateReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const Xa = function(a) {
  return {
    /**
     * 
     * @summary Creates a new event translation
     * @param {AddEventTranslationReq} addEventTranslationReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTranslationControllerCreateEventTranslation: async (e, t = {}) => {
      p("eventTranslationControllerCreateEventTranslation", "addEventTranslationReq", e);
      const o = "/api3/event/translation", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Deletes event translation
     * @param {number} id Event translation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTranslationControllerDeleteEventTranslation: async (e, t = {}) => {
      p("eventTranslationControllerDeleteEventTranslation", "id", e);
      const o = "/api3/event/translation/{id}".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "DELETE", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns a list of event translations
     * @param {number} limit 
     * @param {number} page 
     * @param {any} [eventTypeId] 
     * @param {string} [languageId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTranslationControllerGetEventTranslationList: async (e, t, o, r, n = {}) => {
      p("eventTranslationControllerGetEventTranslationList", "limit", e), p("eventTranslationControllerGetEventTranslationList", "page", t);
      const l = "/api3/event/translation", s = new URL(l, y);
      let i;
      a && (i = a.baseOptions);
      const c = { method: "GET", ...i, ...n }, d = {}, h = {};
      await P(d, a), e !== void 0 && (h.limit = e), t !== void 0 && (h.page = t), o !== void 0 && (h.eventTypeId = o), r !== void 0 && (h.languageId = r), m(s, h);
      let f = i && i.headers ? i.headers : {};
      return c.headers = { ...d, ...f, ...n.headers }, {
        url: O(s),
        options: c
      };
    },
    /**
     * 
     * @summary Updates event translation
     * @param {number} id Event translation ID
     * @param {UpdateEventTranslationReq} updateEventTranslationReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTranslationControllerUpdateEventTranslation: async (e, t, o = {}) => {
      p("eventTranslationControllerUpdateEventTranslation", "id", e), p("eventTranslationControllerUpdateEventTranslation", "updateEventTranslationReq", t);
      const r = "/api3/event/translation/{id}".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, Oe = function(a) {
  const e = Xa(a);
  return {
    /**
     * 
     * @summary Creates a new event translation
     * @param {AddEventTranslationReq} addEventTranslationReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventTranslationControllerCreateEventTranslation(t, o) {
      const r = await e.eventTranslationControllerCreateEventTranslation(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Deletes event translation
     * @param {number} id Event translation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventTranslationControllerDeleteEventTranslation(t, o) {
      const r = await e.eventTranslationControllerDeleteEventTranslation(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns a list of event translations
     * @param {number} limit 
     * @param {number} page 
     * @param {any} [eventTypeId] 
     * @param {string} [languageId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventTranslationControllerGetEventTranslationList(t, o, r, n, l) {
      const s = await e.eventTranslationControllerGetEventTranslationList(t, o, r, n, l);
      return V(s, u, C, a);
    },
    /**
     * 
     * @summary Updates event translation
     * @param {number} id Event translation ID
     * @param {UpdateEventTranslationReq} updateEventTranslationReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventTranslationControllerUpdateEventTranslation(t, o, r) {
      const n = await e.eventTranslationControllerUpdateEventTranslation(t, o, r);
      return V(n, u, C, a);
    }
  };
}, ds = function(a, e, t) {
  const o = Oe(a);
  return {
    /**
     * 
     * @summary Creates a new event translation
     * @param {EventTranslationApiEventTranslationControllerCreateEventTranslationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTranslationControllerCreateEventTranslation(r, n) {
      return o.eventTranslationControllerCreateEventTranslation(r.addEventTranslationReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Deletes event translation
     * @param {EventTranslationApiEventTranslationControllerDeleteEventTranslationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTranslationControllerDeleteEventTranslation(r, n) {
      return o.eventTranslationControllerDeleteEventTranslation(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns a list of event translations
     * @param {EventTranslationApiEventTranslationControllerGetEventTranslationListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTranslationControllerGetEventTranslationList(r, n) {
      return o.eventTranslationControllerGetEventTranslationList(r.limit, r.page, r.eventTypeId, r.languageId, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Updates event translation
     * @param {EventTranslationApiEventTranslationControllerUpdateEventTranslationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTranslationControllerUpdateEventTranslation(r, n) {
      return o.eventTranslationControllerUpdateEventTranslation(r.id, r.updateEventTranslationReq, n).then((l) => l(t, e));
    }
  };
};
class Za extends v {
  /**
   * 
   * @summary Creates a new event translation
   * @param {EventTranslationApiEventTranslationControllerCreateEventTranslationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventTranslationApi
   */
  createEventTranslation(e, t) {
    return Oe(this.configuration).eventTranslationControllerCreateEventTranslation(e.addEventTranslationReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Deletes event translation
   * @param {EventTranslationApiEventTranslationControllerDeleteEventTranslationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventTranslationApi
   */
  deleteEventTranslation(e, t) {
    return Oe(this.configuration).eventTranslationControllerDeleteEventTranslation(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns a list of event translations
   * @param {EventTranslationApiEventTranslationControllerGetEventTranslationListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventTranslationApi
   */
  getEventTranslationList(e, t) {
    return Oe(this.configuration).eventTranslationControllerGetEventTranslationList(e.limit, e.page, e.eventTypeId, e.languageId, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updates event translation
   * @param {EventTranslationApiEventTranslationControllerUpdateEventTranslationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventTranslationApi
   */
  updateEventTranslation(e, t) {
    return Oe(this.configuration).eventTranslationControllerUpdateEventTranslation(e.id, e.updateEventTranslationReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const Ya = function(a) {
  return {
    /**
     * 
     * @summary Returns a list of event types
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTypeControllerGetEventTypeList: async (e, t, o = {}) => {
      p("eventTypeControllerGetEventTypeList", "limit", e), p("eventTypeControllerGetEventTypeList", "page", t);
      const r = "/api3/event/type", n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      await P(i, a), e !== void 0 && (c.limit = e), t !== void 0 && (c.page = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Updates event type
     * @param {number} id Event type ID
     * @param {UpdateEventTypeReq} updateEventTypeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTypeControllerUpdateEventType: async (e, t, o = {}) => {
      p("eventTypeControllerUpdateEventType", "id", e), p("eventTypeControllerUpdateEventType", "updateEventTypeReq", t);
      const r = "/api3/event/type/{id}".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, dt = function(a) {
  const e = Ya(a);
  return {
    /**
     * 
     * @summary Returns a list of event types
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventTypeControllerGetEventTypeList(t, o, r) {
      const n = await e.eventTypeControllerGetEventTypeList(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Updates event type
     * @param {number} id Event type ID
     * @param {UpdateEventTypeReq} updateEventTypeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventTypeControllerUpdateEventType(t, o, r) {
      const n = await e.eventTypeControllerUpdateEventType(t, o, r);
      return V(n, u, C, a);
    }
  };
}, ps = function(a, e, t) {
  const o = dt(a);
  return {
    /**
     * 
     * @summary Returns a list of event types
     * @param {EventTypeApiEventTypeControllerGetEventTypeListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTypeControllerGetEventTypeList(r, n) {
      return o.eventTypeControllerGetEventTypeList(r.limit, r.page, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Updates event type
     * @param {EventTypeApiEventTypeControllerUpdateEventTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventTypeControllerUpdateEventType(r, n) {
      return o.eventTypeControllerUpdateEventType(r.id, r.updateEventTypeReq, n).then((l) => l(t, e));
    }
  };
};
class qa extends v {
  /**
   * 
   * @summary Returns a list of event types
   * @param {EventTypeApiEventTypeControllerGetEventTypeListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventTypeApi
   */
  getEventTypeList(e, t) {
    return dt(this.configuration).eventTypeControllerGetEventTypeList(e.limit, e.page, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updates event type
   * @param {EventTypeApiEventTypeControllerUpdateEventTypeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventTypeApi
   */
  updateEventType(e, t) {
    return dt(this.configuration).eventTypeControllerUpdateEventType(e.id, e.updateEventTypeReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const en = function(a) {
  return {
    /**
     * 
     * @summary Launch export marketing activity
     * @param {string} field Filter field
     * @param {string} operation 
     * @param {object} value 
     * @param {MarketingActivityExportReq} marketingActivityExportReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    marketingActivityExportControllerMarketingActivityExport: async (e, t, o, r, n = {}) => {
      p("marketingActivityExportControllerMarketingActivityExport", "field", e), p("marketingActivityExportControllerMarketingActivityExport", "operation", t), p("marketingActivityExportControllerMarketingActivityExport", "value", o), p("marketingActivityExportControllerMarketingActivityExport", "marketingActivityExportReq", r);
      const l = "/api3/export/marketing-activity", s = new URL(l, y);
      let i;
      a && (i = a.baseOptions);
      const c = { method: "POST", ...i, ...n }, d = {}, h = {};
      await P(d, a), e !== void 0 && (h.field = e), t !== void 0 && (h.operation = t), o !== void 0 && (h.value = o), d["Content-Type"] = "application/json", m(s, h);
      let f = i && i.headers ? i.headers : {};
      return c.headers = { ...d, ...f, ...n.headers }, c.data = S(r, c, a), {
        url: O(s),
        options: c
      };
    }
  };
}, yr = function(a) {
  const e = en(a);
  return {
    /**
     * 
     * @summary Launch export marketing activity
     * @param {string} field Filter field
     * @param {string} operation 
     * @param {object} value 
     * @param {MarketingActivityExportReq} marketingActivityExportReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async marketingActivityExportControllerMarketingActivityExport(t, o, r, n, l) {
      const s = await e.marketingActivityExportControllerMarketingActivityExport(t, o, r, n, l);
      return V(s, u, C, a);
    }
  };
}, hs = function(a, e, t) {
  const o = yr(a);
  return {
    /**
     * 
     * @summary Launch export marketing activity
     * @param {ExportApiMarketingActivityExportControllerMarketingActivityExportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    marketingActivityExportControllerMarketingActivityExport(r, n) {
      return o.marketingActivityExportControllerMarketingActivityExport(r.field, r.operation, r.value, r.marketingActivityExportReq, n).then((l) => l(t, e));
    }
  };
};
class tn extends v {
  /**
   * 
   * @summary Launch export marketing activity
   * @param {ExportApiMarketingActivityExportControllerMarketingActivityExportRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportApi
   */
  marketingActivityExport(e, t) {
    return yr(this.configuration).marketingActivityExportControllerMarketingActivityExport(e.field, e.operation, e.value, e.marketingActivityExportReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const rn = function(a) {
  return {
    /**
     * 
     * @summary Getting a list of field types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fieldTypeControllerGetFieldTypes: async (e = {}) => {
      const t = "/api3/field-type", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    }
  };
}, mr = function(a) {
  const e = rn(a);
  return {
    /**
     * 
     * @summary Getting a list of field types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fieldTypeControllerGetFieldTypes(t) {
      const o = await e.fieldTypeControllerGetFieldTypes(t);
      return V(o, u, C, a);
    }
  };
}, us = function(a, e, t) {
  const o = mr(a);
  return {
    /**
     * 
     * @summary Getting a list of field types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fieldTypeControllerGetFieldTypes(r) {
      return o.fieldTypeControllerGetFieldTypes(r).then((n) => n(t, e));
    }
  };
};
class on extends v {
  /**
   * 
   * @summary Getting a list of field types
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FieldTypeApi
   */
  getFieldTypes(e) {
    return mr(this.configuration).fieldTypeControllerGetFieldTypes(e).then((t) => t(this.axios, this.basePath));
  }
}
const an = function(a) {
  return {
    /**
     * 
     * @summary Returns the number of active accounts
     * @param {any} [endDate] end date of period to calculate
     * @param {any} [period] period from endDate backwards in days
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomeCenterControllerGetCount: async (e, t, o = {}) => {
      const r = "/api3/income-center/count", n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      await P(i, a), e !== void 0 && (c.endDate = e), t !== void 0 && (c.period = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    }
  };
}, Or = function(a) {
  const e = an(a);
  return {
    /**
     * 
     * @summary Returns the number of active accounts
     * @param {any} [endDate] end date of period to calculate
     * @param {any} [period] period from endDate backwards in days
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incomeCenterControllerGetCount(t, o, r) {
      const n = await e.incomeCenterControllerGetCount(t, o, r);
      return V(n, u, C, a);
    }
  };
}, Cs = function(a, e, t) {
  const o = Or(a);
  return {
    /**
     * 
     * @summary Returns the number of active accounts
     * @param {IncomeCenterApiIncomeCenterControllerGetCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incomeCenterControllerGetCount(r = {}, n) {
      return o.incomeCenterControllerGetCount(r.endDate, r.period, n).then((l) => l(t, e));
    }
  };
};
class nn extends v {
  /**
   * 
   * @summary Returns the number of active accounts
   * @param {IncomeCenterApiIncomeCenterControllerGetCountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IncomeCenterApi
   */
  getCount(e = {}, t) {
    return Or(this.configuration).incomeCenterControllerGetCount(e.endDate, e.period, t).then((o) => o(this.axios, this.basePath));
  }
}
const ln = function(a) {
  return {
    /**
     * 
     * @summary Adds a new integration
     * @param {AddIntegrationReq} addIntegrationReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    integrationControllerAddIntegration: async (e, t = {}) => {
      p("integrationControllerAddIntegration", "addIntegrationReq", e);
      const o = "/api3/integration", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Deletes an integration
     * @param {string} id Integration id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    integrationControllerDeleteIntegration: async (e, t = {}) => {
      p("integrationControllerDeleteIntegration", "id", e);
      const o = "/api3/integration/{id}".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "DELETE", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns a list of integrations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    integrationControllerGetList: async (e = {}) => {
      const t = "/api3/integration", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Updates an integration secret key
     * @param {string} id Integration id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    integrationControllerRegenerateSecretKey: async (e, t = {}) => {
      p("integrationControllerRegenerateSecretKey", "id", e);
      const o = "/api3/integration/{id}/secret-key".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "PUT", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Updates an integration
     * @param {string} id Integration id
     * @param {UpdateIntegrationReq} updateIntegrationReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    integrationControllerUpdateIntegration: async (e, t, o = {}) => {
      p("integrationControllerUpdateIntegration", "id", e), p("integrationControllerUpdateIntegration", "updateIntegrationReq", t);
      const r = "/api3/integration/{id}".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, oe = function(a) {
  const e = ln(a);
  return {
    /**
     * 
     * @summary Adds a new integration
     * @param {AddIntegrationReq} addIntegrationReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async integrationControllerAddIntegration(t, o) {
      const r = await e.integrationControllerAddIntegration(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Deletes an integration
     * @param {string} id Integration id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async integrationControllerDeleteIntegration(t, o) {
      const r = await e.integrationControllerDeleteIntegration(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns a list of integrations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async integrationControllerGetList(t) {
      const o = await e.integrationControllerGetList(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Updates an integration secret key
     * @param {string} id Integration id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async integrationControllerRegenerateSecretKey(t, o) {
      const r = await e.integrationControllerRegenerateSecretKey(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Updates an integration
     * @param {string} id Integration id
     * @param {UpdateIntegrationReq} updateIntegrationReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async integrationControllerUpdateIntegration(t, o, r) {
      const n = await e.integrationControllerUpdateIntegration(t, o, r);
      return V(n, u, C, a);
    }
  };
}, ys = function(a, e, t) {
  const o = oe(a);
  return {
    /**
     * 
     * @summary Adds a new integration
     * @param {IntegrationApiIntegrationControllerAddIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    integrationControllerAddIntegration(r, n) {
      return o.integrationControllerAddIntegration(r.addIntegrationReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Deletes an integration
     * @param {IntegrationApiIntegrationControllerDeleteIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    integrationControllerDeleteIntegration(r, n) {
      return o.integrationControllerDeleteIntegration(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns a list of integrations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    integrationControllerGetList(r) {
      return o.integrationControllerGetList(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Updates an integration secret key
     * @param {IntegrationApiIntegrationControllerRegenerateSecretKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    integrationControllerRegenerateSecretKey(r, n) {
      return o.integrationControllerRegenerateSecretKey(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Updates an integration
     * @param {IntegrationApiIntegrationControllerUpdateIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    integrationControllerUpdateIntegration(r, n) {
      return o.integrationControllerUpdateIntegration(r.id, r.updateIntegrationReq, n).then((l) => l(t, e));
    }
  };
};
class sn extends v {
  /**
   * 
   * @summary Adds a new integration
   * @param {IntegrationApiIntegrationControllerAddIntegrationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IntegrationApi
   */
  addIntegration(e, t) {
    return oe(this.configuration).integrationControllerAddIntegration(e.addIntegrationReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Deletes an integration
   * @param {IntegrationApiIntegrationControllerDeleteIntegrationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IntegrationApi
   */
  deleteIntegration(e, t) {
    return oe(this.configuration).integrationControllerDeleteIntegration(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns a list of integrations
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IntegrationApi
   */
  getList(e) {
    return oe(this.configuration).integrationControllerGetList(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updates an integration secret key
   * @param {IntegrationApiIntegrationControllerRegenerateSecretKeyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IntegrationApi
   */
  regenerateSecretKey(e, t) {
    return oe(this.configuration).integrationControllerRegenerateSecretKey(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updates an integration
   * @param {IntegrationApiIntegrationControllerUpdateIntegrationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IntegrationApi
   */
  updateIntegration(e, t) {
    return oe(this.configuration).integrationControllerUpdateIntegration(e.id, e.updateIntegrationReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const cn = function(a) {
  return {
    /**
     * 
     * @summary Get a list of account invoices
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountInvoiceControllerGetAccountInvoiceList: async (e, t, o, r, n, l = {}) => {
      p("accountInvoiceControllerGetAccountInvoiceList", "limit", e), p("accountInvoiceControllerGetAccountInvoiceList", "page", t), p("accountInvoiceControllerGetAccountInvoiceList", "id", o);
      const s = "/api3/account/{id}/invoice".replace("{id}", encodeURIComponent(String(o))), i = new URL(s, y);
      let c;
      a && (c = a.baseOptions);
      const d = { method: "GET", ...c, ...l }, h = {}, f = {};
      await P(h, a), e !== void 0 && (f.limit = e), t !== void 0 && (f.page = t), r !== void 0 && (f.orderBy = r), n !== void 0 && (f.filter = n), m(i, f);
      let R = c && c.headers ? c.headers : {};
      return d.headers = { ...h, ...R, ...l.headers }, {
        url: O(i),
        options: d
      };
    },
    /**
     * 
     * @summary Create invoice
     * @param {CreateInvoiceParamsReq} createInvoiceParamsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invoiceControllerCreateInvoice: async (e, t = {}) => {
      p("invoiceControllerCreateInvoice", "createInvoiceParamsReq", e);
      const o = "/api3/invoice", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns export headers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invoiceControllerGetExportHeaders: async (e = {}) => {
      const t = "/api3/invoice/export/headers", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Get invoice
     * @param {number} invoiceId Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invoiceControllerGetInvoice: async (e, t = {}) => {
      p("invoiceControllerGetInvoice", "invoiceId", e);
      const o = "/api3/invoice/{invoiceId}".replace("{invoiceId}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Get a list of invoices
     * @param {number} limit 
     * @param {number} page 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invoiceControllerGetInvoiceList: async (e, t, o, r, n = {}) => {
      p("invoiceControllerGetInvoiceList", "limit", e), p("invoiceControllerGetInvoiceList", "page", t);
      const l = "/api3/invoice", s = new URL(l, y);
      let i;
      a && (i = a.baseOptions);
      const c = { method: "GET", ...i, ...n }, d = {}, h = {};
      await P(d, a), e !== void 0 && (h.limit = e), t !== void 0 && (h.page = t), o !== void 0 && (h.orderBy = o), r !== void 0 && (h.filter = r), m(s, h);
      let f = i && i.headers ? i.headers : {};
      return c.headers = { ...d, ...f, ...n.headers }, {
        url: O(s),
        options: c
      };
    },
    /**
     * 
     * @summary Starts export operation
     * @param {InvoiceExportReq} invoiceExportReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invoiceControllerStartExport: async (e, t = {}) => {
      p("invoiceControllerStartExport", "invoiceExportReq", e);
      const o = "/api3/invoice/export", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Update invoice
     * @param {UpdateInvoiceParamsReq} updateInvoiceParamsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invoiceControllerUpdateInvoice: async (e, t = {}) => {
      p("invoiceControllerUpdateInvoice", "updateInvoiceParamsReq", e);
      const o = "/api3/invoice", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "PUT", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    }
  };
}, M = function(a) {
  const e = cn(a);
  return {
    /**
     * 
     * @summary Get a list of account invoices
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountInvoiceControllerGetAccountInvoiceList(t, o, r, n, l, s) {
      const i = await e.accountInvoiceControllerGetAccountInvoiceList(t, o, r, n, l, s);
      return V(i, u, C, a);
    },
    /**
     * 
     * @summary Create invoice
     * @param {CreateInvoiceParamsReq} createInvoiceParamsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invoiceControllerCreateInvoice(t, o) {
      const r = await e.invoiceControllerCreateInvoice(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns export headers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invoiceControllerGetExportHeaders(t) {
      const o = await e.invoiceControllerGetExportHeaders(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Get invoice
     * @param {number} invoiceId Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invoiceControllerGetInvoice(t, o) {
      const r = await e.invoiceControllerGetInvoice(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Get a list of invoices
     * @param {number} limit 
     * @param {number} page 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invoiceControllerGetInvoiceList(t, o, r, n, l) {
      const s = await e.invoiceControllerGetInvoiceList(t, o, r, n, l);
      return V(s, u, C, a);
    },
    /**
     * 
     * @summary Starts export operation
     * @param {InvoiceExportReq} invoiceExportReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invoiceControllerStartExport(t, o) {
      const r = await e.invoiceControllerStartExport(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Update invoice
     * @param {UpdateInvoiceParamsReq} updateInvoiceParamsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invoiceControllerUpdateInvoice(t, o) {
      const r = await e.invoiceControllerUpdateInvoice(t, o);
      return V(r, u, C, a);
    }
  };
}, ms = function(a, e, t) {
  const o = M(a);
  return {
    /**
     * 
     * @summary Get a list of account invoices
     * @param {InvoiceApiAccountInvoiceControllerGetAccountInvoiceListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountInvoiceControllerGetAccountInvoiceList(r, n) {
      return o.accountInvoiceControllerGetAccountInvoiceList(r.limit, r.page, r.id, r.orderBy, r.filter, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Create invoice
     * @param {InvoiceApiInvoiceControllerCreateInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invoiceControllerCreateInvoice(r, n) {
      return o.invoiceControllerCreateInvoice(r.createInvoiceParamsReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns export headers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invoiceControllerGetExportHeaders(r) {
      return o.invoiceControllerGetExportHeaders(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Get invoice
     * @param {InvoiceApiInvoiceControllerGetInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invoiceControllerGetInvoice(r, n) {
      return o.invoiceControllerGetInvoice(r.invoiceId, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Get a list of invoices
     * @param {InvoiceApiInvoiceControllerGetInvoiceListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invoiceControllerGetInvoiceList(r, n) {
      return o.invoiceControllerGetInvoiceList(r.limit, r.page, r.orderBy, r.filter, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Starts export operation
     * @param {InvoiceApiInvoiceControllerStartExportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invoiceControllerStartExport(r, n) {
      return o.invoiceControllerStartExport(r.invoiceExportReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Update invoice
     * @param {InvoiceApiInvoiceControllerUpdateInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invoiceControllerUpdateInvoice(r, n) {
      return o.invoiceControllerUpdateInvoice(r.updateInvoiceParamsReq, n).then((l) => l(t, e));
    }
  };
};
class dn extends v {
  /**
   * 
   * @summary Get a list of account invoices
   * @param {InvoiceApiAccountInvoiceControllerGetAccountInvoiceListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  getAccountInvoiceList(e, t) {
    return M(this.configuration).accountInvoiceControllerGetAccountInvoiceList(e.limit, e.page, e.id, e.orderBy, e.filter, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Create invoice
   * @param {InvoiceApiInvoiceControllerCreateInvoiceRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  createInvoice(e, t) {
    return M(this.configuration).invoiceControllerCreateInvoice(e.createInvoiceParamsReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns export headers
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  getExportHeaders(e) {
    return M(this.configuration).invoiceControllerGetExportHeaders(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get invoice
   * @param {InvoiceApiInvoiceControllerGetInvoiceRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  getInvoice(e, t) {
    return M(this.configuration).invoiceControllerGetInvoice(e.invoiceId, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get a list of invoices
   * @param {InvoiceApiInvoiceControllerGetInvoiceListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  getInvoiceList(e, t) {
    return M(this.configuration).invoiceControllerGetInvoiceList(e.limit, e.page, e.orderBy, e.filter, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Starts export operation
   * @param {InvoiceApiInvoiceControllerStartExportRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  startExport(e, t) {
    return M(this.configuration).invoiceControllerStartExport(e.invoiceExportReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update invoice
   * @param {InvoiceApiInvoiceControllerUpdateInvoiceRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */
  updateInvoice(e, t) {
    return M(this.configuration).invoiceControllerUpdateInvoice(e.updateInvoiceParamsReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const pn = function(a) {
  return {
    /**
     * 
     * @summary Returns one message from the queue at the specified offset
     * @param {number} offset 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    kafkaControllerGetMessage: async (e, t = {}) => {
      p("kafkaControllerGetMessage", "offset", e);
      const o = "/api3/kafka/message/{offset}".replace("{offset}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns the number of messages from the queue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    kafkaControllerGetMessageTotal: async (e = {}) => {
      const t = "/api3/kafka/message/count", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Returns the list of messages from the queue
     * @param {number} offset 
     * @param {number} limit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    kafkaControllerGetMessages: async (e, t, o = {}) => {
      p("kafkaControllerGetMessages", "offset", e), p("kafkaControllerGetMessages", "limit", t);
      const r = "/api3/kafka/message", n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      await P(i, a), e !== void 0 && (c.offset = e), t !== void 0 && (c.limit = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Returns information about group offsets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    kafkaControllerGetTopicOffsets: async (e = {}) => {
      const t = "/api3/kafka/group-offsets", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    }
  };
}, Ve = function(a) {
  const e = pn(a);
  return {
    /**
     * 
     * @summary Returns one message from the queue at the specified offset
     * @param {number} offset 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async kafkaControllerGetMessage(t, o) {
      const r = await e.kafkaControllerGetMessage(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns the number of messages from the queue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async kafkaControllerGetMessageTotal(t) {
      const o = await e.kafkaControllerGetMessageTotal(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Returns the list of messages from the queue
     * @param {number} offset 
     * @param {number} limit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async kafkaControllerGetMessages(t, o, r) {
      const n = await e.kafkaControllerGetMessages(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Returns information about group offsets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async kafkaControllerGetTopicOffsets(t) {
      const o = await e.kafkaControllerGetTopicOffsets(t);
      return V(o, u, C, a);
    }
  };
}, Os = function(a, e, t) {
  const o = Ve(a);
  return {
    /**
     * 
     * @summary Returns one message from the queue at the specified offset
     * @param {KafkaApiKafkaControllerGetMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    kafkaControllerGetMessage(r, n) {
      return o.kafkaControllerGetMessage(r.offset, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns the number of messages from the queue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    kafkaControllerGetMessageTotal(r) {
      return o.kafkaControllerGetMessageTotal(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Returns the list of messages from the queue
     * @param {KafkaApiKafkaControllerGetMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    kafkaControllerGetMessages(r, n) {
      return o.kafkaControllerGetMessages(r.offset, r.limit, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns information about group offsets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    kafkaControllerGetTopicOffsets(r) {
      return o.kafkaControllerGetTopicOffsets(r).then((n) => n(t, e));
    }
  };
};
class hn extends v {
  /**
   * 
   * @summary Returns one message from the queue at the specified offset
   * @param {KafkaApiKafkaControllerGetMessageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KafkaApi
   */
  getMessage(e, t) {
    return Ve(this.configuration).kafkaControllerGetMessage(e.offset, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns the number of messages from the queue
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KafkaApi
   */
  getMessageTotal(e) {
    return Ve(this.configuration).kafkaControllerGetMessageTotal(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns the list of messages from the queue
   * @param {KafkaApiKafkaControllerGetMessagesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KafkaApi
   */
  getMessages(e, t) {
    return Ve(this.configuration).kafkaControllerGetMessages(e.offset, e.limit, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns information about group offsets
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KafkaApi
   */
  getTopicOffsets(e) {
    return Ve(this.configuration).kafkaControllerGetTopicOffsets(e).then((t) => t(this.axios, this.basePath));
  }
}
const un = function(a) {
  return {
    /**
     * 
     * @summary Creating a language
     * @param {CreateLanguageReq} createLanguageReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageControllerCreateLanguage: async (e, t = {}) => {
      p("languageControllerCreateLanguage", "createLanguageReq", e);
      const o = "/api3/language", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Deleting a language
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageControllerDeleteLanguage: async (e, t = {}) => {
      p("languageControllerDeleteLanguage", "id", e);
      const o = "/api3/language/{id}".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "DELETE", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Getting a list of languages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageControllerGetLanguages: async (e = {}) => {
      const t = "/api3/language", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Updating a language
     * @param {string} id 
     * @param {UpdateLanguageReq} updateLanguageReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageControllerUpdateLanguage: async (e, t, o = {}) => {
      p("languageControllerUpdateLanguage", "id", e), p("languageControllerUpdateLanguage", "updateLanguageReq", t);
      const r = "/api3/language/{id}".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, Pe = function(a) {
  const e = un(a);
  return {
    /**
     * 
     * @summary Creating a language
     * @param {CreateLanguageReq} createLanguageReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageControllerCreateLanguage(t, o) {
      const r = await e.languageControllerCreateLanguage(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Deleting a language
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageControllerDeleteLanguage(t, o) {
      const r = await e.languageControllerDeleteLanguage(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Getting a list of languages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageControllerGetLanguages(t) {
      const o = await e.languageControllerGetLanguages(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Updating a language
     * @param {string} id 
     * @param {UpdateLanguageReq} updateLanguageReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async languageControllerUpdateLanguage(t, o, r) {
      const n = await e.languageControllerUpdateLanguage(t, o, r);
      return V(n, u, C, a);
    }
  };
}, Vs = function(a, e, t) {
  const o = Pe(a);
  return {
    /**
     * 
     * @summary Creating a language
     * @param {LanguageApiLanguageControllerCreateLanguageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageControllerCreateLanguage(r, n) {
      return o.languageControllerCreateLanguage(r.createLanguageReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Deleting a language
     * @param {LanguageApiLanguageControllerDeleteLanguageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageControllerDeleteLanguage(r, n) {
      return o.languageControllerDeleteLanguage(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting a list of languages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageControllerGetLanguages(r) {
      return o.languageControllerGetLanguages(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Updating a language
     * @param {LanguageApiLanguageControllerUpdateLanguageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageControllerUpdateLanguage(r, n) {
      return o.languageControllerUpdateLanguage(r.id, r.updateLanguageReq, n).then((l) => l(t, e));
    }
  };
};
class Cn extends v {
  /**
   * 
   * @summary Creating a language
   * @param {LanguageApiLanguageControllerCreateLanguageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LanguageApi
   */
  createLanguage(e, t) {
    return Pe(this.configuration).languageControllerCreateLanguage(e.createLanguageReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Deleting a language
   * @param {LanguageApiLanguageControllerDeleteLanguageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LanguageApi
   */
  deleteLanguage(e, t) {
    return Pe(this.configuration).languageControllerDeleteLanguage(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting a list of languages
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LanguageApi
   */
  getLanguages(e) {
    return Pe(this.configuration).languageControllerGetLanguages(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updating a language
   * @param {LanguageApiLanguageControllerUpdateLanguageRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LanguageApi
   */
  updateLanguage(e, t) {
    return Pe(this.configuration).languageControllerUpdateLanguage(e.id, e.updateLanguageReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const yn = function(a) {
  return {
    /**
     * 
     * @summary Returns leaderboard data
     * @param {number} leaderboardId Leaderboard ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    leaderboardControllerGetLeaderboard: async (e, t = {}) => {
      p("leaderboardControllerGetLeaderboard", "leaderboardId", e);
      const o = "/api3/leaderboard/{leaderboardId}/items".replace("{leaderboardId}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns the list of messages from the queue
     * @param {number} collectionId Metabase collection ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    leaderboardControllerGetLeaderboardList: async (e, t = {}) => {
      p("leaderboardControllerGetLeaderboardList", "collectionId", e);
      const o = "/api3/leaderboard/{collectionId}".replace("{collectionId}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    }
  };
}, pt = function(a) {
  const e = yn(a);
  return {
    /**
     * 
     * @summary Returns leaderboard data
     * @param {number} leaderboardId Leaderboard ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async leaderboardControllerGetLeaderboard(t, o) {
      const r = await e.leaderboardControllerGetLeaderboard(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns the list of messages from the queue
     * @param {number} collectionId Metabase collection ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async leaderboardControllerGetLeaderboardList(t, o) {
      const r = await e.leaderboardControllerGetLeaderboardList(t, o);
      return V(r, u, C, a);
    }
  };
}, Ps = function(a, e, t) {
  const o = pt(a);
  return {
    /**
     * 
     * @summary Returns leaderboard data
     * @param {LeaderboardApiLeaderboardControllerGetLeaderboardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    leaderboardControllerGetLeaderboard(r, n) {
      return o.leaderboardControllerGetLeaderboard(r.leaderboardId, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns the list of messages from the queue
     * @param {LeaderboardApiLeaderboardControllerGetLeaderboardListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    leaderboardControllerGetLeaderboardList(r, n) {
      return o.leaderboardControllerGetLeaderboardList(r.collectionId, n).then((l) => l(t, e));
    }
  };
};
class mn extends v {
  /**
   * 
   * @summary Returns leaderboard data
   * @param {LeaderboardApiLeaderboardControllerGetLeaderboardRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LeaderboardApi
   */
  getLeaderboard(e, t) {
    return pt(this.configuration).leaderboardControllerGetLeaderboard(e.leaderboardId, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns the list of messages from the queue
   * @param {LeaderboardApiLeaderboardControllerGetLeaderboardListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LeaderboardApi
   */
  getLeaderboardList(e, t) {
    return pt(this.configuration).leaderboardControllerGetLeaderboardList(e.collectionId, t).then((o) => o(this.axios, this.basePath));
  }
}
const On = function(a) {
  return {
    /**
     * 
     * @summary Getting a list of localization namespaces
     * @param {number} limit 
     * @param {number} page 
     * @param {string} [namespaceQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    localizationControllerGetNamespaces: async (e, t, o, r = {}) => {
      p("localizationControllerGetNamespaces", "limit", e), p("localizationControllerGetNamespaces", "page", t);
      const n = "/api3/localization/namespace", l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "GET", ...s, ...r }, c = {}, d = {};
      await P(c, a), e !== void 0 && (d.limit = e), t !== void 0 && (d.page = t), o !== void 0 && (d.namespaceQuery = o), m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, {
        url: O(l),
        options: i
      };
    },
    /**
     * 
     * @summary Refreshing a localization
     * @param {RefreshLocalizationsReq} refreshLocalizationsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    localizationControllerRefreshLocalizations: async (e, t = {}) => {
      p("localizationControllerRefreshLocalizations", "refreshLocalizationsReq", e);
      const o = "/api3/localization/refresh", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Updating a list of localization namespaces
     * @param {UpdateNamespaceReq} updateNamespaceReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    localizationControllerUpdateNamespaces: async (e, t = {}) => {
      p("localizationControllerUpdateNamespaces", "updateNamespaceReq", e);
      const o = "/api3/localization/namespace", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "PUT", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    }
  };
}, He = function(a) {
  const e = On(a);
  return {
    /**
     * 
     * @summary Getting a list of localization namespaces
     * @param {number} limit 
     * @param {number} page 
     * @param {string} [namespaceQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async localizationControllerGetNamespaces(t, o, r, n) {
      const l = await e.localizationControllerGetNamespaces(t, o, r, n);
      return V(l, u, C, a);
    },
    /**
     * 
     * @summary Refreshing a localization
     * @param {RefreshLocalizationsReq} refreshLocalizationsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async localizationControllerRefreshLocalizations(t, o) {
      const r = await e.localizationControllerRefreshLocalizations(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Updating a list of localization namespaces
     * @param {UpdateNamespaceReq} updateNamespaceReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async localizationControllerUpdateNamespaces(t, o) {
      const r = await e.localizationControllerUpdateNamespaces(t, o);
      return V(r, u, C, a);
    }
  };
}, fs = function(a, e, t) {
  const o = He(a);
  return {
    /**
     * 
     * @summary Getting a list of localization namespaces
     * @param {LocalizationApiLocalizationControllerGetNamespacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    localizationControllerGetNamespaces(r, n) {
      return o.localizationControllerGetNamespaces(r.limit, r.page, r.namespaceQuery, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Refreshing a localization
     * @param {LocalizationApiLocalizationControllerRefreshLocalizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    localizationControllerRefreshLocalizations(r, n) {
      return o.localizationControllerRefreshLocalizations(r.refreshLocalizationsReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Updating a list of localization namespaces
     * @param {LocalizationApiLocalizationControllerUpdateNamespacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    localizationControllerUpdateNamespaces(r, n) {
      return o.localizationControllerUpdateNamespaces(r.updateNamespaceReq, n).then((l) => l(t, e));
    }
  };
};
class Vn extends v {
  /**
   * 
   * @summary Getting a list of localization namespaces
   * @param {LocalizationApiLocalizationControllerGetNamespacesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LocalizationApi
   */
  getNamespaces(e, t) {
    return He(this.configuration).localizationControllerGetNamespaces(e.limit, e.page, e.namespaceQuery, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Refreshing a localization
   * @param {LocalizationApiLocalizationControllerRefreshLocalizationsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LocalizationApi
   */
  refreshLocalizations(e, t) {
    return He(this.configuration).localizationControllerRefreshLocalizations(e.refreshLocalizationsReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updating a list of localization namespaces
   * @param {LocalizationApiLocalizationControllerUpdateNamespacesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LocalizationApi
   */
  updateNamespaces(e, t) {
    return He(this.configuration).localizationControllerUpdateNamespaces(e.updateNamespaceReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const Pn = function(a) {
  return {
    /**
     * 
     * @summary Getting a link to the report in metabase
     * @param {string} resourceKey Alias of the metabase resource
     * @param {number} resourceId Resource ID metabase
     * @param {GetResourceUrlReq} getResourceUrlReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    metabaseControllerGetResourceUrl: async (e, t, o, r = {}) => {
      p("metabaseControllerGetResourceUrl", "resourceKey", e), p("metabaseControllerGetResourceUrl", "resourceId", t), p("metabaseControllerGetResourceUrl", "getResourceUrlReq", o);
      const n = "/api3/metabase/resources/{resourceKey}/{resourceId}/get-url".replace("{resourceKey}", encodeURIComponent(String(e))).replace("{resourceId}", encodeURIComponent(String(t))), l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "POST", ...s, ...r }, c = {}, d = {};
      await P(c, a), c["Content-Type"] = "application/json", m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, i.data = S(o, i, a), {
        url: O(l),
        options: i
      };
    }
  };
}, Vr = function(a) {
  const e = Pn(a);
  return {
    /**
     * 
     * @summary Getting a link to the report in metabase
     * @param {string} resourceKey Alias of the metabase resource
     * @param {number} resourceId Resource ID metabase
     * @param {GetResourceUrlReq} getResourceUrlReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async metabaseControllerGetResourceUrl(t, o, r, n) {
      const l = await e.metabaseControllerGetResourceUrl(t, o, r, n);
      return V(l, u, C, a);
    }
  };
}, ws = function(a, e, t) {
  const o = Vr(a);
  return {
    /**
     * 
     * @summary Getting a link to the report in metabase
     * @param {MetabaseApiMetabaseControllerGetResourceUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    metabaseControllerGetResourceUrl(r, n) {
      return o.metabaseControllerGetResourceUrl(r.resourceKey, r.resourceId, r.getResourceUrlReq, n).then((l) => l(t, e));
    }
  };
};
class fn extends v {
  /**
   * 
   * @summary Getting a link to the report in metabase
   * @param {MetabaseApiMetabaseControllerGetResourceUrlRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MetabaseApi
   */
  getResourceUrl(e, t) {
    return Vr(this.configuration).metabaseControllerGetResourceUrl(e.resourceKey, e.resourceId, e.getResourceUrlReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const wn = function(a) {
  return {
    /**
     * 
     * @summary Returns NRM2 admin settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nrm2AdminSettingsControllerGetSettings: async (e = {}) => {
      const t = "/api3/nrm2/admin-settings", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Updates NRM2 admin settings
     * @param {UpdateNrm2AdminSettingsReq} updateNrm2AdminSettingsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nrm2AdminSettingsControllerUpdateSettings: async (e, t = {}) => {
      p("nrm2AdminSettingsControllerUpdateSettings", "updateNrm2AdminSettingsReq", e);
      const o = "/api3/nrm2/admin-settings", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "PUT", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    }
  };
}, ht = function(a) {
  const e = wn(a);
  return {
    /**
     * 
     * @summary Returns NRM2 admin settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async nrm2AdminSettingsControllerGetSettings(t) {
      const o = await e.nrm2AdminSettingsControllerGetSettings(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Updates NRM2 admin settings
     * @param {UpdateNrm2AdminSettingsReq} updateNrm2AdminSettingsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async nrm2AdminSettingsControllerUpdateSettings(t, o) {
      const r = await e.nrm2AdminSettingsControllerUpdateSettings(t, o);
      return V(r, u, C, a);
    }
  };
}, As = function(a, e, t) {
  const o = ht(a);
  return {
    /**
     * 
     * @summary Returns NRM2 admin settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nrm2AdminSettingsControllerGetSettings(r) {
      return o.nrm2AdminSettingsControllerGetSettings(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Updates NRM2 admin settings
     * @param {NRM2ApiNrm2AdminSettingsControllerUpdateSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    nrm2AdminSettingsControllerUpdateSettings(r, n) {
      return o.nrm2AdminSettingsControllerUpdateSettings(r.updateNrm2AdminSettingsReq, n).then((l) => l(t, e));
    }
  };
};
class An extends v {
  /**
   * 
   * @summary Returns NRM2 admin settings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NRM2Api
   */
  getSettings(e) {
    return ht(this.configuration).nrm2AdminSettingsControllerGetSettings(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updates NRM2 admin settings
   * @param {NRM2ApiNrm2AdminSettingsControllerUpdateSettingsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NRM2Api
   */
  updateSettings(e, t) {
    return ht(this.configuration).nrm2AdminSettingsControllerUpdateSettings(e.updateNrm2AdminSettingsReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const Rn = function(a) {
  return {
    /**
     * 
     * @summary Checking a one-time password
     * @param {OtpCheckReq} otpCheckReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    otpControllerOtpCheck: async (e, t = {}) => {
      p("otpControllerOtpCheck", "otpCheckReq", e);
      const o = "/api3/otp/check", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Sending a one-time password to email
     * @param {OtpEmailReq} otpEmailReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    otpControllerOtpEmail: async (e, t = {}) => {
      p("otpControllerOtpEmail", "otpEmailReq", e);
      const o = "/api3/otp/email", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Sending a one-time password via sms
     * @param {OtpSmsReq} otpSmsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    otpControllerOtpSms: async (e, t = {}) => {
      p("otpControllerOtpSms", "otpSmsReq", e);
      const o = "/api3/otp/sms", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    }
  };
}, Qe = function(a) {
  const e = Rn(a);
  return {
    /**
     * 
     * @summary Checking a one-time password
     * @param {OtpCheckReq} otpCheckReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async otpControllerOtpCheck(t, o) {
      const r = await e.otpControllerOtpCheck(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Sending a one-time password to email
     * @param {OtpEmailReq} otpEmailReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async otpControllerOtpEmail(t, o) {
      const r = await e.otpControllerOtpEmail(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Sending a one-time password via sms
     * @param {OtpSmsReq} otpSmsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async otpControllerOtpSms(t, o) {
      const r = await e.otpControllerOtpSms(t, o);
      return V(r, u, C, a);
    }
  };
}, Rs = function(a, e, t) {
  const o = Qe(a);
  return {
    /**
     * 
     * @summary Checking a one-time password
     * @param {OTPApiOtpControllerOtpCheckRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    otpControllerOtpCheck(r, n) {
      return o.otpControllerOtpCheck(r.otpCheckReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Sending a one-time password to email
     * @param {OTPApiOtpControllerOtpEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    otpControllerOtpEmail(r, n) {
      return o.otpControllerOtpEmail(r.otpEmailReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Sending a one-time password via sms
     * @param {OTPApiOtpControllerOtpSmsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    otpControllerOtpSms(r, n) {
      return o.otpControllerOtpSms(r.otpSmsReq, n).then((l) => l(t, e));
    }
  };
};
class bn extends v {
  /**
   * 
   * @summary Checking a one-time password
   * @param {OTPApiOtpControllerOtpCheckRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OTPApi
   */
  otpCheck(e, t) {
    return Qe(this.configuration).otpControllerOtpCheck(e.otpCheckReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Sending a one-time password to email
   * @param {OTPApiOtpControllerOtpEmailRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OTPApi
   */
  otpEmail(e, t) {
    return Qe(this.configuration).otpControllerOtpEmail(e.otpEmailReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Sending a one-time password via sms
   * @param {OTPApiOtpControllerOtpSmsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OTPApi
   */
  otpSms(e, t) {
    return Qe(this.configuration).otpControllerOtpSms(e.otpSmsReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const Sn = function(a) {
  return {
    /**
     * Please use /v2/pos/product instead
     * @summary Getting a product catalog
     * @param {string} articleOrder 
     * @param {string} [catalogid] Requested categories (Must be an integer or a comma-separated sequence of integers)
     * @param {string} [excatalogid] Exclude categories from the sample (Must be an integer or a comma-separated sequence of integers)
     * @param {any} [pricelistid] 
     * @param {any} [posid] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    catalogControllerGetCatalog: async (e, t, o, r, n, l = {}) => {
      p("catalogControllerGetCatalog", "articleOrder", e);
      const s = "/api3/pos/catalog", i = new URL(s, y);
      let c;
      a && (c = a.baseOptions);
      const d = { method: "GET", ...c, ...l }, h = {}, f = {};
      t !== void 0 && (f.catalogid = t), o !== void 0 && (f.excatalogid = o), r !== void 0 && (f.pricelistid = r), n !== void 0 && (f.posid = n), e !== void 0 && (f.articleOrder = e), m(i, f);
      let R = c && c.headers ? c.headers : {};
      return d.headers = { ...h, ...R, ...l.headers }, {
        url: O(i),
        options: d
      };
    },
    /**
     * 
     * @summary Returns a list of order document statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentStatusControllerGetDocumentStatuses: async (e = {}) => {
      const t = "/api3/pos/order/document-status", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Getting a list of warehouses
     * @param {number} limit 
     * @param {number} page 
     * @param {boolean} [onlyPickupAvailable] Self-delivery is available
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listControllerGetPosList: async (e, t, o, r = {}) => {
      p("listControllerGetPosList", "limit", e), p("listControllerGetPosList", "page", t);
      const n = "/api3/pos/list", l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "GET", ...s, ...r }, c = {}, d = {};
      await P(c, a), e !== void 0 && (d.limit = e), t !== void 0 && (d.page = t), o !== void 0 && (d.only_pickup_available = o), m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, {
        url: O(l),
        options: i
      };
    },
    /**
     * 
     * @summary Getting sorted document\'s items
     * @param {any} id 
     * @param {object} [orderBy] Sort options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    posDocumentControllerGetPosDocumentItems: async (e, t, o = {}) => {
      p("posDocumentControllerGetPosDocumentItems", "id", e);
      const r = "/api3/pos/document/{id}/items".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      await P(i, a), t !== void 0 && (c.orderBy = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Getting a pos documents
     * @param {number} limit 
     * @param {number} page 
     * @param {number} [documentTypeId] 
     * @param {number} [documentStatusId] 
     * @param {number} [sourcePosId] 
     * @param {number} [targetPosId] 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    posDocumentControllerGetPosDocuments: async (e, t, o, r, n, l, s, i, c = {}) => {
      p("posDocumentControllerGetPosDocuments", "limit", e), p("posDocumentControllerGetPosDocuments", "page", t);
      const d = "/api3/pos/document", h = new URL(d, y);
      let f;
      a && (f = a.baseOptions);
      const R = { method: "GET", ...f, ...c }, A = {}, w = {};
      await P(A, a), e !== void 0 && (w.limit = e), t !== void 0 && (w.page = t), o !== void 0 && (w.documentTypeId = o), r !== void 0 && (w.documentStatusId = r), n !== void 0 && (w.sourcePosId = n), l !== void 0 && (w.targetPosId = l), s !== void 0 && (w.orderBy = s), i !== void 0 && (w.filter = i), m(h, w);
      let T = f && f.headers ? f.headers : {};
      return R.headers = { ...A, ...T, ...c.headers }, {
        url: O(h),
        options: R
      };
    },
    /**
     * 
     * @summary Getting a pos document types
     * @param {number} limit 
     * @param {number} page 
     * @param {number} [documentTypeId] 
     * @param {number} [documentStatusId] 
     * @param {number} [sourcePosId] 
     * @param {number} [targetPosId] 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    posDocumentTypeControllerGetPosDocuments: async (e, t, o, r, n, l, s, i, c = {}) => {
      p("posDocumentTypeControllerGetPosDocuments", "limit", e), p("posDocumentTypeControllerGetPosDocuments", "page", t);
      const d = "/api3/pos/document-type", h = new URL(d, y);
      let f;
      a && (f = a.baseOptions);
      const R = { method: "GET", ...f, ...c }, A = {}, w = {};
      await P(A, a), e !== void 0 && (w.limit = e), t !== void 0 && (w.page = t), o !== void 0 && (w.documentTypeId = o), r !== void 0 && (w.documentStatusId = r), n !== void 0 && (w.sourcePosId = n), l !== void 0 && (w.targetPosId = l), s !== void 0 && (w.orderBy = s), i !== void 0 && (w.filter = i), m(h, w);
      let T = f && f.headers ? f.headers : {};
      return R.headers = { ...A, ...T, ...c.headers }, {
        url: O(h),
        options: R
      };
    },
    /**
     * 
     * @summary Creating an order payment
     * @param {number} documentId 
     * @param {CreatePaymentReq} createPaymentReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    posOrderPaymentControllerCreatePayment: async (e, t, o = {}) => {
      p("posOrderPaymentControllerCreatePayment", "documentId", e), p("posOrderPaymentControllerCreatePayment", "createPaymentReq", t);
      const r = "/api3/pos/order/{documentId}/payment".replace("{documentId}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "POST", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Creating an order payment from wallet
     * @param {number} documentId 
     * @param {number} walletId 
     * @param {PaymentDataReq} paymentDataReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    posOrderPaymentControllerCreatePaymentFromWallet: async (e, t, o, r = {}) => {
      p("posOrderPaymentControllerCreatePaymentFromWallet", "documentId", e), p("posOrderPaymentControllerCreatePaymentFromWallet", "walletId", t), p("posOrderPaymentControllerCreatePaymentFromWallet", "paymentDataReq", o);
      const n = "/api3/pos/order/{documentId}/payment/wallet/{walletId}".replace("{documentId}", encodeURIComponent(String(e))).replace("{walletId}", encodeURIComponent(String(t))), l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "POST", ...s, ...r }, c = {}, d = {};
      await P(c, a), c["Content-Type"] = "application/json", m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, i.data = S(o, i, a), {
        url: O(l),
        options: i
      };
    },
    /**
     * 
     * @summary Deleting an order payment
     * @param {number} paymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    posOrderPaymentControllerDeletePayment: async (e, t = {}) => {
      p("posOrderPaymentControllerDeletePayment", "paymentId", e);
      const o = "/api3/pos/order/{documentId}/payment/{paymentId}".replace("{paymentId}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "DELETE", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Getting information about the product
     * @param {any} id Product ID
     * @param {any} [pricelistid] Price list identifier
     * @param {any} [posid] Warehouse ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    posProductControllerGetCatalog: async (e, t, o, r = {}) => {
      p("posProductControllerGetCatalog", "id", e);
      const n = "/api3/pos/product/{id}".replace("{id}", encodeURIComponent(String(e))), l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "GET", ...s, ...r }, c = {}, d = {};
      t !== void 0 && (d.pricelistid = t), o !== void 0 && (d.posid = o), m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, {
        url: O(l),
        options: i
      };
    },
    /**
     * 
     * @summary Returns a list of warehouses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    posWarehouseControllerGetAccounts: async (e = {}) => {
      const t = "/api3/pos/warehouse", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary 
     * @param {any} productId 
     * @param {any} [priceListId] 
     * @param {any} [posId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2PosProductV2ControllerGetProduct: async (e, t, o, r = {}) => {
      p("v2PosProductV2ControllerGetProduct", "productId", e);
      const n = "/api3/v2/pos/product/{productId}".replace("{productId}", encodeURIComponent(String(e))), l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "GET", ...s, ...r }, c = {}, d = {};
      t !== void 0 && (d.priceListId = t), o !== void 0 && (d.posId = o), m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, {
        url: O(l),
        options: i
      };
    },
    /**
     * 
     * @summary 
     * @param {number} limit 
     * @param {number} page 
     * @param {Array<string>} [categoryIds] Requested categories
     * @param {Array<string>} [excludedCategoryIds] Exclude categories from the sample
     * @param {any} [priceListId] 
     * @param {any} [posId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2PosProductV2ControllerGetProducts: async (e, t, o, r, n, l, s = {}) => {
      p("v2PosProductV2ControllerGetProducts", "limit", e), p("v2PosProductV2ControllerGetProducts", "page", t);
      const i = "/api3/v2/pos/product", c = new URL(i, y);
      let d;
      a && (d = a.baseOptions);
      const h = { method: "GET", ...d, ...s }, f = {}, R = {};
      e !== void 0 && (R.limit = e), t !== void 0 && (R.page = t), o && (R.categoryIds = o), r && (R.excludedCategoryIds = r), n !== void 0 && (R.priceListId = n), l !== void 0 && (R.posId = l), m(c, R);
      let A = d && d.headers ? d.headers : {};
      return h.headers = { ...f, ...A, ...s.headers }, {
        url: O(c),
        options: h
      };
    }
  };
}, D = function(a) {
  const e = Sn(a);
  return {
    /**
     * Please use /v2/pos/product instead
     * @summary Getting a product catalog
     * @param {string} articleOrder 
     * @param {string} [catalogid] Requested categories (Must be an integer or a comma-separated sequence of integers)
     * @param {string} [excatalogid] Exclude categories from the sample (Must be an integer or a comma-separated sequence of integers)
     * @param {any} [pricelistid] 
     * @param {any} [posid] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async catalogControllerGetCatalog(t, o, r, n, l, s) {
      const i = await e.catalogControllerGetCatalog(t, o, r, n, l, s);
      return V(i, u, C, a);
    },
    /**
     * 
     * @summary Returns a list of order document statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentStatusControllerGetDocumentStatuses(t) {
      const o = await e.documentStatusControllerGetDocumentStatuses(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Getting a list of warehouses
     * @param {number} limit 
     * @param {number} page 
     * @param {boolean} [onlyPickupAvailable] Self-delivery is available
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listControllerGetPosList(t, o, r, n) {
      const l = await e.listControllerGetPosList(t, o, r, n);
      return V(l, u, C, a);
    },
    /**
     * 
     * @summary Getting sorted document\'s items
     * @param {any} id 
     * @param {object} [orderBy] Sort options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async posDocumentControllerGetPosDocumentItems(t, o, r) {
      const n = await e.posDocumentControllerGetPosDocumentItems(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Getting a pos documents
     * @param {number} limit 
     * @param {number} page 
     * @param {number} [documentTypeId] 
     * @param {number} [documentStatusId] 
     * @param {number} [sourcePosId] 
     * @param {number} [targetPosId] 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async posDocumentControllerGetPosDocuments(t, o, r, n, l, s, i, c, d) {
      const h = await e.posDocumentControllerGetPosDocuments(t, o, r, n, l, s, i, c, d);
      return V(h, u, C, a);
    },
    /**
     * 
     * @summary Getting a pos document types
     * @param {number} limit 
     * @param {number} page 
     * @param {number} [documentTypeId] 
     * @param {number} [documentStatusId] 
     * @param {number} [sourcePosId] 
     * @param {number} [targetPosId] 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async posDocumentTypeControllerGetPosDocuments(t, o, r, n, l, s, i, c, d) {
      const h = await e.posDocumentTypeControllerGetPosDocuments(t, o, r, n, l, s, i, c, d);
      return V(h, u, C, a);
    },
    /**
     * 
     * @summary Creating an order payment
     * @param {number} documentId 
     * @param {CreatePaymentReq} createPaymentReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async posOrderPaymentControllerCreatePayment(t, o, r) {
      const n = await e.posOrderPaymentControllerCreatePayment(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Creating an order payment from wallet
     * @param {number} documentId 
     * @param {number} walletId 
     * @param {PaymentDataReq} paymentDataReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async posOrderPaymentControllerCreatePaymentFromWallet(t, o, r, n) {
      const l = await e.posOrderPaymentControllerCreatePaymentFromWallet(t, o, r, n);
      return V(l, u, C, a);
    },
    /**
     * 
     * @summary Deleting an order payment
     * @param {number} paymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async posOrderPaymentControllerDeletePayment(t, o) {
      const r = await e.posOrderPaymentControllerDeletePayment(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Getting information about the product
     * @param {any} id Product ID
     * @param {any} [pricelistid] Price list identifier
     * @param {any} [posid] Warehouse ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async posProductControllerGetCatalog(t, o, r, n) {
      const l = await e.posProductControllerGetCatalog(t, o, r, n);
      return V(l, u, C, a);
    },
    /**
     * 
     * @summary Returns a list of warehouses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async posWarehouseControllerGetAccounts(t) {
      const o = await e.posWarehouseControllerGetAccounts(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary 
     * @param {any} productId 
     * @param {any} [priceListId] 
     * @param {any} [posId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async v2PosProductV2ControllerGetProduct(t, o, r, n) {
      const l = await e.v2PosProductV2ControllerGetProduct(t, o, r, n);
      return V(l, u, C, a);
    },
    /**
     * 
     * @summary 
     * @param {number} limit 
     * @param {number} page 
     * @param {Array<string>} [categoryIds] Requested categories
     * @param {Array<string>} [excludedCategoryIds] Exclude categories from the sample
     * @param {any} [priceListId] 
     * @param {any} [posId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async v2PosProductV2ControllerGetProducts(t, o, r, n, l, s, i) {
      const c = await e.v2PosProductV2ControllerGetProducts(t, o, r, n, l, s, i);
      return V(c, u, C, a);
    }
  };
}, bs = function(a, e, t) {
  const o = D(a);
  return {
    /**
     * Please use /v2/pos/product instead
     * @summary Getting a product catalog
     * @param {POSApiCatalogControllerGetCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    catalogControllerGetCatalog(r, n) {
      return o.catalogControllerGetCatalog(r.articleOrder, r.catalogid, r.excatalogid, r.pricelistid, r.posid, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns a list of order document statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentStatusControllerGetDocumentStatuses(r) {
      return o.documentStatusControllerGetDocumentStatuses(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Getting a list of warehouses
     * @param {POSApiListControllerGetPosListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listControllerGetPosList(r, n) {
      return o.listControllerGetPosList(r.limit, r.page, r.onlyPickupAvailable, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting sorted document\'s items
     * @param {POSApiPosDocumentControllerGetPosDocumentItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    posDocumentControllerGetPosDocumentItems(r, n) {
      return o.posDocumentControllerGetPosDocumentItems(r.id, r.orderBy, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting a pos documents
     * @param {POSApiPosDocumentControllerGetPosDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    posDocumentControllerGetPosDocuments(r, n) {
      return o.posDocumentControllerGetPosDocuments(r.limit, r.page, r.documentTypeId, r.documentStatusId, r.sourcePosId, r.targetPosId, r.orderBy, r.filter, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting a pos document types
     * @param {POSApiPosDocumentTypeControllerGetPosDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    posDocumentTypeControllerGetPosDocuments(r, n) {
      return o.posDocumentTypeControllerGetPosDocuments(r.limit, r.page, r.documentTypeId, r.documentStatusId, r.sourcePosId, r.targetPosId, r.orderBy, r.filter, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Creating an order payment
     * @param {POSApiPosOrderPaymentControllerCreatePaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    posOrderPaymentControllerCreatePayment(r, n) {
      return o.posOrderPaymentControllerCreatePayment(r.documentId, r.createPaymentReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Creating an order payment from wallet
     * @param {POSApiPosOrderPaymentControllerCreatePaymentFromWalletRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    posOrderPaymentControllerCreatePaymentFromWallet(r, n) {
      return o.posOrderPaymentControllerCreatePaymentFromWallet(r.documentId, r.walletId, r.paymentDataReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Deleting an order payment
     * @param {POSApiPosOrderPaymentControllerDeletePaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    posOrderPaymentControllerDeletePayment(r, n) {
      return o.posOrderPaymentControllerDeletePayment(r.paymentId, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting information about the product
     * @param {POSApiPosProductControllerGetCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    posProductControllerGetCatalog(r, n) {
      return o.posProductControllerGetCatalog(r.id, r.pricelistid, r.posid, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns a list of warehouses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    posWarehouseControllerGetAccounts(r) {
      return o.posWarehouseControllerGetAccounts(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary 
     * @param {POSApiV2PosProductV2ControllerGetProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2PosProductV2ControllerGetProduct(r, n) {
      return o.v2PosProductV2ControllerGetProduct(r.productId, r.priceListId, r.posId, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary 
     * @param {POSApiV2PosProductV2ControllerGetProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v2PosProductV2ControllerGetProducts(r, n) {
      return o.v2PosProductV2ControllerGetProducts(r.limit, r.page, r.categoryIds, r.excludedCategoryIds, r.priceListId, r.posId, n).then((l) => l(t, e));
    }
  };
};
class Tn extends v {
  /**
   * Please use /v2/pos/product instead
   * @summary Getting a product catalog
   * @param {POSApiCatalogControllerGetCatalogRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof POSApi
   */
  catalogControllerGetCatalog(e, t) {
    return D(this.configuration).catalogControllerGetCatalog(e.articleOrder, e.catalogid, e.excatalogid, e.pricelistid, e.posid, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns a list of order document statuses
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof POSApi
   */
  getDocumentStatuses(e) {
    return D(this.configuration).documentStatusControllerGetDocumentStatuses(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting a list of warehouses
   * @param {POSApiListControllerGetPosListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof POSApi
   */
  getPosList(e, t) {
    return D(this.configuration).listControllerGetPosList(e.limit, e.page, e.onlyPickupAvailable, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting sorted document\'s items
   * @param {POSApiPosDocumentControllerGetPosDocumentItemsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof POSApi
   */
  getPosDocumentItems(e, t) {
    return D(this.configuration).posDocumentControllerGetPosDocumentItems(e.id, e.orderBy, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting a pos documents
   * @param {POSApiPosDocumentControllerGetPosDocumentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof POSApi
   */
  posDocumentControllerGetPosDocuments(e, t) {
    return D(this.configuration).posDocumentControllerGetPosDocuments(e.limit, e.page, e.documentTypeId, e.documentStatusId, e.sourcePosId, e.targetPosId, e.orderBy, e.filter, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting a pos document types
   * @param {POSApiPosDocumentTypeControllerGetPosDocumentsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof POSApi
   */
  posDocumentTypeControllerGetPosDocuments(e, t) {
    return D(this.configuration).posDocumentTypeControllerGetPosDocuments(e.limit, e.page, e.documentTypeId, e.documentStatusId, e.sourcePosId, e.targetPosId, e.orderBy, e.filter, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Creating an order payment
   * @param {POSApiPosOrderPaymentControllerCreatePaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof POSApi
   */
  createPayment(e, t) {
    return D(this.configuration).posOrderPaymentControllerCreatePayment(e.documentId, e.createPaymentReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Creating an order payment from wallet
   * @param {POSApiPosOrderPaymentControllerCreatePaymentFromWalletRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof POSApi
   */
  createPaymentFromWallet(e, t) {
    return D(this.configuration).posOrderPaymentControllerCreatePaymentFromWallet(e.documentId, e.walletId, e.paymentDataReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Deleting an order payment
   * @param {POSApiPosOrderPaymentControllerDeletePaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof POSApi
   */
  deletePayment(e, t) {
    return D(this.configuration).posOrderPaymentControllerDeletePayment(e.paymentId, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting information about the product
   * @param {POSApiPosProductControllerGetCatalogRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof POSApi
   */
  posProductControllerGetCatalog(e, t) {
    return D(this.configuration).posProductControllerGetCatalog(e.id, e.pricelistid, e.posid, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns a list of warehouses
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof POSApi
   */
  getAccounts(e) {
    return D(this.configuration).posWarehouseControllerGetAccounts(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary 
   * @param {POSApiV2PosProductV2ControllerGetProductRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof POSApi
   */
  getProduct(e, t) {
    return D(this.configuration).v2PosProductV2ControllerGetProduct(e.productId, e.priceListId, e.posId, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary 
   * @param {POSApiV2PosProductV2ControllerGetProductsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof POSApi
   */
  getProducts(e, t) {
    return D(this.configuration).v2PosProductV2ControllerGetProducts(e.limit, e.page, e.categoryIds, e.excludedCategoryIds, e.priceListId, e.posId, t).then((o) => o(this.axios, this.basePath));
  }
}
const Gn = function(a) {
  return {
    /**
     * 
     * @summary Creating a payment rule
     * @param {AddPaymentRuleReq} addPaymentRuleReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentRuleControllerCreatePaymentRule: async (e, t = {}) => {
      p("paymentRuleControllerCreatePaymentRule", "addPaymentRuleReq", e);
      const o = "/api3/payment-rule", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Deleting a payment rule
     * @param {number} id Payment rule id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentRuleControllerDeletePaymentRule: async (e, t = {}) => {
      p("paymentRuleControllerDeletePaymentRule", "id", e);
      const o = "/api3/payment-rule/{id}".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "DELETE", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Getting a list of payment rules
     * @param {any} [sourceWalletTypeId] 
     * @param {any} [targetWalletTypeId] 
     * @param {any} [sourceWalletOperationTypeId] 
     * @param {any} [targetWalletOperationTypeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentRuleControllerGetPaymentRules: async (e, t, o, r, n = {}) => {
      const l = "/api3/payment-rule", s = new URL(l, y);
      let i;
      a && (i = a.baseOptions);
      const c = { method: "GET", ...i, ...n }, d = {}, h = {};
      await P(d, a), e !== void 0 && (h.sourceWalletTypeId = e), t !== void 0 && (h.targetWalletTypeId = t), o !== void 0 && (h.sourceWalletOperationTypeId = o), r !== void 0 && (h.targetWalletOperationTypeId = r), m(s, h);
      let f = i && i.headers ? i.headers : {};
      return c.headers = { ...d, ...f, ...n.headers }, {
        url: O(s),
        options: c
      };
    },
    /**
     * 
     * @summary Updating a payment rule
     * @param {number} id Payment rule id
     * @param {UpdatePaymentRuleReq} updatePaymentRuleReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentRuleControllerUpdatePaymentRule: async (e, t, o = {}) => {
      p("paymentRuleControllerUpdatePaymentRule", "id", e), p("paymentRuleControllerUpdatePaymentRule", "updatePaymentRuleReq", t);
      const r = "/api3/payment-rule/{id}".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, fe = function(a) {
  const e = Gn(a);
  return {
    /**
     * 
     * @summary Creating a payment rule
     * @param {AddPaymentRuleReq} addPaymentRuleReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentRuleControllerCreatePaymentRule(t, o) {
      const r = await e.paymentRuleControllerCreatePaymentRule(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Deleting a payment rule
     * @param {number} id Payment rule id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentRuleControllerDeletePaymentRule(t, o) {
      const r = await e.paymentRuleControllerDeletePaymentRule(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Getting a list of payment rules
     * @param {any} [sourceWalletTypeId] 
     * @param {any} [targetWalletTypeId] 
     * @param {any} [sourceWalletOperationTypeId] 
     * @param {any} [targetWalletOperationTypeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentRuleControllerGetPaymentRules(t, o, r, n, l) {
      const s = await e.paymentRuleControllerGetPaymentRules(t, o, r, n, l);
      return V(s, u, C, a);
    },
    /**
     * 
     * @summary Updating a payment rule
     * @param {number} id Payment rule id
     * @param {UpdatePaymentRuleReq} updatePaymentRuleReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentRuleControllerUpdatePaymentRule(t, o, r) {
      const n = await e.paymentRuleControllerUpdatePaymentRule(t, o, r);
      return V(n, u, C, a);
    }
  };
}, Ss = function(a, e, t) {
  const o = fe(a);
  return {
    /**
     * 
     * @summary Creating a payment rule
     * @param {PaymentRuleApiPaymentRuleControllerCreatePaymentRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentRuleControllerCreatePaymentRule(r, n) {
      return o.paymentRuleControllerCreatePaymentRule(r.addPaymentRuleReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Deleting a payment rule
     * @param {PaymentRuleApiPaymentRuleControllerDeletePaymentRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentRuleControllerDeletePaymentRule(r, n) {
      return o.paymentRuleControllerDeletePaymentRule(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting a list of payment rules
     * @param {PaymentRuleApiPaymentRuleControllerGetPaymentRulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentRuleControllerGetPaymentRules(r = {}, n) {
      return o.paymentRuleControllerGetPaymentRules(r.sourceWalletTypeId, r.targetWalletTypeId, r.sourceWalletOperationTypeId, r.targetWalletOperationTypeId, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Updating a payment rule
     * @param {PaymentRuleApiPaymentRuleControllerUpdatePaymentRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentRuleControllerUpdatePaymentRule(r, n) {
      return o.paymentRuleControllerUpdatePaymentRule(r.id, r.updatePaymentRuleReq, n).then((l) => l(t, e));
    }
  };
};
class vn extends v {
  /**
   * 
   * @summary Creating a payment rule
   * @param {PaymentRuleApiPaymentRuleControllerCreatePaymentRuleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentRuleApi
   */
  createPaymentRule(e, t) {
    return fe(this.configuration).paymentRuleControllerCreatePaymentRule(e.addPaymentRuleReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Deleting a payment rule
   * @param {PaymentRuleApiPaymentRuleControllerDeletePaymentRuleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentRuleApi
   */
  deletePaymentRule(e, t) {
    return fe(this.configuration).paymentRuleControllerDeletePaymentRule(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting a list of payment rules
   * @param {PaymentRuleApiPaymentRuleControllerGetPaymentRulesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentRuleApi
   */
  getPaymentRules(e = {}, t) {
    return fe(this.configuration).paymentRuleControllerGetPaymentRules(e.sourceWalletTypeId, e.targetWalletTypeId, e.sourceWalletOperationTypeId, e.targetWalletOperationTypeId, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updating a payment rule
   * @param {PaymentRuleApiPaymentRuleControllerUpdatePaymentRuleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentRuleApi
   */
  updatePaymentRule(e, t) {
    return fe(this.configuration).paymentRuleControllerUpdatePaymentRule(e.id, e.updatePaymentRuleReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const Un = function(a) {
  return {
    /**
     * 
     * @summary Create payment system
     * @param {CreatePaymentSystemReq} createPaymentSystemReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentSystemControllerCreatePaymentSystem: async (e, t = {}) => {
      p("paymentSystemControllerCreatePaymentSystem", "createPaymentSystemReq", e);
      const o = "/api3/payment-system", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Delete payment system
     * @param {number} paymentSystemId Payment system ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentSystemControllerDeletePaymentSystem: async (e, t = {}) => {
      p("paymentSystemControllerDeletePaymentSystem", "paymentSystemId", e);
      const o = "/api3/payment-system/{paymentSystemId}".replace("{paymentSystemId}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "DELETE", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Getting a list of payment systems
     * @param {number} limit 
     * @param {number} page 
     * @param {boolean} [isActive] 
     * @param {boolean} [isEnrollment] 
     * @param {boolean} [isPayout] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentSystemControllerGetPaymentSystemList: async (e, t, o, r, n, l = {}) => {
      p("paymentSystemControllerGetPaymentSystemList", "limit", e), p("paymentSystemControllerGetPaymentSystemList", "page", t);
      const s = "/api3/payment-system", i = new URL(s, y);
      let c;
      a && (c = a.baseOptions);
      const d = { method: "GET", ...c, ...l }, h = {}, f = {};
      await P(h, a), e !== void 0 && (f.limit = e), t !== void 0 && (f.page = t), o !== void 0 && (f.isActive = o), r !== void 0 && (f.isEnrollment = r), n !== void 0 && (f.isPayout = n), m(i, f);
      let R = c && c.headers ? c.headers : {};
      return d.headers = { ...h, ...R, ...l.headers }, {
        url: O(i),
        options: d
      };
    },
    /**
     * 
     * @summary Make a payment
     * @param {MakePaymentReq} makePaymentReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentSystemControllerMakePayment: async (e, t = {}) => {
      p("paymentSystemControllerMakePayment", "makePaymentReq", e);
      const o = "/api3/payment-system/payment", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Process payment system callback
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentSystemControllerPaymentCallback: async (e = {}) => {
      const t = "/api3/payment-system/callback", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {};
      m(o, {});
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Update payment system
     * @param {number} paymentSystemId Payment system ID
     * @param {UpdatePaymentSystemReq} updatePaymentSystemReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentSystemControllerUpdatePaymentSystem: async (e, t, o = {}) => {
      p("paymentSystemControllerUpdatePaymentSystem", "paymentSystemId", e), p("paymentSystemControllerUpdatePaymentSystem", "updatePaymentSystemReq", t);
      const r = "/api3/payment-system/{paymentSystemId}".replace("{paymentSystemId}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, J = function(a) {
  const e = Un(a);
  return {
    /**
     * 
     * @summary Create payment system
     * @param {CreatePaymentSystemReq} createPaymentSystemReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentSystemControllerCreatePaymentSystem(t, o) {
      const r = await e.paymentSystemControllerCreatePaymentSystem(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Delete payment system
     * @param {number} paymentSystemId Payment system ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentSystemControllerDeletePaymentSystem(t, o) {
      const r = await e.paymentSystemControllerDeletePaymentSystem(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Getting a list of payment systems
     * @param {number} limit 
     * @param {number} page 
     * @param {boolean} [isActive] 
     * @param {boolean} [isEnrollment] 
     * @param {boolean} [isPayout] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentSystemControllerGetPaymentSystemList(t, o, r, n, l, s) {
      const i = await e.paymentSystemControllerGetPaymentSystemList(t, o, r, n, l, s);
      return V(i, u, C, a);
    },
    /**
     * 
     * @summary Make a payment
     * @param {MakePaymentReq} makePaymentReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentSystemControllerMakePayment(t, o) {
      const r = await e.paymentSystemControllerMakePayment(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Process payment system callback
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentSystemControllerPaymentCallback(t) {
      const o = await e.paymentSystemControllerPaymentCallback(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Update payment system
     * @param {number} paymentSystemId Payment system ID
     * @param {UpdatePaymentSystemReq} updatePaymentSystemReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async paymentSystemControllerUpdatePaymentSystem(t, o, r) {
      const n = await e.paymentSystemControllerUpdatePaymentSystem(t, o, r);
      return V(n, u, C, a);
    }
  };
}, Ts = function(a, e, t) {
  const o = J(a);
  return {
    /**
     * 
     * @summary Create payment system
     * @param {PaymentSystemApiPaymentSystemControllerCreatePaymentSystemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentSystemControllerCreatePaymentSystem(r, n) {
      return o.paymentSystemControllerCreatePaymentSystem(r.createPaymentSystemReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Delete payment system
     * @param {PaymentSystemApiPaymentSystemControllerDeletePaymentSystemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentSystemControllerDeletePaymentSystem(r, n) {
      return o.paymentSystemControllerDeletePaymentSystem(r.paymentSystemId, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting a list of payment systems
     * @param {PaymentSystemApiPaymentSystemControllerGetPaymentSystemListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentSystemControllerGetPaymentSystemList(r, n) {
      return o.paymentSystemControllerGetPaymentSystemList(r.limit, r.page, r.isActive, r.isEnrollment, r.isPayout, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Make a payment
     * @param {PaymentSystemApiPaymentSystemControllerMakePaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentSystemControllerMakePayment(r, n) {
      return o.paymentSystemControllerMakePayment(r.makePaymentReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Process payment system callback
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentSystemControllerPaymentCallback(r) {
      return o.paymentSystemControllerPaymentCallback(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Update payment system
     * @param {PaymentSystemApiPaymentSystemControllerUpdatePaymentSystemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentSystemControllerUpdatePaymentSystem(r, n) {
      return o.paymentSystemControllerUpdatePaymentSystem(r.paymentSystemId, r.updatePaymentSystemReq, n).then((l) => l(t, e));
    }
  };
};
class gn extends v {
  /**
   * 
   * @summary Create payment system
   * @param {PaymentSystemApiPaymentSystemControllerCreatePaymentSystemRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentSystemApi
   */
  createPaymentSystem(e, t) {
    return J(this.configuration).paymentSystemControllerCreatePaymentSystem(e.createPaymentSystemReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Delete payment system
   * @param {PaymentSystemApiPaymentSystemControllerDeletePaymentSystemRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentSystemApi
   */
  deletePaymentSystem(e, t) {
    return J(this.configuration).paymentSystemControllerDeletePaymentSystem(e.paymentSystemId, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting a list of payment systems
   * @param {PaymentSystemApiPaymentSystemControllerGetPaymentSystemListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentSystemApi
   */
  getPaymentSystemList(e, t) {
    return J(this.configuration).paymentSystemControllerGetPaymentSystemList(e.limit, e.page, e.isActive, e.isEnrollment, e.isPayout, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Make a payment
   * @param {PaymentSystemApiPaymentSystemControllerMakePaymentRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentSystemApi
   */
  makePayment(e, t) {
    return J(this.configuration).paymentSystemControllerMakePayment(e.makePaymentReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Process payment system callback
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentSystemApi
   */
  paymentCallback(e) {
    return J(this.configuration).paymentSystemControllerPaymentCallback(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update payment system
   * @param {PaymentSystemApiPaymentSystemControllerUpdatePaymentSystemRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentSystemApi
   */
  updatePaymentSystem(e, t) {
    return J(this.configuration).paymentSystemControllerUpdatePaymentSystem(e.paymentSystemId, e.updatePaymentSystemReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const xn = function(a) {
  return {
    /**
     * 
     * @summary Create payout
     * @param {number} id 
     * @param {CreatePayoutParamsReq} createPayoutParamsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPayoutControllerCreateInvoice: async (e, t, o = {}) => {
      p("accountPayoutControllerCreateInvoice", "id", e), p("accountPayoutControllerCreateInvoice", "createPayoutParamsReq", t);
      const r = "/api3/account/{id}/payout".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "POST", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Get a list of withdrawal requests
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPayoutControllerGetAccountInvoiceList: async (e, t, o, r, n, l = {}) => {
      p("accountPayoutControllerGetAccountInvoiceList", "limit", e), p("accountPayoutControllerGetAccountInvoiceList", "page", t), p("accountPayoutControllerGetAccountInvoiceList", "id", o);
      const s = "/api3/account/{id}/payout".replace("{id}", encodeURIComponent(String(o))), i = new URL(s, y);
      let c;
      a && (c = a.baseOptions);
      const d = { method: "GET", ...c, ...l }, h = {}, f = {};
      await P(h, a), e !== void 0 && (f.limit = e), t !== void 0 && (f.page = t), r !== void 0 && (f.orderBy = r), n !== void 0 && (f.filter = n), m(i, f);
      let R = c && c.headers ? c.headers : {};
      return d.headers = { ...h, ...R, ...l.headers }, {
        url: O(i),
        options: d
      };
    },
    /**
     * 
     * @summary Bulk create payout
     * @param {BulkCreatePayoutReq} bulkCreatePayoutReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payoutControllerBulkCreatePayout: async (e, t = {}) => {
      p("payoutControllerBulkCreatePayout", "bulkCreatePayoutReq", e);
      const o = "/api3/payout/bulk-create", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns export headers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payoutControllerGetExportHeaders: async (e = {}) => {
      const t = "/api3/payout/export/headers", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Get payout list
     * @param {number} limit 
     * @param {number} page 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payoutControllerGetPayoutsList: async (e, t, o, r, n = {}) => {
      p("payoutControllerGetPayoutsList", "limit", e), p("payoutControllerGetPayoutsList", "page", t);
      const l = "/api3/payout", s = new URL(l, y);
      let i;
      a && (i = a.baseOptions);
      const c = { method: "GET", ...i, ...n }, d = {}, h = {};
      await P(d, a), e !== void 0 && (h.limit = e), t !== void 0 && (h.page = t), o !== void 0 && (h.orderBy = o), r !== void 0 && (h.filter = r), m(s, h);
      let f = i && i.headers ? i.headers : {};
      return c.headers = { ...d, ...f, ...n.headers }, {
        url: O(s),
        options: c
      };
    },
    /**
     * 
     * @summary Starts export operation
     * @param {PayoutExportReq} payoutExportReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payoutControllerStartExport: async (e, t = {}) => {
      p("payoutControllerStartExport", "payoutExportReq", e);
      const o = "/api3/payout/export", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Update payout
     * @param {number} id Payout ID
     * @param {UpdatePayoutReq} updatePayoutReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payoutControllerUpdatePayout: async (e, t, o = {}) => {
      p("payoutControllerUpdatePayout", "id", e), p("payoutControllerUpdatePayout", "updatePayoutReq", t);
      const r = "/api3/payout/{id}/process".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, z = function(a) {
  const e = xn(a);
  return {
    /**
     * 
     * @summary Create payout
     * @param {number} id 
     * @param {CreatePayoutParamsReq} createPayoutParamsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountPayoutControllerCreateInvoice(t, o, r) {
      const n = await e.accountPayoutControllerCreateInvoice(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Get a list of withdrawal requests
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountPayoutControllerGetAccountInvoiceList(t, o, r, n, l, s) {
      const i = await e.accountPayoutControllerGetAccountInvoiceList(t, o, r, n, l, s);
      return V(i, u, C, a);
    },
    /**
     * 
     * @summary Bulk create payout
     * @param {BulkCreatePayoutReq} bulkCreatePayoutReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async payoutControllerBulkCreatePayout(t, o) {
      const r = await e.payoutControllerBulkCreatePayout(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns export headers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async payoutControllerGetExportHeaders(t) {
      const o = await e.payoutControllerGetExportHeaders(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Get payout list
     * @param {number} limit 
     * @param {number} page 
     * @param {object} [orderBy] Sort options
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async payoutControllerGetPayoutsList(t, o, r, n, l) {
      const s = await e.payoutControllerGetPayoutsList(t, o, r, n, l);
      return V(s, u, C, a);
    },
    /**
     * 
     * @summary Starts export operation
     * @param {PayoutExportReq} payoutExportReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async payoutControllerStartExport(t, o) {
      const r = await e.payoutControllerStartExport(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Update payout
     * @param {number} id Payout ID
     * @param {UpdatePayoutReq} updatePayoutReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async payoutControllerUpdatePayout(t, o, r) {
      const n = await e.payoutControllerUpdatePayout(t, o, r);
      return V(n, u, C, a);
    }
  };
}, Gs = function(a, e, t) {
  const o = z(a);
  return {
    /**
     * 
     * @summary Create payout
     * @param {PayoutApiAccountPayoutControllerCreateInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPayoutControllerCreateInvoice(r, n) {
      return o.accountPayoutControllerCreateInvoice(r.id, r.createPayoutParamsReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Get a list of withdrawal requests
     * @param {PayoutApiAccountPayoutControllerGetAccountInvoiceListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountPayoutControllerGetAccountInvoiceList(r, n) {
      return o.accountPayoutControllerGetAccountInvoiceList(r.limit, r.page, r.id, r.orderBy, r.filter, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Bulk create payout
     * @param {PayoutApiPayoutControllerBulkCreatePayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payoutControllerBulkCreatePayout(r, n) {
      return o.payoutControllerBulkCreatePayout(r.bulkCreatePayoutReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns export headers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payoutControllerGetExportHeaders(r) {
      return o.payoutControllerGetExportHeaders(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Get payout list
     * @param {PayoutApiPayoutControllerGetPayoutsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payoutControllerGetPayoutsList(r, n) {
      return o.payoutControllerGetPayoutsList(r.limit, r.page, r.orderBy, r.filter, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Starts export operation
     * @param {PayoutApiPayoutControllerStartExportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payoutControllerStartExport(r, n) {
      return o.payoutControllerStartExport(r.payoutExportReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Update payout
     * @param {PayoutApiPayoutControllerUpdatePayoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payoutControllerUpdatePayout(r, n) {
      return o.payoutControllerUpdatePayout(r.id, r.updatePayoutReq, n).then((l) => l(t, e));
    }
  };
};
class En extends v {
  /**
   * 
   * @summary Create payout
   * @param {PayoutApiAccountPayoutControllerCreateInvoiceRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PayoutApi
   */
  createInvoice(e, t) {
    return z(this.configuration).accountPayoutControllerCreateInvoice(e.id, e.createPayoutParamsReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get a list of withdrawal requests
   * @param {PayoutApiAccountPayoutControllerGetAccountInvoiceListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PayoutApi
   */
  getAccountInvoiceList(e, t) {
    return z(this.configuration).accountPayoutControllerGetAccountInvoiceList(e.limit, e.page, e.id, e.orderBy, e.filter, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Bulk create payout
   * @param {PayoutApiPayoutControllerBulkCreatePayoutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PayoutApi
   */
  bulkCreatePayout(e, t) {
    return z(this.configuration).payoutControllerBulkCreatePayout(e.bulkCreatePayoutReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns export headers
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PayoutApi
   */
  getExportHeaders(e) {
    return z(this.configuration).payoutControllerGetExportHeaders(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get payout list
   * @param {PayoutApiPayoutControllerGetPayoutsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PayoutApi
   */
  getPayoutsList(e, t) {
    return z(this.configuration).payoutControllerGetPayoutsList(e.limit, e.page, e.orderBy, e.filter, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Starts export operation
   * @param {PayoutApiPayoutControllerStartExportRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PayoutApi
   */
  startExport(e, t) {
    return z(this.configuration).payoutControllerStartExport(e.payoutExportReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update payout
   * @param {PayoutApiPayoutControllerUpdatePayoutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PayoutApi
   */
  updatePayout(e, t) {
    return z(this.configuration).payoutControllerUpdatePayout(e.id, e.updatePayoutReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const In = function(a) {
  return {
    /**
     * 
     * @summary Getting a list of period closing history
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    periodControllerGetPeriodCloseHistory: async (e, t, o = {}) => {
      p("periodControllerGetPeriodCloseHistory", "limit", e), p("periodControllerGetPeriodCloseHistory", "page", t);
      const r = "/api3/period/close-history", n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      await P(i, a), e !== void 0 && (c.limit = e), t !== void 0 && (c.page = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Getting a list of periods
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    periodControllerGetPeriods: async (e, t, o = {}) => {
      p("periodControllerGetPeriods", "limit", e), p("periodControllerGetPeriods", "page", t);
      const r = "/api3/period", n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      await P(i, a), e !== void 0 && (c.limit = e), t !== void 0 && (c.page = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    }
  };
}, ut = function(a) {
  const e = In(a);
  return {
    /**
     * 
     * @summary Getting a list of period closing history
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async periodControllerGetPeriodCloseHistory(t, o, r) {
      const n = await e.periodControllerGetPeriodCloseHistory(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Getting a list of periods
     * @param {number} limit 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async periodControllerGetPeriods(t, o, r) {
      const n = await e.periodControllerGetPeriods(t, o, r);
      return V(n, u, C, a);
    }
  };
}, vs = function(a, e, t) {
  const o = ut(a);
  return {
    /**
     * 
     * @summary Getting a list of period closing history
     * @param {PeriodApiPeriodControllerGetPeriodCloseHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    periodControllerGetPeriodCloseHistory(r, n) {
      return o.periodControllerGetPeriodCloseHistory(r.limit, r.page, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting a list of periods
     * @param {PeriodApiPeriodControllerGetPeriodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    periodControllerGetPeriods(r, n) {
      return o.periodControllerGetPeriods(r.limit, r.page, n).then((l) => l(t, e));
    }
  };
};
class Fn extends v {
  /**
   * 
   * @summary Getting a list of period closing history
   * @param {PeriodApiPeriodControllerGetPeriodCloseHistoryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeriodApi
   */
  getPeriodCloseHistory(e, t) {
    return ut(this.configuration).periodControllerGetPeriodCloseHistory(e.limit, e.page, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting a list of periods
   * @param {PeriodApiPeriodControllerGetPeriodsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeriodApi
   */
  getPeriods(e, t) {
    return ut(this.configuration).periodControllerGetPeriods(e.limit, e.page, t).then((o) => o(this.axios, this.basePath));
  }
}
const Ln = function(a) {
  return {
    /**
     * 
     * @summary Update plan
     * @param {UpdatePlanReq} updatePlanReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planControllerEditPlan: async (e, t = {}) => {
      p("planControllerEditPlan", "updatePlanReq", e);
      const o = "/api3/plan", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "PUT", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planControllerGetPlans: async (e = {}) => {
      const t = "/api3/plan", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    }
  };
}, Ct = function(a) {
  const e = Ln(a);
  return {
    /**
     * 
     * @summary Update plan
     * @param {UpdatePlanReq} updatePlanReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planControllerEditPlan(t, o) {
      const r = await e.planControllerEditPlan(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planControllerGetPlans(t) {
      const o = await e.planControllerGetPlans(t);
      return V(o, u, C, a);
    }
  };
}, Us = function(a, e, t) {
  const o = Ct(a);
  return {
    /**
     * 
     * @summary Update plan
     * @param {PlanApiPlanControllerEditPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planControllerEditPlan(r, n) {
      return o.planControllerEditPlan(r.updatePlanReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planControllerGetPlans(r) {
      return o.planControllerGetPlans(r).then((n) => n(t, e));
    }
  };
};
class Dn extends v {
  /**
   * 
   * @summary Update plan
   * @param {PlanApiPlanControllerEditPlanRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanApi
   */
  editPlan(e, t) {
    return Ct(this.configuration).planControllerEditPlan(e.updatePlanReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns plans
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanApi
   */
  getPlans(e) {
    return Ct(this.configuration).planControllerGetPlans(e).then((t) => t(this.axios, this.basePath));
  }
}
const Bn = function(a) {
  return {
    /**
     * 
     * @summary Create plan parameter
     * @param {AddPlanParameterReq} addPlanParameterReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planParameterControllerCreatePlanParameter: async (e, t = {}) => {
      p("planParameterControllerCreatePlanParameter", "addPlanParameterReq", e);
      const o = "/api3/plan-parameter", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Delete plan parameter
     * @param {number} id plan parameter id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planParameterControllerDeletePlanParameter: async (e, t = {}) => {
      p("planParameterControllerDeletePlanParameter", "id", e);
      const o = "/api3/plan-parameter/{id}".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "DELETE", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Get plan parameters list
     * @param {number} [fieldTypeId] Field type id
     * @param {boolean} [dictionaryItems] Include dictionary items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planParameterControllerGetPlanParameters: async (e, t, o = {}) => {
      const r = "/api3/plan-parameter", n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      await P(i, a), e !== void 0 && (c.fieldTypeId = e), t !== void 0 && (c.dictionaryItems = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Update plan parameter
     * @param {number} id plan parameter id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planParameterControllerUpdatePlanParameter: async (e, t = {}) => {
      p("planParameterControllerUpdatePlanParameter", "id", e);
      const o = "/api3/plan-parameter/{id}".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "PUT", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Update plan parameter value
     * @param {number} id plan parameter id
     * @param {SetPlanParameterValuesReq} setPlanParameterValuesReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planParameterControllerUpdatePlanParameterValue: async (e, t, o = {}) => {
      p("planParameterControllerUpdatePlanParameterValue", "id", e), p("planParameterControllerUpdatePlanParameterValue", "setPlanParameterValuesReq", t);
      const r = "/api3/plan-parameter/{id}/values".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, ae = function(a) {
  const e = Bn(a);
  return {
    /**
     * 
     * @summary Create plan parameter
     * @param {AddPlanParameterReq} addPlanParameterReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planParameterControllerCreatePlanParameter(t, o) {
      const r = await e.planParameterControllerCreatePlanParameter(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Delete plan parameter
     * @param {number} id plan parameter id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planParameterControllerDeletePlanParameter(t, o) {
      const r = await e.planParameterControllerDeletePlanParameter(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Get plan parameters list
     * @param {number} [fieldTypeId] Field type id
     * @param {boolean} [dictionaryItems] Include dictionary items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planParameterControllerGetPlanParameters(t, o, r) {
      const n = await e.planParameterControllerGetPlanParameters(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Update plan parameter
     * @param {number} id plan parameter id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planParameterControllerUpdatePlanParameter(t, o) {
      const r = await e.planParameterControllerUpdatePlanParameter(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Update plan parameter value
     * @param {number} id plan parameter id
     * @param {SetPlanParameterValuesReq} setPlanParameterValuesReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planParameterControllerUpdatePlanParameterValue(t, o, r) {
      const n = await e.planParameterControllerUpdatePlanParameterValue(t, o, r);
      return V(n, u, C, a);
    }
  };
}, gs = function(a, e, t) {
  const o = ae(a);
  return {
    /**
     * 
     * @summary Create plan parameter
     * @param {PlanParameterApiPlanParameterControllerCreatePlanParameterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planParameterControllerCreatePlanParameter(r, n) {
      return o.planParameterControllerCreatePlanParameter(r.addPlanParameterReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Delete plan parameter
     * @param {PlanParameterApiPlanParameterControllerDeletePlanParameterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planParameterControllerDeletePlanParameter(r, n) {
      return o.planParameterControllerDeletePlanParameter(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Get plan parameters list
     * @param {PlanParameterApiPlanParameterControllerGetPlanParametersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planParameterControllerGetPlanParameters(r = {}, n) {
      return o.planParameterControllerGetPlanParameters(r.fieldTypeId, r.dictionaryItems, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Update plan parameter
     * @param {PlanParameterApiPlanParameterControllerUpdatePlanParameterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planParameterControllerUpdatePlanParameter(r, n) {
      return o.planParameterControllerUpdatePlanParameter(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Update plan parameter value
     * @param {PlanParameterApiPlanParameterControllerUpdatePlanParameterValueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planParameterControllerUpdatePlanParameterValue(r, n) {
      return o.planParameterControllerUpdatePlanParameterValue(r.id, r.setPlanParameterValuesReq, n).then((l) => l(t, e));
    }
  };
};
class jn extends v {
  /**
   * 
   * @summary Create plan parameter
   * @param {PlanParameterApiPlanParameterControllerCreatePlanParameterRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanParameterApi
   */
  createPlanParameter(e, t) {
    return ae(this.configuration).planParameterControllerCreatePlanParameter(e.addPlanParameterReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Delete plan parameter
   * @param {PlanParameterApiPlanParameterControllerDeletePlanParameterRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanParameterApi
   */
  deletePlanParameter(e, t) {
    return ae(this.configuration).planParameterControllerDeletePlanParameter(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get plan parameters list
   * @param {PlanParameterApiPlanParameterControllerGetPlanParametersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanParameterApi
   */
  getPlanParameters(e = {}, t) {
    return ae(this.configuration).planParameterControllerGetPlanParameters(e.fieldTypeId, e.dictionaryItems, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update plan parameter
   * @param {PlanParameterApiPlanParameterControllerUpdatePlanParameterRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanParameterApi
   */
  updatePlanParameter(e, t) {
    return ae(this.configuration).planParameterControllerUpdatePlanParameter(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update plan parameter value
   * @param {PlanParameterApiPlanParameterControllerUpdatePlanParameterValueRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanParameterApi
   */
  updatePlanParameterValue(e, t) {
    return ae(this.configuration).planParameterControllerUpdatePlanParameterValue(e.id, e.setPlanParameterValuesReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const kn = function(a) {
  return {
    /**
     * 
     * @summary Create plan property
     * @param {AddPlanPropertyReq} addPlanPropertyReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planPropertyControllerCreatePlanProperty: async (e, t = {}) => {
      p("planPropertyControllerCreatePlanProperty", "addPlanPropertyReq", e);
      const o = "/api3/plan-property", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Delete plan property
     * @param {number} id Plan property id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planPropertyControllerDeletePlanProperty: async (e, t = {}) => {
      p("planPropertyControllerDeletePlanProperty", "id", e);
      const o = "/api3/plan-property/{id}".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "DELETE", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns plan properties
     * @param {boolean} [includeInvisible] Include invisible fields
     * @param {number} [treeId] Tree id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planPropertyControllerGetPlanProperties: async (e, t, o = {}) => {
      const r = "/api3/plan-property", n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      await P(i, a), e !== void 0 && (c.includeInvisible = e), t !== void 0 && (c.treeId = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Update plan property
     * @param {number} id Plan property id
     * @param {UpdatePlanPropertyReq} updatePlanPropertyReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planPropertyControllerUpdatePlanProperty: async (e, t, o = {}) => {
      p("planPropertyControllerUpdatePlanProperty", "id", e), p("planPropertyControllerUpdatePlanProperty", "updatePlanPropertyReq", t);
      const r = "/api3/plan-property/{id}".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, we = function(a) {
  const e = kn(a);
  return {
    /**
     * 
     * @summary Create plan property
     * @param {AddPlanPropertyReq} addPlanPropertyReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planPropertyControllerCreatePlanProperty(t, o) {
      const r = await e.planPropertyControllerCreatePlanProperty(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Delete plan property
     * @param {number} id Plan property id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planPropertyControllerDeletePlanProperty(t, o) {
      const r = await e.planPropertyControllerDeletePlanProperty(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns plan properties
     * @param {boolean} [includeInvisible] Include invisible fields
     * @param {number} [treeId] Tree id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planPropertyControllerGetPlanProperties(t, o, r) {
      const n = await e.planPropertyControllerGetPlanProperties(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Update plan property
     * @param {number} id Plan property id
     * @param {UpdatePlanPropertyReq} updatePlanPropertyReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planPropertyControllerUpdatePlanProperty(t, o, r) {
      const n = await e.planPropertyControllerUpdatePlanProperty(t, o, r);
      return V(n, u, C, a);
    }
  };
}, xs = function(a, e, t) {
  const o = we(a);
  return {
    /**
     * 
     * @summary Create plan property
     * @param {PlanPropertyApiPlanPropertyControllerCreatePlanPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planPropertyControllerCreatePlanProperty(r, n) {
      return o.planPropertyControllerCreatePlanProperty(r.addPlanPropertyReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Delete plan property
     * @param {PlanPropertyApiPlanPropertyControllerDeletePlanPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planPropertyControllerDeletePlanProperty(r, n) {
      return o.planPropertyControllerDeletePlanProperty(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns plan properties
     * @param {PlanPropertyApiPlanPropertyControllerGetPlanPropertiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planPropertyControllerGetPlanProperties(r = {}, n) {
      return o.planPropertyControllerGetPlanProperties(r.includeInvisible, r.treeId, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Update plan property
     * @param {PlanPropertyApiPlanPropertyControllerUpdatePlanPropertyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planPropertyControllerUpdatePlanProperty(r, n) {
      return o.planPropertyControllerUpdatePlanProperty(r.id, r.updatePlanPropertyReq, n).then((l) => l(t, e));
    }
  };
};
class Hn extends v {
  /**
   * 
   * @summary Create plan property
   * @param {PlanPropertyApiPlanPropertyControllerCreatePlanPropertyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanPropertyApi
   */
  createPlanProperty(e, t) {
    return we(this.configuration).planPropertyControllerCreatePlanProperty(e.addPlanPropertyReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Delete plan property
   * @param {PlanPropertyApiPlanPropertyControllerDeletePlanPropertyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanPropertyApi
   */
  deletePlanProperty(e, t) {
    return we(this.configuration).planPropertyControllerDeletePlanProperty(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns plan properties
   * @param {PlanPropertyApiPlanPropertyControllerGetPlanPropertiesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanPropertyApi
   */
  getPlanProperties(e = {}, t) {
    return we(this.configuration).planPropertyControllerGetPlanProperties(e.includeInvisible, e.treeId, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update plan property
   * @param {PlanPropertyApiPlanPropertyControllerUpdatePlanPropertyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanPropertyApi
   */
  updatePlanProperty(e, t) {
    return we(this.configuration).planPropertyControllerUpdatePlanProperty(e.id, e.updatePlanPropertyReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const Qn = function(a) {
  return {
    /**
     * 
     * @summary Returns platform enroll settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerGetEnrollSettings: async (e = {}) => {
      const t = "/api3/platform-setting/enroll", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {};
      m(o, {});
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Returns platform format settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerGetFormatSettings: async (e = {}) => {
      const t = "/api3/platform-setting/format", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Returns platform global settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerGetGlobalSettings: async (e = {}) => {
      const t = "/api3/platform-setting/global", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Returns platform pos-global settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerGetPosGlobalSettings: async (e = {}) => {
      const t = "/api3/platform-setting/pos-global", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Returns platform settings
     * @param {string} [group] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerGetSettings: async (e, t = {}) => {
      const o = "/api3/platform-setting", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      await P(s, a), e !== void 0 && (i.group = e), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Returns platform sms settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerGetSmsSettings: async (e = {}) => {
      const t = "/api3/platform-setting/sms", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Set platform enroll settings
     * @param {SetEnrollSettingsReq} setEnrollSettingsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerSetEnrollSettings: async (e, t = {}) => {
      p("platformSettingControllerSetEnrollSettings", "setEnrollSettingsReq", e);
      const o = "/api3/platform-setting/enroll", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Set platform format settings
     * @param {SetFormatSettingsReq} setFormatSettingsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerSetFormatSettings: async (e, t = {}) => {
      p("platformSettingControllerSetFormatSettings", "setFormatSettingsReq", e);
      const o = "/api3/platform-setting/format", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Set platform global settings
     * @param {SetGlobalSettingsReq} setGlobalSettingsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerSetGlobalSettings: async (e, t = {}) => {
      p("platformSettingControllerSetGlobalSettings", "setGlobalSettingsReq", e);
      const o = "/api3/platform-setting/global", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Set platform pos-global settings
     * @param {SetPosGlobalSettingsReq} setPosGlobalSettingsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerSetPosGlobalSettings: async (e, t = {}) => {
      p("platformSettingControllerSetPosGlobalSettings", "setPosGlobalSettingsReq", e);
      const o = "/api3/platform-setting/pos-global", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Set platform sms settings
     * @param {SetSmsSettingsReq} setSmsSettingsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerSetSmsSettings: async (e, t = {}) => {
      p("platformSettingControllerSetSmsSettings", "setSmsSettingsReq", e);
      const o = "/api3/platform-setting/sms", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    }
  };
}, j = function(a) {
  const e = Qn(a);
  return {
    /**
     * 
     * @summary Returns platform enroll settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformSettingControllerGetEnrollSettings(t) {
      const o = await e.platformSettingControllerGetEnrollSettings(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Returns platform format settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformSettingControllerGetFormatSettings(t) {
      const o = await e.platformSettingControllerGetFormatSettings(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Returns platform global settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformSettingControllerGetGlobalSettings(t) {
      const o = await e.platformSettingControllerGetGlobalSettings(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Returns platform pos-global settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformSettingControllerGetPosGlobalSettings(t) {
      const o = await e.platformSettingControllerGetPosGlobalSettings(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Returns platform settings
     * @param {string} [group] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformSettingControllerGetSettings(t, o) {
      const r = await e.platformSettingControllerGetSettings(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Returns platform sms settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformSettingControllerGetSmsSettings(t) {
      const o = await e.platformSettingControllerGetSmsSettings(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Set platform enroll settings
     * @param {SetEnrollSettingsReq} setEnrollSettingsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformSettingControllerSetEnrollSettings(t, o) {
      const r = await e.platformSettingControllerSetEnrollSettings(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Set platform format settings
     * @param {SetFormatSettingsReq} setFormatSettingsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformSettingControllerSetFormatSettings(t, o) {
      const r = await e.platformSettingControllerSetFormatSettings(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Set platform global settings
     * @param {SetGlobalSettingsReq} setGlobalSettingsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformSettingControllerSetGlobalSettings(t, o) {
      const r = await e.platformSettingControllerSetGlobalSettings(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Set platform pos-global settings
     * @param {SetPosGlobalSettingsReq} setPosGlobalSettingsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformSettingControllerSetPosGlobalSettings(t, o) {
      const r = await e.platformSettingControllerSetPosGlobalSettings(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Set platform sms settings
     * @param {SetSmsSettingsReq} setSmsSettingsReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async platformSettingControllerSetSmsSettings(t, o) {
      const r = await e.platformSettingControllerSetSmsSettings(t, o);
      return V(r, u, C, a);
    }
  };
}, Es = function(a, e, t) {
  const o = j(a);
  return {
    /**
     * 
     * @summary Returns platform enroll settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerGetEnrollSettings(r) {
      return o.platformSettingControllerGetEnrollSettings(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Returns platform format settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerGetFormatSettings(r) {
      return o.platformSettingControllerGetFormatSettings(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Returns platform global settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerGetGlobalSettings(r) {
      return o.platformSettingControllerGetGlobalSettings(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Returns platform pos-global settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerGetPosGlobalSettings(r) {
      return o.platformSettingControllerGetPosGlobalSettings(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Returns platform settings
     * @param {PlatformSettingApiPlatformSettingControllerGetSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerGetSettings(r = {}, n) {
      return o.platformSettingControllerGetSettings(r.group, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns platform sms settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerGetSmsSettings(r) {
      return o.platformSettingControllerGetSmsSettings(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Set platform enroll settings
     * @param {PlatformSettingApiPlatformSettingControllerSetEnrollSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerSetEnrollSettings(r, n) {
      return o.platformSettingControllerSetEnrollSettings(r.setEnrollSettingsReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Set platform format settings
     * @param {PlatformSettingApiPlatformSettingControllerSetFormatSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerSetFormatSettings(r, n) {
      return o.platformSettingControllerSetFormatSettings(r.setFormatSettingsReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Set platform global settings
     * @param {PlatformSettingApiPlatformSettingControllerSetGlobalSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerSetGlobalSettings(r, n) {
      return o.platformSettingControllerSetGlobalSettings(r.setGlobalSettingsReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Set platform pos-global settings
     * @param {PlatformSettingApiPlatformSettingControllerSetPosGlobalSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerSetPosGlobalSettings(r, n) {
      return o.platformSettingControllerSetPosGlobalSettings(r.setPosGlobalSettingsReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Set platform sms settings
     * @param {PlatformSettingApiPlatformSettingControllerSetSmsSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformSettingControllerSetSmsSettings(r, n) {
      return o.platformSettingControllerSetSmsSettings(r.setSmsSettingsReq, n).then((l) => l(t, e));
    }
  };
};
class Wn extends v {
  /**
   * 
   * @summary Returns platform enroll settings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformSettingApi
   */
  getEnrollSettings(e) {
    return j(this.configuration).platformSettingControllerGetEnrollSettings(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns platform format settings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformSettingApi
   */
  getFormatSettings(e) {
    return j(this.configuration).platformSettingControllerGetFormatSettings(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns platform global settings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformSettingApi
   */
  getGlobalSettings(e) {
    return j(this.configuration).platformSettingControllerGetGlobalSettings(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns platform pos-global settings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformSettingApi
   */
  getPosGlobalSettings(e) {
    return j(this.configuration).platformSettingControllerGetPosGlobalSettings(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns platform settings
   * @param {PlatformSettingApiPlatformSettingControllerGetSettingsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformSettingApi
   */
  getSettings(e = {}, t) {
    return j(this.configuration).platformSettingControllerGetSettings(e.group, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns platform sms settings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformSettingApi
   */
  getSmsSettings(e) {
    return j(this.configuration).platformSettingControllerGetSmsSettings(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Set platform enroll settings
   * @param {PlatformSettingApiPlatformSettingControllerSetEnrollSettingsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformSettingApi
   */
  setEnrollSettings(e, t) {
    return j(this.configuration).platformSettingControllerSetEnrollSettings(e.setEnrollSettingsReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Set platform format settings
   * @param {PlatformSettingApiPlatformSettingControllerSetFormatSettingsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformSettingApi
   */
  setFormatSettings(e, t) {
    return j(this.configuration).platformSettingControllerSetFormatSettings(e.setFormatSettingsReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Set platform global settings
   * @param {PlatformSettingApiPlatformSettingControllerSetGlobalSettingsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformSettingApi
   */
  setGlobalSettings(e, t) {
    return j(this.configuration).platformSettingControllerSetGlobalSettings(e.setGlobalSettingsReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Set platform pos-global settings
   * @param {PlatformSettingApiPlatformSettingControllerSetPosGlobalSettingsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformSettingApi
   */
  setPosGlobalSettings(e, t) {
    return j(this.configuration).platformSettingControllerSetPosGlobalSettings(e.setPosGlobalSettingsReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Set platform sms settings
   * @param {PlatformSettingApiPlatformSettingControllerSetSmsSettingsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlatformSettingApi
   */
  setSmsSettings(e, t) {
    return j(this.configuration).platformSettingControllerSetSmsSettings(e.setSmsSettingsReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const $n = function(a) {
  return {
    /**
     * 
     * @summary Creates profile field
     * @param {AddProfileFieldReq} addProfileFieldReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileFieldControllerCreateProfileField: async (e, t = {}) => {
      p("profileFieldControllerCreateProfileField", "addProfileFieldReq", e);
      const o = "/api3/profile-field", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Deletes profile field
     * @param {number} id 
     * @param {boolean} [hardRemove] Hard remove item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileFieldControllerDeleteProfileField: async (e, t, o = {}) => {
      p("profileFieldControllerDeleteProfileField", "id", e);
      const r = "/api3/profile-field/{id}".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "DELETE", ...l, ...o }, i = {}, c = {};
      await P(i, a), t !== void 0 && (c.hardRemove = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Returns profile fields
     * @param {boolean} [includeDeleted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileFieldControllerGetProfileFields: async (e, t = {}) => {
      const o = "/api3/profile-field", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "GET", ...n, ...t }, s = {}, i = {};
      e !== void 0 && (i.includeDeleted = e), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Updates profile field
     * @param {number} id 
     * @param {UpdateProfileFieldReq} updateProfileFieldReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileFieldControllerUpdateProfileField: async (e, t, o = {}) => {
      p("profileFieldControllerUpdateProfileField", "id", e), p("profileFieldControllerUpdateProfileField", "updateProfileFieldReq", t);
      const r = "/api3/profile-field/{id}".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, Ae = function(a) {
  const e = $n(a);
  return {
    /**
     * 
     * @summary Creates profile field
     * @param {AddProfileFieldReq} addProfileFieldReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profileFieldControllerCreateProfileField(t, o) {
      const r = await e.profileFieldControllerCreateProfileField(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Deletes profile field
     * @param {number} id 
     * @param {boolean} [hardRemove] Hard remove item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profileFieldControllerDeleteProfileField(t, o, r) {
      const n = await e.profileFieldControllerDeleteProfileField(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Returns profile fields
     * @param {boolean} [includeDeleted] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profileFieldControllerGetProfileFields(t, o) {
      const r = await e.profileFieldControllerGetProfileFields(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Updates profile field
     * @param {number} id 
     * @param {UpdateProfileFieldReq} updateProfileFieldReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async profileFieldControllerUpdateProfileField(t, o, r) {
      const n = await e.profileFieldControllerUpdateProfileField(t, o, r);
      return V(n, u, C, a);
    }
  };
}, Is = function(a, e, t) {
  const o = Ae(a);
  return {
    /**
     * 
     * @summary Creates profile field
     * @param {ProfileFieldsApiProfileFieldControllerCreateProfileFieldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileFieldControllerCreateProfileField(r, n) {
      return o.profileFieldControllerCreateProfileField(r.addProfileFieldReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Deletes profile field
     * @param {ProfileFieldsApiProfileFieldControllerDeleteProfileFieldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileFieldControllerDeleteProfileField(r, n) {
      return o.profileFieldControllerDeleteProfileField(r.id, r.hardRemove, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns profile fields
     * @param {ProfileFieldsApiProfileFieldControllerGetProfileFieldsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileFieldControllerGetProfileFields(r = {}, n) {
      return o.profileFieldControllerGetProfileFields(r.includeDeleted, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Updates profile field
     * @param {ProfileFieldsApiProfileFieldControllerUpdateProfileFieldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileFieldControllerUpdateProfileField(r, n) {
      return o.profileFieldControllerUpdateProfileField(r.id, r.updateProfileFieldReq, n).then((l) => l(t, e));
    }
  };
};
class Nn extends v {
  /**
   * 
   * @summary Creates profile field
   * @param {ProfileFieldsApiProfileFieldControllerCreateProfileFieldRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileFieldsApi
   */
  createProfileField(e, t) {
    return Ae(this.configuration).profileFieldControllerCreateProfileField(e.addProfileFieldReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Deletes profile field
   * @param {ProfileFieldsApiProfileFieldControllerDeleteProfileFieldRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileFieldsApi
   */
  deleteProfileField(e, t) {
    return Ae(this.configuration).profileFieldControllerDeleteProfileField(e.id, e.hardRemove, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns profile fields
   * @param {ProfileFieldsApiProfileFieldControllerGetProfileFieldsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileFieldsApi
   */
  getProfileFields(e = {}, t) {
    return Ae(this.configuration).profileFieldControllerGetProfileFields(e.includeDeleted, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Updates profile field
   * @param {ProfileFieldsApiProfileFieldControllerUpdateProfileFieldRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileFieldsApi
   */
  updateProfileField(e, t) {
    return Ae(this.configuration).profileFieldControllerUpdateProfileField(e.id, e.updateProfileFieldReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const _n = function(a) {
  return {
    /**
     * 
     * @summary Returns queue status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    queueStatusControllerGetQueueStatus: async (e = {}) => {
      const t = "/api3/app/queue-status", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Sets the queue status
     * @param {SetQueueStatusReqQuery} setQueueStatusReqQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    queueStatusControllerSetQueueStatus: async (e, t = {}) => {
      p("queueStatusControllerSetQueueStatus", "setQueueStatusReqQuery", e);
      const o = "/api3/app/queue-status", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "PUT", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    }
  };
}, yt = function(a) {
  const e = _n(a);
  return {
    /**
     * 
     * @summary Returns queue status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async queueStatusControllerGetQueueStatus(t) {
      const o = await e.queueStatusControllerGetQueueStatus(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Sets the queue status
     * @param {SetQueueStatusReqQuery} setQueueStatusReqQuery 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async queueStatusControllerSetQueueStatus(t, o) {
      const r = await e.queueStatusControllerSetQueueStatus(t, o);
      return V(r, u, C, a);
    }
  };
}, Fs = function(a, e, t) {
  const o = yt(a);
  return {
    /**
     * 
     * @summary Returns queue status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    queueStatusControllerGetQueueStatus(r) {
      return o.queueStatusControllerGetQueueStatus(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Sets the queue status
     * @param {QueueApiQueueStatusControllerSetQueueStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    queueStatusControllerSetQueueStatus(r, n) {
      return o.queueStatusControllerSetQueueStatus(r.setQueueStatusReqQuery, n).then((l) => l(t, e));
    }
  };
};
class Mn extends v {
  /**
   * 
   * @summary Returns queue status
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QueueApi
   */
  getQueueStatus(e) {
    return yt(this.configuration).queueStatusControllerGetQueueStatus(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Sets the queue status
   * @param {QueueApiQueueStatusControllerSetQueueStatusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QueueApi
   */
  setQueueStatus(e, t) {
    return yt(this.configuration).queueStatusControllerSetQueueStatus(e.setQueueStatusReqQuery, t).then((o) => o(this.axios, this.basePath));
  }
}
const zn = function(a) {
  return {
    /**
     * 
     * @summary Returns transaction log
     * @param {number} limit 
     * @param {number} page 
     * @param {any} [accountId] 
     * @param {any} [positionId] 
     * @param {string} [documentType] 
     * @param {any} [docId] 
     * @param {string} [planProperty] 
     * @param {any} [periodId] 
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionLogControllerGetTransactionLog: async (e, t, o, r, n, l, s, i, c, d = {}) => {
      p("transactionLogControllerGetTransactionLog", "limit", e), p("transactionLogControllerGetTransactionLog", "page", t);
      const h = "/api3/transaction-log", f = new URL(h, y);
      let R;
      a && (R = a.baseOptions);
      const A = { method: "GET", ...R, ...d }, w = {}, T = {};
      await P(w, a), e !== void 0 && (T.limit = e), t !== void 0 && (T.page = t), o !== void 0 && (T.accountId = o), r !== void 0 && (T.positionId = r), n !== void 0 && (T.documentType = n), l !== void 0 && (T.docId = l), s !== void 0 && (T.planProperty = s), i !== void 0 && (T.periodId = i), c !== void 0 && (T.filter = c), m(f, T);
      let g = R && R.headers ? R.headers : {};
      return A.headers = { ...w, ...g, ...d.headers }, {
        url: O(f),
        options: A
      };
    }
  };
}, Pr = function(a) {
  const e = zn(a);
  return {
    /**
     * 
     * @summary Returns transaction log
     * @param {number} limit 
     * @param {number} page 
     * @param {any} [accountId] 
     * @param {any} [positionId] 
     * @param {string} [documentType] 
     * @param {any} [docId] 
     * @param {string} [planProperty] 
     * @param {any} [periodId] 
     * @param {object} [filter] Filtering parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transactionLogControllerGetTransactionLog(t, o, r, n, l, s, i, c, d, h) {
      const f = await e.transactionLogControllerGetTransactionLog(t, o, r, n, l, s, i, c, d, h);
      return V(f, u, C, a);
    }
  };
}, Ls = function(a, e, t) {
  const o = Pr(a);
  return {
    /**
     * 
     * @summary Returns transaction log
     * @param {TransactionLogApiTransactionLogControllerGetTransactionLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transactionLogControllerGetTransactionLog(r, n) {
      return o.transactionLogControllerGetTransactionLog(r.limit, r.page, r.accountId, r.positionId, r.documentType, r.docId, r.planProperty, r.periodId, r.filter, n).then((l) => l(t, e));
    }
  };
};
class Kn extends v {
  /**
   * 
   * @summary Returns transaction log
   * @param {TransactionLogApiTransactionLogControllerGetTransactionLogRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionLogApi
   */
  getTransactionLog(e, t) {
    return Pr(this.configuration).transactionLogControllerGetTransactionLog(e.limit, e.page, e.accountId, e.positionId, e.documentType, e.docId, e.planProperty, e.periodId, e.filter, t).then((o) => o(this.axios, this.basePath));
  }
}
const Jn = function(a) {
  return {
    /**
     * 
     * @summary Get a list of trees
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    treeControllerGetTrees: async (e = {}) => {
      const t = "/api3/tree", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Update tree
     * @param {UpdateTreeReq} updateTreeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    treeControllerUpdateTree: async (e, t = {}) => {
      p("treeControllerUpdateTree", "updateTreeReq", e);
      const o = "/api3/tree", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "PUT", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    }
  };
}, mt = function(a) {
  const e = Jn(a);
  return {
    /**
     * 
     * @summary Get a list of trees
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async treeControllerGetTrees(t) {
      const o = await e.treeControllerGetTrees(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Update tree
     * @param {UpdateTreeReq} updateTreeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async treeControllerUpdateTree(t, o) {
      const r = await e.treeControllerUpdateTree(t, o);
      return V(r, u, C, a);
    }
  };
}, Ds = function(a, e, t) {
  const o = mt(a);
  return {
    /**
     * 
     * @summary Get a list of trees
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    treeControllerGetTrees(r) {
      return o.treeControllerGetTrees(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Update tree
     * @param {TreeApiTreeControllerUpdateTreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    treeControllerUpdateTree(r, n) {
      return o.treeControllerUpdateTree(r.updateTreeReq, n).then((l) => l(t, e));
    }
  };
};
class Xn extends v {
  /**
   * 
   * @summary Get a list of trees
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TreeApi
   */
  getTrees(e) {
    return mt(this.configuration).treeControllerGetTrees(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update tree
   * @param {TreeApiTreeControllerUpdateTreeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TreeApi
   */
  updateTree(e, t) {
    return mt(this.configuration).treeControllerUpdateTree(e.updateTreeReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const Zn = function(a) {
  return {
    /**
     * Please use the account/{id}/wallet/{walletId}/operation methods
     * @summary Creating a wallet transaction
     * @param {string} walletAlias Wallet alias
     * @param {number} id 
     * @param {PostTransactionReq} postTransactionReq 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    walletAliasControllerCreateTransaction: async (e, t, o, r = {}) => {
      p("walletAliasControllerCreateTransaction", "walletAlias", e), p("walletAliasControllerCreateTransaction", "id", t), p("walletAliasControllerCreateTransaction", "postTransactionReq", o);
      const n = "/api3/account/{id}/wallet/{walletAlias}/transaction".replace("{walletAlias}", encodeURIComponent(String(e))).replace("{id}", encodeURIComponent(String(t))), l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "POST", ...s, ...r }, c = {}, d = {};
      await P(c, a), c["Content-Type"] = "application/json", m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, i.data = S(o, i, a), {
        url: O(l),
        options: i
      };
    },
    /**
     * Please use the account/{id}/wallet/{walletId}/transfer methods
     * @summary Transferring money from a specified wallet to another
     * @param {string} walletAlias Wallet alias
     * @param {number} id 
     * @param {PostTransferReq} postTransferReq 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    walletAliasControllerCreateTransfer: async (e, t, o, r = {}) => {
      p("walletAliasControllerCreateTransfer", "walletAlias", e), p("walletAliasControllerCreateTransfer", "id", t), p("walletAliasControllerCreateTransfer", "postTransferReq", o);
      const n = "/api3/account/{id}/wallet/{walletAlias}/transfer".replace("{walletAlias}", encodeURIComponent(String(e))).replace("{id}", encodeURIComponent(String(t))), l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "POST", ...s, ...r }, c = {}, d = {};
      await P(c, a), c["Content-Type"] = "application/json", m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, i.data = S(o, i, a), {
        url: O(l),
        options: i
      };
    },
    /**
     * Please use the account/id/wallet/:walletId/operation methods
     * @summary Getting wallets operations
     * @param {string} walletAlias Wallet alias
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {number} [operationTypeId] Operation type ID
     * @param {any} [start] Date
     * @param {any} [end] Date
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    walletAliasControllerGetTransaction: async (e, t, o, r, n, l, s, i = {}) => {
      p("walletAliasControllerGetTransaction", "walletAlias", e), p("walletAliasControllerGetTransaction", "limit", t), p("walletAliasControllerGetTransaction", "page", o), p("walletAliasControllerGetTransaction", "id", r);
      const c = "/api3/account/{id}/wallet/{walletAlias}/transaction".replace("{walletAlias}", encodeURIComponent(String(e))).replace("{id}", encodeURIComponent(String(r))), d = new URL(c, y);
      let h;
      a && (h = a.baseOptions);
      const f = { method: "GET", ...h, ...i }, R = {}, A = {};
      await P(R, a), t !== void 0 && (A.limit = t), o !== void 0 && (A.page = o), n !== void 0 && (A.operationTypeId = n), l !== void 0 && (A.start = l), s !== void 0 && (A.end = s), m(d, A);
      let w = h && h.headers ? h.headers : {};
      return f.headers = { ...R, ...w, ...i.headers }, {
        url: O(d),
        options: f
      };
    },
    /**
     * 
     * @summary Get a list of account wallets
     * @param {number} id 
     * @param {any} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletAliasControllerGetWalletsList: async (e, t, o = {}) => {
      p("walletAliasControllerGetWalletsList", "id", e);
      const r = "/api3/account/{id}/wallet".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      await P(i, a), t !== void 0 && (c.date = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Returns transaction log
     * @param {number} limit 
     * @param {number} page 
     * @param {ExportOperationParams} exportOperationParams 
     * @param {number} [walletTypeId] 
     * @param {number} [accountId] 
     * @param {object} [filter] Filtering parameters
     * @param {object} [orderBy] Sort options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletBalanceControllerExportWalletOperations: async (e, t, o, r, n, l, s, i = {}) => {
      p("walletBalanceControllerExportWalletOperations", "limit", e), p("walletBalanceControllerExportWalletOperations", "page", t), p("walletBalanceControllerExportWalletOperations", "exportOperationParams", o);
      const c = "/api3/wallet-balance/export", d = new URL(c, y);
      let h;
      a && (h = a.baseOptions);
      const f = { method: "POST", ...h, ...i }, R = {}, A = {};
      await P(R, a), e !== void 0 && (A.limit = e), t !== void 0 && (A.page = t), r !== void 0 && (A.walletTypeId = r), n !== void 0 && (A.accountId = n), l !== void 0 && (A.filter = l), s !== void 0 && (A.orderBy = s), R["Content-Type"] = "application/json", m(d, A);
      let w = h && h.headers ? h.headers : {};
      return f.headers = { ...R, ...w, ...i.headers }, f.data = S(o, f, a), {
        url: O(d),
        options: f
      };
    },
    /**
     * 
     * @summary Returns export headers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletBalanceControllerGetExportHeaders: async (e = {}) => {
      const t = "/api3/wallet-balance/export/headers", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Returns wallet balances
     * @param {number} limit 
     * @param {number} page 
     * @param {number} [walletTypeId] 
     * @param {number} [accountId] 
     * @param {object} [filter] Filtering parameters
     * @param {object} [orderBy] Sort options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletBalanceControllerGetWalletOperations: async (e, t, o, r, n, l, s = {}) => {
      p("walletBalanceControllerGetWalletOperations", "limit", e), p("walletBalanceControllerGetWalletOperations", "page", t);
      const i = "/api3/wallet-balance", c = new URL(i, y);
      let d;
      a && (d = a.baseOptions);
      const h = { method: "GET", ...d, ...s }, f = {}, R = {};
      await P(f, a), e !== void 0 && (R.limit = e), t !== void 0 && (R.page = t), o !== void 0 && (R.walletTypeId = o), r !== void 0 && (R.accountId = r), n !== void 0 && (R.filter = n), l !== void 0 && (R.orderBy = l), m(c, R);
      let A = d && d.headers ? d.headers : {};
      return h.headers = { ...f, ...A, ...s.headers }, {
        url: O(c),
        options: h
      };
    },
    /**
     * Create only one walletOperation. PaymentRule will be searched by target_wallet_type_id и target_wallet_operation_type_id
     * @summary Creating a wallet operation
     * @param {number} walletId Wallet ID
     * @param {number} id 
     * @param {PostTransactionReq} postTransactionReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationControllerCreateOperations: async (e, t, o, r = {}) => {
      p("walletOperationControllerCreateOperations", "walletId", e), p("walletOperationControllerCreateOperations", "id", t), p("walletOperationControllerCreateOperations", "postTransactionReq", o);
      const n = "/api3/account/{id}/wallet/{walletId}/operation".replace("{walletId}", encodeURIComponent(String(e))).replace("{id}", encodeURIComponent(String(t))), l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "POST", ...s, ...r }, c = {}, d = {};
      await P(c, a), c["Content-Type"] = "application/json", m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, i.data = S(o, i, a), {
        url: O(l),
        options: i
      };
    },
    /**
     * 
     * @summary Getting wallet operations
     * @param {number} walletId Wallet ID
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {ExportOperationParams} exportOperationParams 
     * @param {number} [operationTypeId] Operation type ID
     * @param {Array<string>} [operationTypeIds] Operation type IDs
     * @param {number} [paymentSystemId] Payment system ID
     * @param {number} [paymentRuleId] Payment rule ID
     * @param {string} [currencyId] Currency
     * @param {any} [start] Date
     * @param {any} [end] Date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationControllerExportOperations: async (e, t, o, r, n, l, s, i, c, d, h, f, R = {}) => {
      p("walletOperationControllerExportOperations", "walletId", e), p("walletOperationControllerExportOperations", "limit", t), p("walletOperationControllerExportOperations", "page", o), p("walletOperationControllerExportOperations", "id", r), p("walletOperationControllerExportOperations", "exportOperationParams", n);
      const A = "/api3/account/{id}/wallet/{walletId}/operation/export".replace("{walletId}", encodeURIComponent(String(e))).replace("{id}", encodeURIComponent(String(r))), w = new URL(A, y);
      let T;
      a && (T = a.baseOptions);
      const g = { method: "POST", ...T, ...R }, G = {}, E = {};
      await P(G, a), t !== void 0 && (E.limit = t), o !== void 0 && (E.page = o), l !== void 0 && (E.operationTypeId = l), s && (E.operationTypeIds = s), i !== void 0 && (E.paymentSystemId = i), c !== void 0 && (E.paymentRuleId = c), d !== void 0 && (E.currencyId = d), h !== void 0 && (E.start = h), f !== void 0 && (E.end = f), G["Content-Type"] = "application/json", m(w, E);
      let q = T && T.headers ? T.headers : {};
      return g.headers = { ...G, ...q, ...R.headers }, g.data = S(n, g, a), {
        url: O(w),
        options: g
      };
    },
    /**
     * 
     * @summary Getting wallet operations
     * @param {number} walletId Wallet ID
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {number} [operationTypeId] Operation type ID
     * @param {Array<string>} [operationTypeIds] Operation type IDs
     * @param {number} [paymentSystemId] Payment system ID
     * @param {number} [paymentRuleId] Payment rule ID
     * @param {string} [currencyId] Currency
     * @param {any} [start] Date
     * @param {any} [end] Date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationControllerGetOperations: async (e, t, o, r, n, l, s, i, c, d, h, f = {}) => {
      p("walletOperationControllerGetOperations", "walletId", e), p("walletOperationControllerGetOperations", "limit", t), p("walletOperationControllerGetOperations", "page", o), p("walletOperationControllerGetOperations", "id", r);
      const R = "/api3/account/{id}/wallet/{walletId}/operation".replace("{walletId}", encodeURIComponent(String(e))).replace("{id}", encodeURIComponent(String(r))), A = new URL(R, y);
      let w;
      a && (w = a.baseOptions);
      const T = { method: "GET", ...w, ...f }, g = {}, G = {};
      await P(g, a), t !== void 0 && (G.limit = t), o !== void 0 && (G.page = o), n !== void 0 && (G.operationTypeId = n), l && (G.operationTypeIds = l), s !== void 0 && (G.paymentSystemId = s), i !== void 0 && (G.paymentRuleId = i), c !== void 0 && (G.currencyId = c), d !== void 0 && (G.start = d), h !== void 0 && (G.end = h), m(A, G);
      let E = w && w.headers ? w.headers : {};
      return T.headers = { ...g, ...E, ...f.headers }, {
        url: O(A),
        options: T
      };
    },
    /**
     * Transfer to own account. 2 operations (out, in).     PaymentRule wil be searched by source_ and target_ params at one time
     * @summary Create an internal transfer
     * @param {number} walletId Wallet ID
     * @param {number} id 
     * @param {InternalTransferReq} internalTransferReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletTransferControllerCreateInternalTransfer: async (e, t, o, r = {}) => {
      p("walletTransferControllerCreateInternalTransfer", "walletId", e), p("walletTransferControllerCreateInternalTransfer", "id", t), p("walletTransferControllerCreateInternalTransfer", "internalTransferReq", o);
      const n = "/api3/account/{id}/wallet/{walletId}/internal-transfer".replace("{walletId}", encodeURIComponent(String(e))).replace("{id}", encodeURIComponent(String(t))), l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "POST", ...s, ...r }, c = {}, d = {};
      await P(c, a), c["Content-Type"] = "application/json", m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, i.data = S(o, i, a), {
        url: O(l),
        options: i
      };
    },
    /**
     * Transfer to another account. 2 operations (out, in).      PaymentRule wil be searched by source_ and target_ params at one time
     * @summary Create a transfer
     * @param {number} walletId Wallet ID
     * @param {number} id 
     * @param {PostTransferReq} postTransferReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletTransferControllerCreateTransfer: async (e, t, o, r = {}) => {
      p("walletTransferControllerCreateTransfer", "walletId", e), p("walletTransferControllerCreateTransfer", "id", t), p("walletTransferControllerCreateTransfer", "postTransferReq", o);
      const n = "/api3/account/{id}/wallet/{walletId}/external-transfer".replace("{walletId}", encodeURIComponent(String(e))).replace("{id}", encodeURIComponent(String(t))), l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "POST", ...s, ...r }, c = {}, d = {};
      await P(c, a), c["Content-Type"] = "application/json", m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, i.data = S(o, i, a), {
        url: O(l),
        options: i
      };
    },
    /**
     * Preview transfer to own account.
     * @summary Preview an internal transfer
     * @param {number} walletId Wallet ID
     * @param {number} id 
     * @param {InternalTransferReq} internalTransferReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletTransferControllerPreviewTransfer: async (e, t, o, r = {}) => {
      p("walletTransferControllerPreviewTransfer", "walletId", e), p("walletTransferControllerPreviewTransfer", "id", t), p("walletTransferControllerPreviewTransfer", "internalTransferReq", o);
      const n = "/api3/account/{id}/wallet/{walletId}/internal-transfer-preview".replace("{walletId}", encodeURIComponent(String(e))).replace("{id}", encodeURIComponent(String(t))), l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "POST", ...s, ...r }, c = {}, d = {};
      await P(c, a), c["Content-Type"] = "application/json", m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, i.data = S(o, i, a), {
        url: O(l),
        options: i
      };
    }
  };
}, B = function(a) {
  const e = Zn(a);
  return {
    /**
     * Please use the account/{id}/wallet/{walletId}/operation methods
     * @summary Creating a wallet transaction
     * @param {string} walletAlias Wallet alias
     * @param {number} id 
     * @param {PostTransactionReq} postTransactionReq 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async walletAliasControllerCreateTransaction(t, o, r, n) {
      const l = await e.walletAliasControllerCreateTransaction(t, o, r, n);
      return V(l, u, C, a);
    },
    /**
     * Please use the account/{id}/wallet/{walletId}/transfer methods
     * @summary Transferring money from a specified wallet to another
     * @param {string} walletAlias Wallet alias
     * @param {number} id 
     * @param {PostTransferReq} postTransferReq 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async walletAliasControllerCreateTransfer(t, o, r, n) {
      const l = await e.walletAliasControllerCreateTransfer(t, o, r, n);
      return V(l, u, C, a);
    },
    /**
     * Please use the account/id/wallet/:walletId/operation methods
     * @summary Getting wallets operations
     * @param {string} walletAlias Wallet alias
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {number} [operationTypeId] Operation type ID
     * @param {any} [start] Date
     * @param {any} [end] Date
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async walletAliasControllerGetTransaction(t, o, r, n, l, s, i, c) {
      const d = await e.walletAliasControllerGetTransaction(t, o, r, n, l, s, i, c);
      return V(d, u, C, a);
    },
    /**
     * 
     * @summary Get a list of account wallets
     * @param {number} id 
     * @param {any} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletAliasControllerGetWalletsList(t, o, r) {
      const n = await e.walletAliasControllerGetWalletsList(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Returns transaction log
     * @param {number} limit 
     * @param {number} page 
     * @param {ExportOperationParams} exportOperationParams 
     * @param {number} [walletTypeId] 
     * @param {number} [accountId] 
     * @param {object} [filter] Filtering parameters
     * @param {object} [orderBy] Sort options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletBalanceControllerExportWalletOperations(t, o, r, n, l, s, i, c) {
      const d = await e.walletBalanceControllerExportWalletOperations(t, o, r, n, l, s, i, c);
      return V(d, u, C, a);
    },
    /**
     * 
     * @summary Returns export headers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletBalanceControllerGetExportHeaders(t) {
      const o = await e.walletBalanceControllerGetExportHeaders(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Returns wallet balances
     * @param {number} limit 
     * @param {number} page 
     * @param {number} [walletTypeId] 
     * @param {number} [accountId] 
     * @param {object} [filter] Filtering parameters
     * @param {object} [orderBy] Sort options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletBalanceControllerGetWalletOperations(t, o, r, n, l, s, i) {
      const c = await e.walletBalanceControllerGetWalletOperations(t, o, r, n, l, s, i);
      return V(c, u, C, a);
    },
    /**
     * Create only one walletOperation. PaymentRule will be searched by target_wallet_type_id и target_wallet_operation_type_id
     * @summary Creating a wallet operation
     * @param {number} walletId Wallet ID
     * @param {number} id 
     * @param {PostTransactionReq} postTransactionReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletOperationControllerCreateOperations(t, o, r, n) {
      const l = await e.walletOperationControllerCreateOperations(t, o, r, n);
      return V(l, u, C, a);
    },
    /**
     * 
     * @summary Getting wallet operations
     * @param {number} walletId Wallet ID
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {ExportOperationParams} exportOperationParams 
     * @param {number} [operationTypeId] Operation type ID
     * @param {Array<string>} [operationTypeIds] Operation type IDs
     * @param {number} [paymentSystemId] Payment system ID
     * @param {number} [paymentRuleId] Payment rule ID
     * @param {string} [currencyId] Currency
     * @param {any} [start] Date
     * @param {any} [end] Date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletOperationControllerExportOperations(t, o, r, n, l, s, i, c, d, h, f, R, A) {
      const w = await e.walletOperationControllerExportOperations(t, o, r, n, l, s, i, c, d, h, f, R, A);
      return V(w, u, C, a);
    },
    /**
     * 
     * @summary Getting wallet operations
     * @param {number} walletId Wallet ID
     * @param {number} limit 
     * @param {number} page 
     * @param {number} id 
     * @param {number} [operationTypeId] Operation type ID
     * @param {Array<string>} [operationTypeIds] Operation type IDs
     * @param {number} [paymentSystemId] Payment system ID
     * @param {number} [paymentRuleId] Payment rule ID
     * @param {string} [currencyId] Currency
     * @param {any} [start] Date
     * @param {any} [end] Date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletOperationControllerGetOperations(t, o, r, n, l, s, i, c, d, h, f, R) {
      const A = await e.walletOperationControllerGetOperations(t, o, r, n, l, s, i, c, d, h, f, R);
      return V(A, u, C, a);
    },
    /**
     * Transfer to own account. 2 operations (out, in).     PaymentRule wil be searched by source_ and target_ params at one time
     * @summary Create an internal transfer
     * @param {number} walletId Wallet ID
     * @param {number} id 
     * @param {InternalTransferReq} internalTransferReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletTransferControllerCreateInternalTransfer(t, o, r, n) {
      const l = await e.walletTransferControllerCreateInternalTransfer(t, o, r, n);
      return V(l, u, C, a);
    },
    /**
     * Transfer to another account. 2 operations (out, in).      PaymentRule wil be searched by source_ and target_ params at one time
     * @summary Create a transfer
     * @param {number} walletId Wallet ID
     * @param {number} id 
     * @param {PostTransferReq} postTransferReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletTransferControllerCreateTransfer(t, o, r, n) {
      const l = await e.walletTransferControllerCreateTransfer(t, o, r, n);
      return V(l, u, C, a);
    },
    /**
     * Preview transfer to own account.
     * @summary Preview an internal transfer
     * @param {number} walletId Wallet ID
     * @param {number} id 
     * @param {InternalTransferReq} internalTransferReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletTransferControllerPreviewTransfer(t, o, r, n) {
      const l = await e.walletTransferControllerPreviewTransfer(t, o, r, n);
      return V(l, u, C, a);
    }
  };
}, Bs = function(a, e, t) {
  const o = B(a);
  return {
    /**
     * Please use the account/{id}/wallet/{walletId}/operation methods
     * @summary Creating a wallet transaction
     * @param {WalletApiWalletAliasControllerCreateTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    walletAliasControllerCreateTransaction(r, n) {
      return o.walletAliasControllerCreateTransaction(r.walletAlias, r.id, r.postTransactionReq, n).then((l) => l(t, e));
    },
    /**
     * Please use the account/{id}/wallet/{walletId}/transfer methods
     * @summary Transferring money from a specified wallet to another
     * @param {WalletApiWalletAliasControllerCreateTransferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    walletAliasControllerCreateTransfer(r, n) {
      return o.walletAliasControllerCreateTransfer(r.walletAlias, r.id, r.postTransferReq, n).then((l) => l(t, e));
    },
    /**
     * Please use the account/id/wallet/:walletId/operation methods
     * @summary Getting wallets operations
     * @param {WalletApiWalletAliasControllerGetTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    walletAliasControllerGetTransaction(r, n) {
      return o.walletAliasControllerGetTransaction(r.walletAlias, r.limit, r.page, r.id, r.operationTypeId, r.start, r.end, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Get a list of account wallets
     * @param {WalletApiWalletAliasControllerGetWalletsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletAliasControllerGetWalletsList(r, n) {
      return o.walletAliasControllerGetWalletsList(r.id, r.date, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns transaction log
     * @param {WalletApiWalletBalanceControllerExportWalletOperationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletBalanceControllerExportWalletOperations(r, n) {
      return o.walletBalanceControllerExportWalletOperations(r.limit, r.page, r.exportOperationParams, r.walletTypeId, r.accountId, r.filter, r.orderBy, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns export headers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletBalanceControllerGetExportHeaders(r) {
      return o.walletBalanceControllerGetExportHeaders(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Returns wallet balances
     * @param {WalletApiWalletBalanceControllerGetWalletOperationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletBalanceControllerGetWalletOperations(r, n) {
      return o.walletBalanceControllerGetWalletOperations(r.limit, r.page, r.walletTypeId, r.accountId, r.filter, r.orderBy, n).then((l) => l(t, e));
    },
    /**
     * Create only one walletOperation. PaymentRule will be searched by target_wallet_type_id и target_wallet_operation_type_id
     * @summary Creating a wallet operation
     * @param {WalletApiWalletOperationControllerCreateOperationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationControllerCreateOperations(r, n) {
      return o.walletOperationControllerCreateOperations(r.walletId, r.id, r.postTransactionReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting wallet operations
     * @param {WalletApiWalletOperationControllerExportOperationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationControllerExportOperations(r, n) {
      return o.walletOperationControllerExportOperations(r.walletId, r.limit, r.page, r.id, r.exportOperationParams, r.operationTypeId, r.operationTypeIds, r.paymentSystemId, r.paymentRuleId, r.currencyId, r.start, r.end, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting wallet operations
     * @param {WalletApiWalletOperationControllerGetOperationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationControllerGetOperations(r, n) {
      return o.walletOperationControllerGetOperations(r.walletId, r.limit, r.page, r.id, r.operationTypeId, r.operationTypeIds, r.paymentSystemId, r.paymentRuleId, r.currencyId, r.start, r.end, n).then((l) => l(t, e));
    },
    /**
     * Transfer to own account. 2 operations (out, in).     PaymentRule wil be searched by source_ and target_ params at one time
     * @summary Create an internal transfer
     * @param {WalletApiWalletTransferControllerCreateInternalTransferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletTransferControllerCreateInternalTransfer(r, n) {
      return o.walletTransferControllerCreateInternalTransfer(r.walletId, r.id, r.internalTransferReq, n).then((l) => l(t, e));
    },
    /**
     * Transfer to another account. 2 operations (out, in).      PaymentRule wil be searched by source_ and target_ params at one time
     * @summary Create a transfer
     * @param {WalletApiWalletTransferControllerCreateTransferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletTransferControllerCreateTransfer(r, n) {
      return o.walletTransferControllerCreateTransfer(r.walletId, r.id, r.postTransferReq, n).then((l) => l(t, e));
    },
    /**
     * Preview transfer to own account.
     * @summary Preview an internal transfer
     * @param {WalletApiWalletTransferControllerPreviewTransferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletTransferControllerPreviewTransfer(r, n) {
      return o.walletTransferControllerPreviewTransfer(r.walletId, r.id, r.internalTransferReq, n).then((l) => l(t, e));
    }
  };
};
class Yn extends v {
  /**
   * Please use the account/{id}/wallet/{walletId}/operation methods
   * @summary Creating a wallet transaction
   * @param {WalletApiWalletAliasControllerCreateTransactionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  createTransaction(e, t) {
    return B(this.configuration).walletAliasControllerCreateTransaction(e.walletAlias, e.id, e.postTransactionReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Please use the account/{id}/wallet/{walletId}/transfer methods
   * @summary Transferring money from a specified wallet to another
   * @param {WalletApiWalletAliasControllerCreateTransferRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  walletAliasControllerCreateTransfer(e, t) {
    return B(this.configuration).walletAliasControllerCreateTransfer(e.walletAlias, e.id, e.postTransferReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Please use the account/id/wallet/:walletId/operation methods
   * @summary Getting wallets operations
   * @param {WalletApiWalletAliasControllerGetTransactionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  getTransaction(e, t) {
    return B(this.configuration).walletAliasControllerGetTransaction(e.walletAlias, e.limit, e.page, e.id, e.operationTypeId, e.start, e.end, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get a list of account wallets
   * @param {WalletApiWalletAliasControllerGetWalletsListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  getWalletsList(e, t) {
    return B(this.configuration).walletAliasControllerGetWalletsList(e.id, e.date, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns transaction log
   * @param {WalletApiWalletBalanceControllerExportWalletOperationsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  exportWalletOperations(e, t) {
    return B(this.configuration).walletBalanceControllerExportWalletOperations(e.limit, e.page, e.exportOperationParams, e.walletTypeId, e.accountId, e.filter, e.orderBy, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns export headers
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  getExportHeaders(e) {
    return B(this.configuration).walletBalanceControllerGetExportHeaders(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns wallet balances
   * @param {WalletApiWalletBalanceControllerGetWalletOperationsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  getWalletOperations(e, t) {
    return B(this.configuration).walletBalanceControllerGetWalletOperations(e.limit, e.page, e.walletTypeId, e.accountId, e.filter, e.orderBy, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Create only one walletOperation. PaymentRule will be searched by target_wallet_type_id и target_wallet_operation_type_id
   * @summary Creating a wallet operation
   * @param {WalletApiWalletOperationControllerCreateOperationsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  createOperations(e, t) {
    return B(this.configuration).walletOperationControllerCreateOperations(e.walletId, e.id, e.postTransactionReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting wallet operations
   * @param {WalletApiWalletOperationControllerExportOperationsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  exportOperations(e, t) {
    return B(this.configuration).walletOperationControllerExportOperations(e.walletId, e.limit, e.page, e.id, e.exportOperationParams, e.operationTypeId, e.operationTypeIds, e.paymentSystemId, e.paymentRuleId, e.currencyId, e.start, e.end, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting wallet operations
   * @param {WalletApiWalletOperationControllerGetOperationsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  getOperations(e, t) {
    return B(this.configuration).walletOperationControllerGetOperations(e.walletId, e.limit, e.page, e.id, e.operationTypeId, e.operationTypeIds, e.paymentSystemId, e.paymentRuleId, e.currencyId, e.start, e.end, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Transfer to own account. 2 operations (out, in).     PaymentRule wil be searched by source_ and target_ params at one time
   * @summary Create an internal transfer
   * @param {WalletApiWalletTransferControllerCreateInternalTransferRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  createInternalTransfer(e, t) {
    return B(this.configuration).walletTransferControllerCreateInternalTransfer(e.walletId, e.id, e.internalTransferReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Transfer to another account. 2 operations (out, in).      PaymentRule wil be searched by source_ and target_ params at one time
   * @summary Create a transfer
   * @param {WalletApiWalletTransferControllerCreateTransferRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  walletTransferControllerCreateTransfer(e, t) {
    return B(this.configuration).walletTransferControllerCreateTransfer(e.walletId, e.id, e.postTransferReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Preview transfer to own account.
   * @summary Preview an internal transfer
   * @param {WalletApiWalletTransferControllerPreviewTransferRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  previewTransfer(e, t) {
    return B(this.configuration).walletTransferControllerPreviewTransfer(e.walletId, e.id, e.internalTransferReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const qn = function(a) {
  return {
    /**
     * 
     * @summary Returns transaction log
     * @param {number} limit 
     * @param {number} page 
     * @param {ExportOperationParams} exportOperationParams 
     * @param {number} [operationTypeId] Operation type ID
     * @param {Array<string>} [operationTypeIds] Operation type IDs
     * @param {number} [paymentSystemId] Payment system ID
     * @param {number} [paymentRuleId] Payment rule ID
     * @param {string} [currencyId] Currency
     * @param {number} [walletId] Wallet ID
     * @param {any} [start] Date
     * @param {any} [end] Date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationControllerExportWalletOperations: async (e, t, o, r, n, l, s, i, c, d, h, f = {}) => {
      p("walletOperationControllerExportWalletOperations", "limit", e), p("walletOperationControllerExportWalletOperations", "page", t), p("walletOperationControllerExportWalletOperations", "exportOperationParams", o);
      const R = "/api3/wallet-operation/export", A = new URL(R, y);
      let w;
      a && (w = a.baseOptions);
      const T = { method: "POST", ...w, ...f }, g = {}, G = {};
      await P(g, a), e !== void 0 && (G.limit = e), t !== void 0 && (G.page = t), r !== void 0 && (G.operationTypeId = r), n && (G.operationTypeIds = n), l !== void 0 && (G.paymentSystemId = l), s !== void 0 && (G.paymentRuleId = s), i !== void 0 && (G.currencyId = i), c !== void 0 && (G.walletId = c), d !== void 0 && (G.start = d), h !== void 0 && (G.end = h), g["Content-Type"] = "application/json", m(A, G);
      let E = w && w.headers ? w.headers : {};
      return T.headers = { ...g, ...E, ...f.headers }, T.data = S(o, T, a), {
        url: O(A),
        options: T
      };
    },
    /**
     * 
     * @summary Returns export headers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationControllerGetExportHeaders: async (e = {}) => {
      const t = "/api3/wallet-operation/export/headers", o = new URL(t, y);
      let r;
      a && (r = a.baseOptions);
      const n = { method: "GET", ...r, ...e }, l = {}, s = {};
      await P(l, a), m(o, s);
      let i = r && r.headers ? r.headers : {};
      return n.headers = { ...l, ...i, ...e.headers }, {
        url: O(o),
        options: n
      };
    },
    /**
     * 
     * @summary Returns transaction log
     * @param {number} limit 
     * @param {number} page 
     * @param {number} [operationTypeId] Operation type ID
     * @param {Array<string>} [operationTypeIds] Operation type IDs
     * @param {number} [paymentSystemId] Payment system ID
     * @param {number} [paymentRuleId] Payment rule ID
     * @param {string} [currencyId] Currency
     * @param {number} [walletId] Wallet ID
     * @param {any} [start] Date
     * @param {any} [end] Date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationControllerGetWalletOperations: async (e, t, o, r, n, l, s, i, c, d, h = {}) => {
      p("walletOperationControllerGetWalletOperations", "limit", e), p("walletOperationControllerGetWalletOperations", "page", t);
      const f = "/api3/wallet-operation", R = new URL(f, y);
      let A;
      a && (A = a.baseOptions);
      const w = { method: "GET", ...A, ...h }, T = {}, g = {};
      await P(T, a), e !== void 0 && (g.limit = e), t !== void 0 && (g.page = t), o !== void 0 && (g.operationTypeId = o), r && (g.operationTypeIds = r), n !== void 0 && (g.paymentSystemId = n), l !== void 0 && (g.paymentRuleId = l), s !== void 0 && (g.currencyId = s), i !== void 0 && (g.walletId = i), c !== void 0 && (g.start = c), d !== void 0 && (g.end = d), m(R, g);
      let G = A && A.headers ? A.headers : {};
      return w.headers = { ...T, ...G, ...h.headers }, {
        url: O(R),
        options: w
      };
    }
  };
}, We = function(a) {
  const e = qn(a);
  return {
    /**
     * 
     * @summary Returns transaction log
     * @param {number} limit 
     * @param {number} page 
     * @param {ExportOperationParams} exportOperationParams 
     * @param {number} [operationTypeId] Operation type ID
     * @param {Array<string>} [operationTypeIds] Operation type IDs
     * @param {number} [paymentSystemId] Payment system ID
     * @param {number} [paymentRuleId] Payment rule ID
     * @param {string} [currencyId] Currency
     * @param {number} [walletId] Wallet ID
     * @param {any} [start] Date
     * @param {any} [end] Date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletOperationControllerExportWalletOperations(t, o, r, n, l, s, i, c, d, h, f, R) {
      const A = await e.walletOperationControllerExportWalletOperations(t, o, r, n, l, s, i, c, d, h, f, R);
      return V(A, u, C, a);
    },
    /**
     * 
     * @summary Returns export headers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletOperationControllerGetExportHeaders(t) {
      const o = await e.walletOperationControllerGetExportHeaders(t);
      return V(o, u, C, a);
    },
    /**
     * 
     * @summary Returns transaction log
     * @param {number} limit 
     * @param {number} page 
     * @param {number} [operationTypeId] Operation type ID
     * @param {Array<string>} [operationTypeIds] Operation type IDs
     * @param {number} [paymentSystemId] Payment system ID
     * @param {number} [paymentRuleId] Payment rule ID
     * @param {string} [currencyId] Currency
     * @param {number} [walletId] Wallet ID
     * @param {any} [start] Date
     * @param {any} [end] Date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletOperationControllerGetWalletOperations(t, o, r, n, l, s, i, c, d, h, f) {
      const R = await e.walletOperationControllerGetWalletOperations(t, o, r, n, l, s, i, c, d, h, f);
      return V(R, u, C, a);
    }
  };
}, js = function(a, e, t) {
  const o = We(a);
  return {
    /**
     * 
     * @summary Returns transaction log
     * @param {WalletOperationApiWalletOperationControllerExportWalletOperationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationControllerExportWalletOperations(r, n) {
      return o.walletOperationControllerExportWalletOperations(r.limit, r.page, r.exportOperationParams, r.operationTypeId, r.operationTypeIds, r.paymentSystemId, r.paymentRuleId, r.currencyId, r.walletId, r.start, r.end, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Returns export headers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationControllerGetExportHeaders(r) {
      return o.walletOperationControllerGetExportHeaders(r).then((n) => n(t, e));
    },
    /**
     * 
     * @summary Returns transaction log
     * @param {WalletOperationApiWalletOperationControllerGetWalletOperationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationControllerGetWalletOperations(r, n) {
      return o.walletOperationControllerGetWalletOperations(r.limit, r.page, r.operationTypeId, r.operationTypeIds, r.paymentSystemId, r.paymentRuleId, r.currencyId, r.walletId, r.start, r.end, n).then((l) => l(t, e));
    }
  };
};
class el extends v {
  /**
   * 
   * @summary Returns transaction log
   * @param {WalletOperationApiWalletOperationControllerExportWalletOperationsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletOperationApi
   */
  exportWalletOperations(e, t) {
    return We(this.configuration).walletOperationControllerExportWalletOperations(e.limit, e.page, e.exportOperationParams, e.operationTypeId, e.operationTypeIds, e.paymentSystemId, e.paymentRuleId, e.currencyId, e.walletId, e.start, e.end, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns export headers
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletOperationApi
   */
  getExportHeaders(e) {
    return We(this.configuration).walletOperationControllerGetExportHeaders(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Returns transaction log
   * @param {WalletOperationApiWalletOperationControllerGetWalletOperationsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletOperationApi
   */
  getWalletOperations(e, t) {
    return We(this.configuration).walletOperationControllerGetWalletOperations(e.limit, e.page, e.operationTypeId, e.operationTypeIds, e.paymentSystemId, e.paymentRuleId, e.currencyId, e.walletId, e.start, e.end, t).then((o) => o(this.axios, this.basePath));
  }
}
const tl = function(a) {
  return {
    /**
     * 
     * @summary Create a wallet operation type
     * @param {AddWalletOperationTypeReq} addWalletOperationTypeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationTypeControllerCreateWalletOperationType: async (e, t = {}) => {
      p("walletOperationTypeControllerCreateWalletOperationType", "addWalletOperationTypeReq", e);
      const o = "/api3/wallet-operation-type", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Delete a wallet operation type
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationTypeControllerDeleteWalletOperationType: async (e, t = {}) => {
      p("walletOperationTypeControllerDeleteWalletOperationType", "id", e);
      const o = "/api3/wallet-operation-type/{id}".replace("{id}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "DELETE", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Getting a wallet operation types
     * @param {number} limit 
     * @param {number} page 
     * @param {Array<string>} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationTypeControllerGetWalletOperationTypes: async (e, t, o, r = {}) => {
      p("walletOperationTypeControllerGetWalletOperationTypes", "limit", e), p("walletOperationTypeControllerGetWalletOperationTypes", "page", t);
      const n = "/api3/wallet-operation-type", l = new URL(n, y);
      let s;
      a && (s = a.baseOptions);
      const i = { method: "GET", ...s, ...r }, c = {}, d = {};
      await P(c, a), e !== void 0 && (d.limit = e), t !== void 0 && (d.page = t), o && (d.filter = o), m(l, d);
      let h = s && s.headers ? s.headers : {};
      return i.headers = { ...c, ...h, ...r.headers }, {
        url: O(l),
        options: i
      };
    },
    /**
     * 
     * @summary Update a wallet operation type
     * @param {number} id 
     * @param {UpdateWalletOperationTypeReq} updateWalletOperationTypeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationTypeControllerUpdateWalletOperationType: async (e, t, o = {}) => {
      p("walletOperationTypeControllerUpdateWalletOperationType", "id", e), p("walletOperationTypeControllerUpdateWalletOperationType", "updateWalletOperationTypeReq", t);
      const r = "/api3/wallet-operation-type/{id}".replace("{id}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, Re = function(a) {
  const e = tl(a);
  return {
    /**
     * 
     * @summary Create a wallet operation type
     * @param {AddWalletOperationTypeReq} addWalletOperationTypeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletOperationTypeControllerCreateWalletOperationType(t, o) {
      const r = await e.walletOperationTypeControllerCreateWalletOperationType(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Delete a wallet operation type
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletOperationTypeControllerDeleteWalletOperationType(t, o) {
      const r = await e.walletOperationTypeControllerDeleteWalletOperationType(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Getting a wallet operation types
     * @param {number} limit 
     * @param {number} page 
     * @param {Array<string>} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletOperationTypeControllerGetWalletOperationTypes(t, o, r, n) {
      const l = await e.walletOperationTypeControllerGetWalletOperationTypes(t, o, r, n);
      return V(l, u, C, a);
    },
    /**
     * 
     * @summary Update a wallet operation type
     * @param {number} id 
     * @param {UpdateWalletOperationTypeReq} updateWalletOperationTypeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletOperationTypeControllerUpdateWalletOperationType(t, o, r) {
      const n = await e.walletOperationTypeControllerUpdateWalletOperationType(t, o, r);
      return V(n, u, C, a);
    }
  };
}, ks = function(a, e, t) {
  const o = Re(a);
  return {
    /**
     * 
     * @summary Create a wallet operation type
     * @param {WalletOperationTypeApiWalletOperationTypeControllerCreateWalletOperationTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationTypeControllerCreateWalletOperationType(r, n) {
      return o.walletOperationTypeControllerCreateWalletOperationType(r.addWalletOperationTypeReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Delete a wallet operation type
     * @param {WalletOperationTypeApiWalletOperationTypeControllerDeleteWalletOperationTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationTypeControllerDeleteWalletOperationType(r, n) {
      return o.walletOperationTypeControllerDeleteWalletOperationType(r.id, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Getting a wallet operation types
     * @param {WalletOperationTypeApiWalletOperationTypeControllerGetWalletOperationTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationTypeControllerGetWalletOperationTypes(r, n) {
      return o.walletOperationTypeControllerGetWalletOperationTypes(r.limit, r.page, r.filter, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Update a wallet operation type
     * @param {WalletOperationTypeApiWalletOperationTypeControllerUpdateWalletOperationTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletOperationTypeControllerUpdateWalletOperationType(r, n) {
      return o.walletOperationTypeControllerUpdateWalletOperationType(r.id, r.updateWalletOperationTypeReq, n).then((l) => l(t, e));
    }
  };
};
class rl extends v {
  /**
   * 
   * @summary Create a wallet operation type
   * @param {WalletOperationTypeApiWalletOperationTypeControllerCreateWalletOperationTypeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletOperationTypeApi
   */
  createWalletOperationType(e, t) {
    return Re(this.configuration).walletOperationTypeControllerCreateWalletOperationType(e.addWalletOperationTypeReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Delete a wallet operation type
   * @param {WalletOperationTypeApiWalletOperationTypeControllerDeleteWalletOperationTypeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletOperationTypeApi
   */
  deleteWalletOperationType(e, t) {
    return Re(this.configuration).walletOperationTypeControllerDeleteWalletOperationType(e.id, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Getting a wallet operation types
   * @param {WalletOperationTypeApiWalletOperationTypeControllerGetWalletOperationTypesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletOperationTypeApi
   */
  getWalletOperationTypes(e, t) {
    return Re(this.configuration).walletOperationTypeControllerGetWalletOperationTypes(e.limit, e.page, e.filter, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update a wallet operation type
   * @param {WalletOperationTypeApiWalletOperationTypeControllerUpdateWalletOperationTypeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletOperationTypeApi
   */
  updateWalletOperationType(e, t) {
    return Re(this.configuration).walletOperationTypeControllerUpdateWalletOperationType(e.id, e.updateWalletOperationTypeReq, t).then((o) => o(this.axios, this.basePath));
  }
}
const ol = function(a) {
  return {
    /**
     * 
     * @summary Create wallet
     * @param {SetWalletTypeReq} setWalletTypeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletTypeControllerCreateWallet: async (e, t = {}) => {
      p("walletTypeControllerCreateWallet", "setWalletTypeReq", e);
      const o = "/api3/wallet-type", r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "POST", ...n, ...t }, s = {}, i = {};
      await P(s, a), s["Content-Type"] = "application/json", m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, l.data = S(e, l, a), {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Delete wallet
     * @param {any} walletId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletTypeControllerDeleteWallet: async (e, t = {}) => {
      p("walletTypeControllerDeleteWallet", "walletId", e);
      const o = "/api3/wallet-type/{walletId}".replace("{walletId}", encodeURIComponent(String(e))), r = new URL(o, y);
      let n;
      a && (n = a.baseOptions);
      const l = { method: "DELETE", ...n, ...t }, s = {}, i = {};
      await P(s, a), m(r, i);
      let c = n && n.headers ? n.headers : {};
      return l.headers = { ...s, ...c, ...t.headers }, {
        url: O(r),
        options: l
      };
    },
    /**
     * 
     * @summary Get a list of wallet types
     * @param {boolean} [includeInactive] 
     * @param {boolean} [includeRates] Include currencies and rates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletTypeControllerGetWallets: async (e, t, o = {}) => {
      const r = "/api3/wallet-type", n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "GET", ...l, ...o }, i = {}, c = {};
      await P(i, a), e !== void 0 && (c.includeInactive = e), t !== void 0 && (c.includeRates = t), m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, {
        url: O(n),
        options: s
      };
    },
    /**
     * 
     * @summary Update wallet
     * @param {any} walletId 
     * @param {SetWalletTypeReq} setWalletTypeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletTypeControllerUpdateWallet: async (e, t, o = {}) => {
      p("walletTypeControllerUpdateWallet", "walletId", e), p("walletTypeControllerUpdateWallet", "setWalletTypeReq", t);
      const r = "/api3/wallet-type/{walletId}".replace("{walletId}", encodeURIComponent(String(e))), n = new URL(r, y);
      let l;
      a && (l = a.baseOptions);
      const s = { method: "PUT", ...l, ...o }, i = {}, c = {};
      await P(i, a), i["Content-Type"] = "application/json", m(n, c);
      let d = l && l.headers ? l.headers : {};
      return s.headers = { ...i, ...d, ...o.headers }, s.data = S(t, s, a), {
        url: O(n),
        options: s
      };
    }
  };
}, be = function(a) {
  const e = ol(a);
  return {
    /**
     * 
     * @summary Create wallet
     * @param {SetWalletTypeReq} setWalletTypeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletTypeControllerCreateWallet(t, o) {
      const r = await e.walletTypeControllerCreateWallet(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Delete wallet
     * @param {any} walletId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletTypeControllerDeleteWallet(t, o) {
      const r = await e.walletTypeControllerDeleteWallet(t, o);
      return V(r, u, C, a);
    },
    /**
     * 
     * @summary Get a list of wallet types
     * @param {boolean} [includeInactive] 
     * @param {boolean} [includeRates] Include currencies and rates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletTypeControllerGetWallets(t, o, r) {
      const n = await e.walletTypeControllerGetWallets(t, o, r);
      return V(n, u, C, a);
    },
    /**
     * 
     * @summary Update wallet
     * @param {any} walletId 
     * @param {SetWalletTypeReq} setWalletTypeReq 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async walletTypeControllerUpdateWallet(t, o, r) {
      const n = await e.walletTypeControllerUpdateWallet(t, o, r);
      return V(n, u, C, a);
    }
  };
}, Hs = function(a, e, t) {
  const o = be(a);
  return {
    /**
     * 
     * @summary Create wallet
     * @param {WalletTypeApiWalletTypeControllerCreateWalletRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletTypeControllerCreateWallet(r, n) {
      return o.walletTypeControllerCreateWallet(r.setWalletTypeReq, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Delete wallet
     * @param {WalletTypeApiWalletTypeControllerDeleteWalletRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletTypeControllerDeleteWallet(r, n) {
      return o.walletTypeControllerDeleteWallet(r.walletId, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Get a list of wallet types
     * @param {WalletTypeApiWalletTypeControllerGetWalletsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletTypeControllerGetWallets(r = {}, n) {
      return o.walletTypeControllerGetWallets(r.includeInactive, r.includeRates, n).then((l) => l(t, e));
    },
    /**
     * 
     * @summary Update wallet
     * @param {WalletTypeApiWalletTypeControllerUpdateWalletRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletTypeControllerUpdateWallet(r, n) {
      return o.walletTypeControllerUpdateWallet(r.walletId, r.setWalletTypeReq, n).then((l) => l(t, e));
    }
  };
};
class al extends v {
  /**
   * 
   * @summary Create wallet
   * @param {WalletTypeApiWalletTypeControllerCreateWalletRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletTypeApi
   */
  createWallet(e, t) {
    return be(this.configuration).walletTypeControllerCreateWallet(e.setWalletTypeReq, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Delete wallet
   * @param {WalletTypeApiWalletTypeControllerDeleteWalletRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletTypeApi
   */
  deleteWallet(e, t) {
    return be(this.configuration).walletTypeControllerDeleteWallet(e.walletId, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get a list of wallet types
   * @param {WalletTypeApiWalletTypeControllerGetWalletsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletTypeApi
   */
  getWallets(e = {}, t) {
    return be(this.configuration).walletTypeControllerGetWallets(e.includeInactive, e.includeRates, t).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Update wallet
   * @param {WalletTypeApiWalletTypeControllerUpdateWalletRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletTypeApi
   */
  updateWallet(e, t) {
    return be(this.configuration).walletTypeControllerUpdateWallet(e.walletId, e.setWalletTypeReq, t).then((o) => o(this.axios, this.basePath));
  }
}
class nl {
  constructor(e = {}) {
    /**
     * parameter for apiKey security
     * @param name security name
     * @memberof Configuration
     */
    $(this, "apiKey");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    $(this, "username");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    $(this, "password");
    /**
     * parameter for oauth2 security
     * @param name security name
     * @param scopes oauth2 scope
     * @memberof Configuration
     */
    $(this, "accessToken");
    /**
     * override base path
     *
     * @type {string}
     * @memberof Configuration
     */
    $(this, "basePath");
    /**
     * base options for axios calls
     *
     * @type {any}
     * @memberof Configuration
     */
    $(this, "baseOptions");
    /**
     * The FormData constructor that will be used to create multipart form data
     * requests. You can inject this here so that execution environments that
     * do not support the FormData class can still run the generated client.
     *
     * @type {new () => FormData}
     */
    $(this, "formDataCtor");
    this.apiKey = e.apiKey, this.username = e.username, this.password = e.password, this.accessToken = e.accessToken, this.basePath = e.basePath, this.baseOptions = e.baseOptions, this.formDataCtor = e.formDataCtor;
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(e) {
    const t = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return e !== null && (t.test(e) || e.toLowerCase() === "application/json-patch+json");
  }
}
u.interceptors.response.use(
  (a) => a,
  (a) => (a.response.status === 401 && ve.logout(!0), Promise.reject(a))
);
let Se = "";
function ll(a) {
  console.log("api-service: set override:", a), Se = a || "";
}
function sl() {
  var t, o;
  if (Se === "undefined" && (Se = ""), Se)
    return Se;
  if (typeof window > "u")
    return ve.getApiDevPath();
  const a = (t = window == null ? void 0 : window.location) == null ? void 0 : t.hostname, e = (o = window == null ? void 0 : window.location) == null ? void 0 : o.protocol;
  return a === "localhost" ? ve.getApiDevPath() : `${e}//${a}`;
}
function il() {
  const a = ve.getAccessToken(), e = ve.getLocale();
  return new nl({
    accessToken: a,
    basePath: sl(),
    baseOptions: {
      headers: {
        Locale: e
      }
    }
  });
}
function U(a) {
  return new Proxy(a, {
    get(e, t) {
      const o = e, r = o[t];
      return r instanceof Function && (o.configuration = il()), r;
    }
  });
}
const Qs = (a, e = "Unexpected Error") => {
  var l, s, i;
  const t = [], o = (s = (l = a == null ? void 0 : a.response) == null ? void 0 : l.data) == null ? void 0 : s.error;
  if ((o == null ? void 0 : o.type) === "validation") {
    const c = o.fields || {};
    Object.keys(c).forEach((d) => {
      const h = c[d];
      if (typeof h == "string") {
        t.push(h);
        return;
      }
      if (Array.isArray(h)) {
        c[d].forEach((f) => {
          t.push(f);
        });
        return;
      }
      t.push(`${d}: ${JSON.stringify(h)}`);
    });
  }
  const r = (i = o == null ? void 0 : o.data) == null ? void 0 : i.reason;
  r && t.push(r);
  const n = (o == null ? void 0 : o.description) || (a == null ? void 0 : a.message);
  return t.push(n), t.length > 0 ? t.join(", ") : e;
}, Ws = () => U(new Jo()), $s = () => U(new Zo()), Ns = () => U(new qo()), _s = () => U(new ta()), Ms = () => U(new oa()), zs = () => U(new na()), Ks = () => U(new sa()), Js = () => U(new ca()), Xs = () => U(new pa()), Zs = () => U(new ua()), Ys = () => U(new ya()), qs = () => U(new Oa()), fr = () => U(new Pa()), ei = () => U(new wa()), ti = () => U(new Ra()), ri = () => U(new Sa()), oi = () => U(new Ga()), ai = () => U(new Ua()), ni = () => U(new xa()), li = () => U(new Ia()), si = () => U(new La()), ii = () => U(new Ba()), ci = () => U(new ka()), di = () => U(new Qa()), pi = () => U(new $a()), hi = () => U(new _a()), ui = () => U(new za()), Ci = () => U(new Ja()), yi = () => U(new Za()), mi = () => U(new qa()), Oi = () => U(new tn()), Vi = () => U(new on()), Pi = () => U(new nn()), fi = () => U(new sn()), wi = () => U(new dn()), Ai = () => U(new hn()), Ri = () => U(new Cn()), bi = () => U(new mn()), Si = () => U(new Vn()), Ti = () => U(new fn()), Gi = () => U(new An()), vi = () => U(new bn()), Ui = () => U(new Tn()), gi = () => U(new vn()), xi = () => U(new gn()), Ei = () => U(new En()), Ii = () => U(new Fn()), Fi = () => U(new Dn()), Li = () => U(new jn()), Di = () => U(new Hn()), Bi = () => U(new Wn()), ji = () => U(new Nn()), ki = () => U(new Mn()), Hi = () => U(new Kn()), Qi = () => U(new Xn()), Wi = () => U(new Yn()), $i = () => U(new el()), Ni = () => U(new rl()), _i = () => U(new al());
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var wr = dl, jt = pl, cl = Object.prototype.toString, Ie = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
function dl(a, e) {
  if (typeof a != "string")
    throw new TypeError("argument str must be a string");
  for (var t = {}, o = e || {}, r = o.decode || hl, n = 0; n < a.length; ) {
    var l = a.indexOf("=", n);
    if (l === -1)
      break;
    var s = a.indexOf(";", n);
    if (s === -1)
      s = a.length;
    else if (s < l) {
      n = a.lastIndexOf(";", l - 1) + 1;
      continue;
    }
    var i = a.slice(n, l).trim();
    if (t[i] === void 0) {
      var c = a.slice(l + 1, s).trim();
      c.charCodeAt(0) === 34 && (c = c.slice(1, -1)), t[i] = yl(c, r);
    }
    n = s + 1;
  }
  return t;
}
function pl(a, e, t) {
  var o = t || {}, r = o.encode || ul;
  if (typeof r != "function")
    throw new TypeError("option encode is invalid");
  if (!Ie.test(a))
    throw new TypeError("argument name is invalid");
  var n = r(e);
  if (n && !Ie.test(n))
    throw new TypeError("argument val is invalid");
  var l = a + "=" + n;
  if (o.maxAge != null) {
    var s = o.maxAge - 0;
    if (isNaN(s) || !isFinite(s))
      throw new TypeError("option maxAge is invalid");
    l += "; Max-Age=" + Math.floor(s);
  }
  if (o.domain) {
    if (!Ie.test(o.domain))
      throw new TypeError("option domain is invalid");
    l += "; Domain=" + o.domain;
  }
  if (o.path) {
    if (!Ie.test(o.path))
      throw new TypeError("option path is invalid");
    l += "; Path=" + o.path;
  }
  if (o.expires) {
    var i = o.expires;
    if (!Cl(i) || isNaN(i.valueOf()))
      throw new TypeError("option expires is invalid");
    l += "; Expires=" + i.toUTCString();
  }
  if (o.httpOnly && (l += "; HttpOnly"), o.secure && (l += "; Secure"), o.partitioned && (l += "; Partitioned"), o.priority) {
    var c = typeof o.priority == "string" ? o.priority.toLowerCase() : o.priority;
    switch (c) {
      case "low":
        l += "; Priority=Low";
        break;
      case "medium":
        l += "; Priority=Medium";
        break;
      case "high":
        l += "; Priority=High";
        break;
      default:
        throw new TypeError("option priority is invalid");
    }
  }
  if (o.sameSite) {
    var d = typeof o.sameSite == "string" ? o.sameSite.toLowerCase() : o.sameSite;
    switch (d) {
      case !0:
        l += "; SameSite=Strict";
        break;
      case "lax":
        l += "; SameSite=Lax";
        break;
      case "strict":
        l += "; SameSite=Strict";
        break;
      case "none":
        l += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return l;
}
function hl(a) {
  return a.indexOf("%") !== -1 ? decodeURIComponent(a) : a;
}
function ul(a) {
  return encodeURIComponent(a);
}
function Cl(a) {
  return cl.call(a) === "[object Date]" || a instanceof Date;
}
function yl(a, e) {
  try {
    return e(a);
  } catch {
    return a;
  }
}
function ml() {
  const a = typeof global > "u" ? void 0 : global.TEST_HAS_DOCUMENT_COOKIE;
  return typeof a == "boolean" ? a : typeof document == "object" && typeof document.cookie == "string";
}
function Ol(a) {
  return typeof a == "string" ? wr(a) : typeof a == "object" && a !== null ? a : {};
}
function et(a, e = {}) {
  const t = Vl(a);
  if (!e.doNotParse)
    try {
      return JSON.parse(t);
    } catch {
    }
  return a;
}
function Vl(a) {
  return a && a[0] === "j" && a[1] === ":" ? a.substr(2) : a;
}
class Pl {
  constructor(e, t = {}) {
    this.changeListeners = [], this.HAS_DOCUMENT_COOKIE = !1, this.update = () => {
      if (!this.HAS_DOCUMENT_COOKIE)
        return;
      const r = this.cookies;
      this.cookies = wr(document.cookie), this._checkChanges(r);
    };
    const o = typeof document > "u" ? "" : document.cookie;
    this.cookies = Ol(e || o), this.defaultSetOptions = t, this.HAS_DOCUMENT_COOKIE = ml();
  }
  _emitChange(e) {
    for (let t = 0; t < this.changeListeners.length; ++t)
      this.changeListeners[t](e);
  }
  _checkChanges(e) {
    new Set(Object.keys(e).concat(Object.keys(this.cookies))).forEach((o) => {
      e[o] !== this.cookies[o] && this._emitChange({
        name: o,
        value: et(this.cookies[o])
      });
    });
  }
  _startPolling() {
    this.pollingInterval = setInterval(this.update, 300);
  }
  _stopPolling() {
    this.pollingInterval && clearInterval(this.pollingInterval);
  }
  get(e, t = {}) {
    return t.doNotUpdate || this.update(), et(this.cookies[e], t);
  }
  getAll(e = {}) {
    e.doNotUpdate || this.update();
    const t = {};
    for (let o in this.cookies)
      t[o] = et(this.cookies[o], e);
    return t;
  }
  set(e, t, o) {
    o ? o = Object.assign(Object.assign({}, this.defaultSetOptions), o) : o = this.defaultSetOptions;
    const r = typeof t == "string" ? t : JSON.stringify(t);
    this.cookies = Object.assign(Object.assign({}, this.cookies), { [e]: r }), this.HAS_DOCUMENT_COOKIE && (document.cookie = jt(e, r, o)), this._emitChange({ name: e, value: t, options: o });
  }
  remove(e, t) {
    const o = t = Object.assign(Object.assign(Object.assign({}, this.defaultSetOptions), t), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 });
    this.cookies = Object.assign({}, this.cookies), delete this.cookies[e], this.HAS_DOCUMENT_COOKIE && (document.cookie = jt(e, "", o)), this._emitChange({ name: e, value: void 0, options: t });
  }
  addChangeListener(e) {
    this.changeListeners.push(e), this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 1 && (typeof window == "object" && "cookieStore" in window ? window.cookieStore.addEventListener("change", this.update) : this._startPolling());
  }
  removeChangeListener(e) {
    const t = this.changeListeners.indexOf(e);
    t >= 0 && this.changeListeners.splice(t, 1), this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 0 && (typeof window == "object" && "cookieStore" in window ? window.cookieStore.removeEventListener("change", this.update) : this._stopPolling());
  }
}
const Y = new Pl();
let Ee = "UI2_ATK", Je = "UI2_RTK";
const Ge = "myAESPass", fl = 12e4, wl = 1e4;
let X = null, le = {
  getLocale: () => "en",
  getApiDevPath: () => "https://staging.mlmsoft.com",
  onTokenRefresh: (a) => {
  },
  onAfterLogout: (a) => {
  }
};
const I = Ur({
  loading: !0,
  accountId: void 0,
  userId: void 0,
  roles: [],
  accessToken: "",
  refreshToken: "",
  apiPathOverride: ""
}), bt = {
  loading: () => I.loading,
  accountId: () => I.accountId,
  userId: () => I.userId,
  roles: () => I.roles,
  init: Sl,
  logout: Rr,
  login: Tl,
  getLocale: () => le.getLocale(),
  getApiDevPath: () => le.getApiDevPath(),
  accessTokenExists: Rl,
  setTokens: St,
  getStoredSSOKey: Al,
  getAccessToken: Gl,
  setApiPathOverride: Ar,
  getApiPathOverride: bl,
  setTokenCookiesPrefix: (a) => {
    Ee = a + "_ATK", Je = a + "_RTK";
  }
}, ve = bt;
function Al() {
  return window.localStorage.getItem(Ge);
}
function Rl() {
  return !!Z(I.accessToken || "");
}
function Ar(a) {
  I.apiPathOverride = a, window.localStorage.setItem("apiPathOverride", a || ""), ll(a);
}
function bl() {
  return I.apiPathOverride;
}
async function Sl(a = {}) {
  le = { ...le, ...a }, Ar(window.localStorage.getItem("apiPathOverride") || "");
  const e = Y.get(Ee), t = Y.get(Je);
  I.accessToken = e || "", I.refreshToken = t || "", e && t ? console.log("auth: accessToken and refreshToken found in cookie") : t && console.log("auth: only refreshToken found in cookie");
  const r = new URL(window.location.href).hash;
  if (r) {
    const { authToken: l, refreshToken: s, remoteSsoKey: i } = vl(r);
    history.replaceState({}, document.title, window.location.href.split("#")[0]), l && s && (console.log("auth: authToken and refreshToken found in url"), St(l, s), i && window.localStorage.setItem(Ge, i));
  }
  const n = await br();
  I.loading = !1, !n && Rr(!0);
}
function Rr(a = !1) {
  I.accessToken = "", I.refreshToken = "", Y.remove(Ee, { path: "/" }), Y.remove(Je, { path: "/" }), window.localStorage.removeItem(Ge), I.accountId = void 0, I.userId = void 0, I.roles = [], le.onAfterLogout(a);
}
function St(a, e) {
  const t = Z(a), o = Z(e);
  if (!t || !o)
    throw new Error("invalid token(s)");
  const r = new Date(Ue(t)), n = new Date(Ue(o));
  Y.set(Ee, a, { path: "/", expires: r }), Y.set(Je, e, { path: "/", expires: n }), I.accessToken = a, I.refreshToken = e, console.log("auth: new_token_set=", t, "expires=", r.toLocaleString()), le.onTokenRefresh(a);
}
async function Tl(a, e, t = !0) {
  const r = await fr().login({
    loginReq: {
      login: a,
      password: e,
      networkAccount: t
    }
  });
  if (r.status === 200) {
    const { accessToken: n, refreshToken: l } = r.data.payload;
    return r.data.payload.remoteAuthKey ? window.localStorage.setItem(Ge, r.data.payload.remoteAuthKey) : window.localStorage.removeItem(Ge), St(n, l), await br();
  }
  return !1;
}
function Gl() {
  return I.accessToken;
}
async function br() {
  const a = I.accessToken, e = I.refreshToken;
  if (!a && !e)
    return !1;
  if (a) {
    const o = Z(a);
    if (o && kt(o))
      return Ot(o), I.accountId = o.accountId ? parseInt(o.accountId) : void 0, I.userId = o.userId ? Number(o.userId) : void 0, I.roles = o.roles, console.log("token=", o), !0;
  }
  if (!e)
    return !1;
  const t = Z(e);
  if (!t || !kt(t))
    return !1;
  if (await Sr()) {
    const o = Z(I.accessToken);
    if (o)
      return Ot(o), !0;
  }
  return !1;
}
function vl(a) {
  const e = a.match(/#auth\((.+?)\)/);
  if (e) {
    const n = (e ? e[1].split(",") : []).map((c) => c.trim()), l = e ? n[0] : null, s = e ? n[1] : null, i = e ? n[2] : null;
    return { authToken: l, refreshToken: s, remoteSsoKey: i };
  }
  const t = a.match(/#([.a-zA-Z0-9]+);([.a-zA-Z0-9]+);([.a-zA-Z0-9]+);([.a-zA-Z0-9]+)/);
  if (!t)
    return {};
  const o = t[3], r = t[4];
  return { authToken: o, refreshToken: r };
}
async function Ul() {
  if (console.log("auth: running token refresh task"), X && (clearTimeout(X), X = null), await Sr()) {
    const a = Y.get(Ee), e = Z(a);
    e && Ot(e);
    return;
  }
  console.error("auth: token refresh failed, logging out."), bt.logout(!0);
}
function Ot(a) {
  X && (clearTimeout(X), X = null);
  const e = Math.max(Ue(a) - Date.now() - fl, 0);
  return X = setTimeout(Ul, e), !0;
}
async function Sr() {
  const a = fr();
  try {
    const e = await a.refreshToken({
      refreshReq: {
        token: I.refreshToken
      }
    });
    if (e.status === 200) {
      const { accessToken: t, refreshToken: o } = e.data.payload;
      return bt.setTokens(t, o), !0;
    }
    return !1;
  } catch {
    return !1;
  }
}
function kt(a) {
  return Ue(a) > Date.now() + wl;
}
function Ue(a) {
  return a.exp * 1e3;
}
function Z(a) {
  const e = gl(a);
  return !e || Ue(e) < Date.now() ? null : e;
}
function gl(a) {
  try {
    const t = a.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"), o = decodeURIComponent(
      atob(t).split("").map((r) => `%${`00${r.charCodeAt(0).toString(16)}`.slice(-2)}`).join("")
    );
    return JSON.parse(o);
  } catch {
    return null;
  }
}
export {
  ki as $,
  hi as A,
  ui as B,
  Ci as C,
  yi as D,
  mi as E,
  Oi as F,
  Vi as G,
  Pi as H,
  fi as I,
  wi as J,
  Ai as K,
  Ri as L,
  bi as M,
  Si as N,
  Ti as O,
  Gi as P,
  vi as Q,
  Ui as R,
  gi as S,
  xi as T,
  Ei as U,
  Ii as V,
  Fi as W,
  Li as X,
  Di as Y,
  Bi as Z,
  ji as _,
  ve as a,
  it as a$,
  Hi as a0,
  Qi as a1,
  Wi as a2,
  $i as a3,
  Ni as a4,
  _i as a5,
  ll as a6,
  sl as a7,
  il as a8,
  U as a9,
  Ql as aA,
  na as aB,
  la as aC,
  ee as aD,
  Wl as aE,
  sa as aF,
  ia as aG,
  te as aH,
  $l as aI,
  ca as aJ,
  da as aK,
  ir as aL,
  Nl as aM,
  pa as aN,
  ha as aO,
  cr as aP,
  _l as aQ,
  ua as aR,
  Ca as aS,
  dr as aT,
  Ml as aU,
  ya as aV,
  ma as aW,
  st as aX,
  zl as aY,
  Oa as aZ,
  Va as a_,
  Qs as aa,
  Il as ab,
  Fl as ac,
  Ll as ad,
  Ko as ae,
  F as af,
  Dl as ag,
  Jo as ah,
  Xo as ai,
  lt as aj,
  Bl as ak,
  Zo as al,
  Yo as am,
  sr as an,
  jl as ao,
  qo as ap,
  ea as aq,
  je as ar,
  kl as as,
  ta as at,
  ra as au,
  ce as av,
  Hl as aw,
  oa as ax,
  aa as ay,
  H as az,
  $s as b,
  Oe as b$,
  Kl as b0,
  Pa as b1,
  fa as b2,
  de as b3,
  Jl as b4,
  wa as b5,
  Aa as b6,
  pr as b7,
  Xl as b8,
  Ra as b9,
  os as bA,
  Ba as bB,
  ja as bC,
  ue as bD,
  as as bE,
  ka as bF,
  Ha as bG,
  Ce as bH,
  ns as bI,
  Qa as bJ,
  Wa as bK,
  ye as bL,
  ls as bM,
  $a as bN,
  Na as bO,
  ct as bP,
  ss as bQ,
  _a as bR,
  Ma as bS,
  Cr as bT,
  is as bU,
  za as bV,
  Ka as bW,
  me as bX,
  cs as bY,
  Ja as bZ,
  Xa as b_,
  ba,
  hr as bb,
  Zl as bc,
  Sa as bd,
  Ta as be,
  ke as bf,
  Yl as bg,
  Ga as bh,
  va as bi,
  K as bj,
  ql as bk,
  Ua as bl,
  ga as bm,
  pe as bn,
  es as bo,
  xa as bp,
  Ea as bq,
  ur as br,
  ts as bs,
  Ia as bt,
  Fa as bu,
  re as bv,
  rs as bw,
  La as bx,
  Da as by,
  he as bz,
  Ns as c,
  J as c$,
  ds as c0,
  Za as c1,
  Ya as c2,
  dt as c3,
  ps as c4,
  qa as c5,
  en as c6,
  yr as c7,
  hs as c8,
  tn as c9,
  Ps as cA,
  mn as cB,
  On as cC,
  He as cD,
  fs as cE,
  Vn as cF,
  Pn as cG,
  Vr as cH,
  ws as cI,
  fn as cJ,
  wn as cK,
  ht as cL,
  As as cM,
  An as cN,
  Rn as cO,
  Qe as cP,
  Rs as cQ,
  bn as cR,
  Sn as cS,
  D as cT,
  bs as cU,
  Tn as cV,
  Gn as cW,
  fe as cX,
  Ss as cY,
  vn as cZ,
  Un as c_,
  rn as ca,
  mr as cb,
  us as cc,
  on as cd,
  an as ce,
  Or as cf,
  Cs as cg,
  nn as ch,
  ln as ci,
  oe as cj,
  ys as ck,
  sn as cl,
  cn as cm,
  M as cn,
  ms as co,
  dn as cp,
  pn as cq,
  Ve as cr,
  Os as cs,
  hn as ct,
  un as cu,
  Pe as cv,
  Vs as cw,
  Cn as cx,
  yn as cy,
  pt as cz,
  _s as d,
  Ts as d0,
  gn as d1,
  xn as d2,
  z as d3,
  Gs as d4,
  En as d5,
  In as d6,
  ut as d7,
  vs as d8,
  Fn as d9,
  Pr as dA,
  Ls as dB,
  Kn as dC,
  Jn as dD,
  mt as dE,
  Ds as dF,
  Xn as dG,
  Zn as dH,
  B as dI,
  Bs as dJ,
  Yn as dK,
  qn as dL,
  We as dM,
  js as dN,
  el as dO,
  tl as dP,
  Re as dQ,
  ks as dR,
  rl as dS,
  ol as dT,
  be as dU,
  Hs as dV,
  al as dW,
  nl as dX,
  Ln as da,
  Ct as db,
  Us as dc,
  Dn as dd,
  Bn as de,
  ae as df,
  gs as dg,
  jn as dh,
  kn as di,
  we as dj,
  xs as dk,
  Hn as dl,
  Qn as dm,
  j as dn,
  Es as dp,
  Wn as dq,
  $n as dr,
  Ae as ds,
  Is as dt,
  Nn as du,
  _n as dv,
  yt as dw,
  Fs as dx,
  Mn as dy,
  zn as dz,
  Ms as e,
  zs as f,
  Ks as g,
  Js as h,
  Xs as i,
  Zs as j,
  Ys as k,
  qs as l,
  fr as m,
  ei as n,
  ti as o,
  ri as p,
  oi as q,
  ai as r,
  ni as s,
  li as t,
  Ws as u,
  si as v,
  ii as w,
  ci as x,
  di as y,
  pi as z
};
